export const BravuraFont = {
  glyphs: {
    bracketTop: {
      x_min: 0,
      x_max: 469,
      y_min: 0,
      y_max: 295,
      ha: 295,
      o: 'm 0 168 l 0 0 l 180 0 b 674 390 410 43 616 150 b 675 405 675 396 675 400 b 664 425 675 416 671 422 b 628 405 651 425 635 415 b 157 179 613 389 432 199 l 12 179 b 0 168 3 179 0 177 z',
    },
    bracketBottom: {
      x_min: 0,
      x_max: 469,
      y_min: -295,
      y_max: 0,
      ha: 295,
      o: 'm 0 0 l 0 -168 b 12 -179 0 -177 3 -179 l 157 -179 b 628 -405 432 -199 613 -389 b 664 -425 635 -415 651 -425 b 675 -405 671 -422 675 -416 b 674 -390 675 -400 675 -396 b 180 0 616 -150 410 -43 z',
    },
    barlineTick: {
      x_min: 0,
      x_max: 36,
      y_min: 868,
      y_max: 1120,
      ha: 252,
      o: 'm 52 1250 l 52 1613 l 0 1613 l 0 1250 z',
    },
    breathMarkTick: {
      x_min: 0,
      x_max: 500,
      y_min: 0,
      y_max: 502,
      ha: 502,
      o: 'm 0 374 b 9 334 0 367 0 343 b 179 19 40 312 164 121 b 192 0 179 3 186 0 b 210 19 197 0 207 6 b 698 701 245 197 507 658 b 720 714 714 704 720 711 b 698 723 720 720 711 723 b 197 186 455 714 210 202 b 186 176 194 179 189 176 b 176 186 179 176 176 186 b 9 367 143 266 27 359 b 0 374 6 372 3 374 z',
    },
    segno: {
      x_min: 4,
      x_max: 550,
      y_min: -27,
      y_max: 759,
      ha: 786,
      o: 'm 29 687 b 295 449 75 582 284 454 b 304 438 301 446 304 444 b 295 415 304 432 301 425 b 78 22 285 395 78 22 b 73 3 75 16 73 9 b 114 -39 73 -20 91 -39 b 150 -17 128 -39 143 -30 b 377 395 150 -17 373 386 b 395 402 377 393 389 402 b 704 176 416 397 704 312 b 624 75 704 120 670 82 b 613 73 621 75 616 73 b 562 138 586 73 562 94 l 562 154 b 485 249 562 209 526 249 b 468 246 480 249 474 248 b 366 153 415 233 366 210 b 540 -12 366 65 455 -12 b 600 -1 559 -12 579 -9 b 792 251 716 37 792 131 b 789 292 792 264 791 278 b 523 588 768 451 540 579 b 498 611 505 598 498 603 b 501 619 498 613 500 616 b 732 1032 508 631 732 1032 b 737 1053 736 1040 737 1045 b 697 1093 737 1076 719 1093 b 661 1073 683 1093 668 1086 b 423 647 661 1073 432 660 b 410 635 419 639 416 635 b 396 639 406 635 402 636 b 128 792 383 644 166 727 b 108 868 120 808 108 838 b 186 958 108 907 125 948 l 194 958 b 217 939 203 958 213 955 l 220 929 b 325 805 230 890 252 805 b 425 901 384 805 425 840 b 413 969 425 923 420 946 b 220 1060 390 1035 294 1060 b 6 793 120 1060 6 936 b 29 687 6 759 13 723 z m 680 589 b 762 671 726 589 762 626 b 680 753 762 717 726 753 b 598 671 635 753 598 717 b 680 589 598 626 635 589 z m 120 298 b 202 380 166 298 202 334 b 120 462 202 425 166 462 b 37 380 75 462 37 425 b 120 298 37 334 75 298 z',
    },
    coda: {
      x_min: -4,
      x_max: 955,
      y_min: -158,
      y_max: 898,
      ha: 1056,
      o: 'm -6 541 b 20 507 -6 523 0 507 l 210 507 b 660 0 226 238 426 19 l 660 -202 b 694 -228 660 -222 675 -228 b 729 -202 713 -228 729 -222 l 729 0 b 1178 507 962 19 1164 238 l 1349 507 b 1375 541 1369 507 1375 523 b 1349 576 1375 560 1369 576 l 1178 576 b 729 1083 1164 847 962 1064 l 729 1269 b 694 1293 729 1287 713 1293 b 660 1269 675 1293 660 1287 l 660 1083 b 210 576 426 1064 226 848 l 20 576 b -6 541 0 576 -6 560 z m 940 576 l 729 576 l 729 1002 b 940 576 930 985 940 809 z m 729 507 l 940 507 b 729 69 936 287 909 91 z m 455 576 b 660 1002 455 809 455 985 l 660 576 z m 660 507 l 660 69 b 455 507 474 91 456 285 z',
    },
    gClef: {
      x_min: 0,
      x_max: 671,
      y_min: -658,
      y_max: 1098,
      ha: 1756,
      o: 'm 524 -363 b 624 -354 557 -363 595 -360 b 645 -367 639 -351 642 -350 b 684 -657 662 -464 684 -589 b 455 -896 684 -870 540 -896 b 340 -854 377 -896 340 -873 b 386 -829 340 -844 353 -840 b 482 -694 431 -816 482 -778 b 344 -547 482 -615 432 -547 b 190 -713 248 -547 190 -624 b 464 -948 190 -806 246 -948 b 747 -660 560 -948 747 -904 b 706 -351 747 -577 721 -441 b 724 -327 703 -334 704 -336 b 966 16 870 -269 966 -147 b 619 363 966 200 831 363 b 577 389 582 363 582 363 l 541 598 b 550 625 539 615 541 616 b 824 1174 706 770 824 953 b 730 1509 824 1299 789 1423 b 655 1581 708 1541 671 1581 b 562 1512 635 1581 590 1544 b 420 1064 455 1394 420 1214 b 441 828 420 981 431 887 b 428 793 444 811 445 808 b 0 125 220 622 0 416 b 524 -363 0 -125 171 -363 z m 115 29 b 249 363 115 114 130 228 b 469 567 336 459 402 513 b 490 562 484 579 487 577 l 520 377 b 498 343 524 350 524 351 b 289 63 372 300 289 186 b 455 -192 289 -66 357 -158 b 494 -200 467 -196 484 -200 b 511 -184 505 -200 511 -193 b 490 -166 511 -174 500 -170 b 386 -12 429 -140 386 -78 b 530 157 386 71 442 132 b 559 145 553 163 556 161 l 631 -284 b 611 -304 634 -300 632 -300 b 530 -311 588 -308 559 -311 b 115 29 278 -311 115 -171 z m 677 1358 b 763 1240 724 1358 763 1319 b 513 851 763 1080 626 950 b 494 863 503 842 497 844 b 485 995 488 900 485 949 b 677 1358 485 1220 589 1358 z m 635 168 b 848 -66 752 158 848 60 b 713 -271 848 -157 793 -230 b 690 -262 696 -279 693 -279 l 619 148 b 635 168 616 166 618 170 z',
    },
    cClef: {
      x_min: 0,
      x_max: 699,
      y_min: -506,
      y_max: 506,
      ha: 1012,
      o: 'm 269 -694 b 300 -724 269 -714 279 -724 l 301 -724 b 331 -694 321 -724 331 -714 l 331 -63 b 344 -55 331 -52 338 -53 b 472 -265 382 -65 442 -102 b 500 -301 477 -288 485 -301 b 530 -262 516 -301 523 -287 b 684 -128 549 -199 582 -128 b 804 -409 778 -128 804 -220 b 651 -683 804 -598 770 -683 b 528 -644 631 -683 528 -674 b 567 -622 528 -636 552 -628 b 625 -528 596 -612 625 -583 b 527 -429 625 -465 583 -429 b 416 -547 465 -429 416 -471 b 667 -729 416 -638 495 -729 b 1007 -413 903 -729 1007 -563 b 706 -76 1007 -215 897 -76 b 618 -89 664 -76 636 -84 b 576 -88 603 -94 589 -96 b 524 0 556 -75 524 -29 b 576 88 524 29 556 75 b 618 89 589 96 603 94 b 706 76 636 84 664 76 b 1007 413 897 76 1007 215 b 667 729 1007 563 903 729 b 416 547 495 729 416 638 b 527 429 416 471 465 429 b 625 528 583 429 625 465 b 567 622 625 583 596 612 b 528 644 552 628 528 636 b 651 683 528 674 631 683 b 804 409 770 683 804 598 b 684 128 804 220 778 128 b 530 262 582 128 549 199 b 500 301 523 287 516 301 b 472 265 485 301 477 288 b 344 55 442 102 382 65 b 331 63 338 53 331 52 l 331 694 b 301 724 331 714 321 724 l 300 724 b 269 694 279 724 269 714 z m 30 -724 l 154 -724 b 184 -694 174 -724 184 -714 l 184 694 b 154 724 184 714 174 724 l 30 724 b 0 694 10 724 0 714 l 0 -694 b 30 -724 0 -714 10 -724 z',
    },
    fClef: {
      x_min: -5,
      x_max: 684,
      y_min: -635,
      y_max: 262,
      ha: 897,
      o: 'm 12 -914 b 36 -907 19 -914 27 -912 b 765 -40 390 -734 765 -478 b 363 377 765 210 612 377 b 0 56 112 377 0 194 b 177 -158 0 -59 60 -158 b 330 -6 268 -158 330 -95 b 192 144 330 86 262 144 b 120 134 153 144 138 134 b 96 160 101 134 96 145 b 330 323 96 217 183 323 b 549 -53 482 323 549 173 b 14 -871 549 -455 350 -680 b -7 -897 1 -878 -7 -886 b 12 -914 -7 -906 -1 -914 z m 906 101 b 985 180 950 101 985 135 b 906 259 985 225 950 259 b 827 180 861 259 827 225 b 906 101 827 135 861 101 z m 907 -258 b 985 -180 952 -258 985 -225 b 907 -102 985 -135 952 -102 b 829 -180 863 -102 829 -135 b 907 -258 829 -225 863 -258 z',
    },
    unpitchedPercussionClef1: {
      x_min: 0,
      x_max: 382,
      y_min: -250,
      y_max: 250,
      ha: 500,
      o: 'm 320 338 l 320 -338 b 340 -360 320 -350 328 -360 l 530 -360 b 550 -338 541 -360 550 -350 l 550 338 b 530 360 550 350 541 360 l 340 360 b 320 338 328 360 320 350 z m 20 -360 l 210 -360 b 230 -338 222 -360 230 -350 l 230 338 b 210 360 230 350 222 360 l 20 360 b 0 338 9 360 0 350 l 0 -338 b 20 -360 0 -350 9 -360 z',
    },
    '6stringTabClef': {
      x_min: -3,
      x_max: 408,
      y_min: -748,
      y_max: 764,
      ha: 1512,
      o: 'm 39 -399 l 39 -1077 l 344 -1077 b 544 -883 467 -1077 544 -995 b 420 -719 544 -802 507 -752 b 514 -572 482 -690 514 -639 b 314 -399 514 -472 442 -399 z m 88 -328 l 160 -125 l 420 -125 l 491 -328 l 588 -328 l 350 348 l 238 348 l -4 -328 z m 26 1100 l 26 1024 l 249 1024 l 249 422 l 336 422 l 336 1024 l 557 1024 l 557 1100 z m 125 -768 l 337 -768 b 458 -884 418 -768 458 -818 b 337 -1001 458 -949 418 -1001 l 125 -1001 z m 292 -475 b 428 -583 389 -475 428 -514 b 292 -691 428 -652 389 -691 l 125 -691 l 125 -475 z m 292 256 l 397 -52 l 181 -52 z',
    },
    timeSig0: {
      x_min: 20,
      x_max: 450,
      y_min: -250,
      y_max: 251,
      ha: 501,
      o: 'm 338 -360 b 648 0 510 -360 648 -199 b 338 361 648 200 510 361 b 29 0 167 361 29 200 b 338 -360 29 -199 167 -360 z m 230 10 b 338 317 230 180 278 317 b 446 10 397 317 446 180 b 338 -295 446 -158 397 -295 b 230 10 278 -295 230 -158 z',
    },
    timeSig1: {
      x_min: 20,
      x_max: 314,
      y_min: -250,
      y_max: 251,
      ha: 501,
      o: 'm 29 0 b 45 -20 29 -7 33 -16 b 58 -23 50 -22 56 -23 b 78 -10 72 -23 78 -10 b 156 117 78 -10 140 89 b 170 131 161 127 167 131 b 179 111 176 131 179 120 l 179 -261 b 115 -315 179 -294 145 -315 b 91 -337 105 -315 91 -320 b 122 -360 91 -353 104 -360 l 429 -360 b 452 -337 452 -360 452 -337 b 431 -315 452 -337 452 -315 b 384 -265 410 -315 384 -289 l 384 328 b 356 361 384 351 376 360 b 281 356 336 361 300 356 b 206 360 253 356 228 357 b 199 361 203 360 200 361 b 173 334 184 361 179 347 l 35 19 b 29 0 35 19 29 10 z',
    },
    timeSig2: {
      x_min: 20,
      x_max: 426,
      y_min: -257,
      y_max: 254,
      ha: 511,
      o: 'm 29 170 b 42 108 29 150 33 130 b 160 29 63 63 108 29 b 261 156 248 29 261 120 b 161 275 261 242 161 246 b 275 330 164 295 190 330 b 405 192 403 330 405 233 b 193 -102 405 60 297 -39 b 33 -314 114 -153 58 -223 b 69 -370 33 -336 40 -370 b 203 -282 101 -370 118 -282 b 410 -360 261 -282 282 -360 b 606 -131 472 -360 583 -354 b 589 -111 606 -114 599 -111 b 570 -125 577 -111 573 -117 b 569 -130 570 -127 569 -128 b 513 -192 554 -164 543 -192 b 488 -187 505 -192 498 -190 b 445 -171 469 -180 459 -179 b 289 -137 416 -160 348 -137 b 236 -145 271 -137 252 -140 b 422 -42 268 -94 390 -50 b 613 147 523 -14 613 27 b 330 366 613 300 464 366 b 69 275 229 366 140 357 b 29 170 45 245 29 209 z',
    },
    timeSig3: {
      x_min: 20,
      x_max: 401,
      y_min: -251,
      y_max: 249,
      ha: 500,
      o: 'm 29 -203 b 275 -361 32 -315 134 -359 l 288 -361 b 577 -161 431 -361 577 -288 l 577 -151 b 537 -50 575 -109 564 -82 b 503 -20 528 -39 517 -29 l 472 -3 l 425 10 b 410 17 418 12 413 12 b 409 24 409 20 409 22 b 415 37 409 30 410 36 b 459 50 431 42 446 43 b 547 181 517 78 547 115 b 307 357 547 314 367 353 b 285 359 300 357 292 359 b 37 200 161 359 37 276 b 154 84 37 153 65 89 l 161 84 b 256 177 225 84 256 130 l 256 189 b 209 248 252 242 216 245 b 180 268 202 251 180 248 l 180 274 b 240 310 183 298 228 310 b 374 199 363 310 374 233 l 374 189 b 199 36 374 82 289 40 b 164 12 184 35 164 27 b 200 -6 164 -6 189 -6 b 379 -137 366 -6 379 -118 b 269 -307 379 -289 301 -307 b 256 -305 264 -307 258 -305 b 216 -282 245 -304 217 -304 l 216 -275 b 249 -180 216 -243 248 -222 b 145 -76 249 -120 207 -76 b 130 -78 140 -76 135 -76 b 60 -115 105 -82 78 -96 b 29 -203 36 -137 29 -171 z',
    },
    timeSig4: {
      x_min: 20,
      x_max: 450,
      y_min: -250,
      y_max: 251,
      ha: 501,
      o: 'm 58 -161 l 325 -161 l 325 -252 b 268 -302 325 -291 294 -302 b 235 -330 245 -302 235 -315 b 262 -360 235 -344 240 -360 l 569 -360 b 598 -330 583 -360 598 -350 b 566 -301 598 -310 580 -301 b 521 -246 552 -301 521 -292 l 521 -161 l 626 -161 b 648 -134 641 -161 648 -151 b 626 -107 648 -117 642 -107 l 521 -107 l 521 202 b 504 226 521 213 520 226 b 475 213 491 226 484 223 l 338 48 b 325 14 333 40 325 32 l 325 -107 l 131 -107 b 481 334 246 -9 477 318 b 482 341 481 337 482 338 b 461 361 482 353 472 361 b 363 359 448 361 389 359 b 261 361 337 359 272 361 b 228 334 248 361 228 357 b 43 -105 228 156 86 -45 l 35 -117 b 33 -121 35 -118 33 -120 b 29 -137 30 -127 29 -132 b 58 -161 29 -151 40 -161 z',
    },
    timeSig5: {
      x_min: 20,
      x_max: 383,
      y_min: -251,
      y_max: 246,
      ha: 497,
      o: 'm 29 -183 b 284 -361 29 -302 107 -361 b 552 -125 456 -361 552 -255 b 314 112 552 6 445 112 b 122 71 230 112 168 98 b 115 69 120 69 117 69 b 109 79 109 69 109 75 l 109 85 b 117 179 109 85 115 166 b 138 197 118 190 125 197 l 144 197 b 285 184 158 194 226 184 b 492 323 485 184 492 300 b 472 353 492 341 488 353 b 295 340 454 353 341 340 b 101 354 249 340 125 351 b 66 330 75 354 68 341 l 50 10 l 50 7 b 79 -14 50 -12 65 -14 b 111 14 94 -14 95 -1 b 209 62 125 29 160 62 b 357 -125 258 62 357 35 b 235 -304 357 -284 272 -304 b 202 -300 223 -304 212 -304 b 184 -279 194 -295 186 -289 b 202 -259 184 -269 194 -264 b 256 -163 235 -239 256 -203 b 144 -50 256 -99 206 -50 b 30 -157 66 -50 35 -107 b 29 -183 29 -166 29 -174 z',
    },
    timeSig6: {
      x_min: 20,
      x_max: 414,
      y_min: -249,
      y_max: 251,
      ha: 500,
      o: 'm 29 4 l 29 -1 b 73 -200 30 -68 42 -143 b 324 -359 132 -307 203 -359 b 513 -307 389 -359 461 -348 b 596 -137 563 -266 596 -202 b 379 72 596 -24 490 72 b 248 22 333 72 285 55 b 239 19 245 19 242 19 b 226 53 230 19 226 30 b 346 327 230 320 315 327 b 393 305 374 327 393 320 b 357 251 393 285 366 268 b 347 209 350 238 347 223 b 369 150 347 187 354 166 b 439 120 379 131 420 120 b 554 229 500 120 554 167 b 553 245 554 235 554 239 b 348 361 539 337 426 361 b 85 209 239 360 137 307 b 29 4 53 148 29 72 z m 320 3 b 405 -158 366 3 405 -69 b 320 -320 405 -248 366 -320 b 236 -158 274 -320 236 -248 b 320 3 236 -69 274 3 z',
    },
    timeSig7: {
      x_min: 20,
      x_max: 421,
      y_min: -250,
      y_max: 249,
      ha: 499,
      o: 'm 29 71 b 45 48 29 71 30 48 b 66 76 56 48 60 60 b 164 196 81 112 99 196 b 374 88 222 196 291 88 b 446 118 415 88 435 109 b 459 124 451 121 456 124 b 469 111 465 124 468 120 b 272 -112 469 71 359 -10 b 173 -315 217 -176 173 -259 b 200 -360 173 -346 173 -360 b 294 -347 226 -360 258 -347 b 412 -360 330 -347 397 -360 b 435 -307 426 -360 435 -348 b 606 288 435 -66 606 140 l 606 294 b 582 351 606 333 606 351 b 552 336 580 351 557 346 b 485 236 541 318 521 236 b 262 359 449 236 382 359 b 137 307 179 359 157 325 b 98 281 117 288 108 282 b 60 315 86 281 68 301 b 43 325 58 321 50 325 b 29 308 36 325 29 321 z',
    },
    timeSig8: {
      x_min: 20,
      x_max: 416,
      y_min: -259,
      y_max: 259,
      ha: 518,
      o: 'm 29 -190 b 301 -373 29 -315 158 -373 b 599 -117 445 -373 599 -311 b 481 52 599 -30 549 17 b 567 204 533 85 567 132 b 317 373 567 351 356 373 b 36 176 150 373 36 297 b 161 -16 36 76 92 23 b 29 -190 86 -52 29 -99 z m 111 -183 b 225 -48 111 -125 161 -72 b 436 -219 330 -94 436 -124 b 295 -325 436 -276 392 -325 b 111 -183 199 -325 111 -276 z m 314 331 b 482 207 360 331 482 308 b 406 85 482 150 454 112 b 168 240 291 125 168 150 b 314 331 168 301 251 331 z',
    },
    timeSig9: {
      x_min: 20,
      x_max: 414,
      y_min: -249,
      y_max: 251,
      ha: 500,
      o: 'm 246 -69 b 377 -19 292 -69 340 -52 b 386 -16 380 -16 383 -16 b 399 -50 395 -16 399 -27 b 279 -324 395 -317 310 -324 b 232 -302 251 -324 232 -317 b 268 -248 232 -282 259 -265 b 278 -206 275 -235 278 -220 b 256 -147 278 -184 271 -163 b 186 -117 246 -128 204 -117 b 71 -226 125 -117 71 -164 b 72 -242 71 -232 71 -236 b 276 -359 86 -334 199 -359 b 540 -206 386 -357 488 -304 b 596 -1 572 -145 596 -69 l 596 4 b 552 203 595 71 583 145 b 301 361 492 310 422 361 b 112 310 236 361 164 351 b 29 140 62 269 29 204 b 246 -69 29 27 135 -69 z m 220 161 b 305 323 220 251 259 323 b 389 161 351 323 389 251 b 305 0 389 72 351 0 b 220 161 259 0 220 72 z',
    },
    timeSigCommon: {
      x_min: 5,
      x_max: 424,
      y_min: -249,
      y_max: 251,
      ha: 500,
      o: 'm 101 -262 b 321 -359 156 -328 235 -359 b 611 -88 573 -359 611 -130 b 589 -56 611 -56 595 -56 b 567 -82 577 -56 567 -58 b 363 -311 567 -268 409 -311 b 184 40 246 -311 184 -197 b 372 327 184 278 294 327 b 477 278 446 327 477 292 b 451 246 477 265 472 246 b 360 140 393 246 360 184 b 471 32 360 58 431 32 b 580 156 471 32 580 36 b 336 361 580 344 363 361 b 7 -14 131 361 7 180 b 101 -262 7 -108 42 -190 z',
    },
    timeSigCutCommon: {
      x_min: 0,
      x_max: 418,
      y_min: -359,
      y_max: 361,
      ha: 720,
      o: 'm 225 -346 b 252 -382 235 -350 252 -369 l 252 -492 b 276 -517 252 -505 265 -517 b 302 -492 292 -517 302 -505 l 302 -379 b 318 -359 302 -370 308 -363 b 602 -85 563 -354 602 -130 b 579 -58 600 -58 586 -58 l 573 -58 b 559 -82 567 -58 559 -60 b 354 -310 559 -266 400 -310 b 317 -305 340 -310 328 -308 b 302 -284 311 -304 302 -295 l 302 287 b 338 323 302 297 328 321 b 363 324 347 324 356 324 b 468 275 436 324 468 289 b 442 243 468 264 464 243 b 351 137 384 243 351 181 b 462 30 351 56 422 30 b 572 154 462 30 572 35 b 318 357 572 295 441 357 b 302 390 310 359 302 383 l 302 495 b 276 520 302 507 292 520 b 252 495 265 520 252 507 l 252 369 b 235 346 252 359 238 346 l 196 331 b 0 -14 66 275 0 122 b 225 -346 0 -150 86 -310 z m 232 259 b 236 262 233 262 235 262 b 252 239 243 262 252 251 l 252 -235 b 243 -252 252 -248 248 -252 b 236 -248 240 -252 238 -251 b 177 37 197 -193 177 -96 b 232 259 177 147 200 215 z',
    },
    noteheadDoubleWhole: {
      x_min: 0,
      x_max: 599,
      y_min: -155,
      y_max: 155,
      ha: 310,
      o: 'm 423 -180 b 733 1 657 -180 733 -98 l 733 -213 b 747 -223 733 -219 740 -223 l 766 -223 b 780 -213 773 -223 780 -219 l 780 212 b 766 223 780 217 773 223 l 747 223 b 733 212 740 223 733 217 l 733 1 b 438 180 733 104 572 180 b 130 1 248 180 130 101 b 423 -180 130 -92 210 -180 z m 284 58 b 400 147 284 131 333 147 b 577 -45 498 147 577 42 b 469 -145 577 -115 533 -145 b 331 -71 409 -145 369 -112 b 284 58 305 -37 284 12 z m 815 -213 b 829 -223 815 -219 824 -223 l 848 -223 b 863 -213 857 -223 863 -219 l 863 212 b 848 223 863 217 857 223 l 829 223 b 815 212 824 223 815 217 z m 82 212 l 82 -213 b 96 -223 82 -219 88 -223 l 114 -223 b 128 -213 121 -223 128 -219 l 128 212 b 114 223 128 217 121 223 l 96 223 b 82 212 88 223 82 217 z m 13 -223 l 32 -223 b 45 -213 39 -223 45 -219 l 45 212 b 32 223 45 217 39 223 l 13 223 b 0 212 4 223 0 217 l 0 -213 b 13 -223 0 -219 4 -223 z',
    },
    noteheadWhole: {
      x_min: 0,
      x_max: 422,
      y_min: -125,
      y_max: 125,
      ha: 250,
      o: 'm 0 3 b 297 -180 0 -94 82 -180 b 608 3 533 -180 608 -98 b 311 180 608 105 445 180 b 0 3 120 180 0 101 z m 156 56 b 160 91 156 68 157 79 b 274 148 176 141 229 148 b 452 -45 373 148 452 42 b 386 -141 452 -89 433 -130 b 341 -147 372 -145 356 -147 b 206 -72 289 -147 236 -112 b 156 56 177 -39 156 10 z',
    },
    noteheadHalf: {
      x_min: 0,
      x_max: 295,
      y_min: -125,
      y_max: 125,
      ha: 250,
      o: 'm 140 -180 b 425 60 377 -180 425 13 b 282 180 425 134 366 180 b 0 -60 68 180 0 14 b 140 -180 0 -137 60 -180 z m 42 -63 b 318 121 42 7 251 121 b 372 91 346 121 361 108 b 380 63 376 82 380 73 b 108 -125 380 1 177 -125 b 50 -92 78 -125 60 -109 b 42 -63 46 -84 42 -73 z',
    },
    noteheadBlack: {
      x_min: 0,
      x_max: 295,
      y_min: -125,
      y_max: 125,
      ha: 250,
      o: 'm 0 -60 b 140 -180 0 -135 62 -180 b 425 60 268 -180 425 -62 b 285 180 425 134 367 180 b 0 -60 127 180 0 63 z',
    },
    noteheadXWhole: {
      x_min: 0,
      x_max: 377,
      y_min: -125,
      y_max: 125,
      ha: 250,
      o: 'm 0 148 b 12 124 0 140 4 131 l 132 0 l 12 -124 b 1 -148 4 -131 1 -140 b 32 -180 1 -164 14 -180 l 158 -180 b 179 -171 166 -180 173 -177 l 272 -95 l 364 -171 b 384 -180 370 -177 377 -180 l 511 -180 b 543 -148 528 -180 543 -164 b 531 -124 543 -140 539 -131 l 412 0 l 531 124 b 541 148 539 131 541 140 b 513 180 541 164 528 180 l 384 180 b 364 171 377 180 370 177 l 272 94 l 179 171 b 158 180 173 177 166 180 l 30 180 b 0 148 16 180 0 164 z m 245 0 l 88 141 l 157 141 l 272 45 l 386 141 l 456 141 l 300 0 l 456 -141 l 386 -141 l 272 -45 l 157 -141 l 88 -141 z',
    },
    noteheadXHalf: {
      x_min: 0,
      x_max: 334,
      y_min: -125,
      y_max: 125,
      ha: 250,
      o: 'm 32 -180 l 184 -180 b 209 -170 193 -180 203 -177 l 271 -99 l 363 -171 b 384 -180 370 -176 377 -180 l 445 -180 b 478 -147 461 -180 478 -163 b 465 -125 478 -138 474 -131 l 341 -22 l 474 127 b 481 148 480 131 481 138 b 448 180 481 166 468 180 l 295 180 b 271 170 287 180 278 177 l 209 98 l 115 171 b 95 180 109 177 104 180 l 36 180 b 4 148 19 180 4 164 b 14 124 4 140 7 132 l 140 22 l 7 -127 b 0 -148 3 -131 0 -138 b 32 -180 0 -166 14 -180 z m 95 148 l 233 33 l 334 148 l 410 148 l 274 -6 l 445 -148 l 384 -148 l 248 -35 l 147 -148 l 71 -148 l 206 4 l 36 148 z',
    },
    noteheadXBlack: {
      x_min: 0,
      x_max: 290,
      y_min: -125,
      y_max: 125,
      ha: 250,
      o: 'm 0 -158 b 19 -180 0 -170 7 -180 b 29 -176 23 -180 26 -179 l 207 -24 l 389 -176 b 399 -180 392 -179 396 -180 b 418 -160 410 -180 418 -168 b 410 -143 418 -153 415 -147 l 239 0 l 410 144 b 418 160 415 147 418 154 b 399 180 418 171 408 180 b 389 177 396 180 392 179 l 207 26 l 29 177 b 17 180 26 179 22 180 b 0 161 7 180 0 170 b 7 144 0 156 3 148 l 179 0 l 7 -143 b 0 -158 1 -147 0 -153 z',
    },
    noteheadCircleX: {
      x_min: 0,
      x_max: 249,
      y_min: -125,
      y_max: 125,
      ha: 250,
      o: 'm 0 0 b 179 -180 0 -99 81 -180 b 359 0 278 -180 359 -99 b 179 180 359 99 278 180 b 0 0 81 180 0 99 z m 69 84 l 151 1 l 68 -84 b 40 0 49 -60 40 -30 b 69 84 40 32 50 60 z m 180 -27 l 262 -111 b 179 -138 239 -128 210 -138 b 95 -111 148 -138 120 -128 z m 209 1 l 291 84 b 317 0 307 60 317 30 b 292 -82 317 -30 308 -59 z m 179 138 b 261 112 210 138 238 128 l 180 30 l 98 112 b 179 138 121 128 148 138 z',
    },
    noteheadTriangleUpWhole: {
      x_min: 0,
      x_max: 319,
      y_min: -125,
      y_max: 125,
      ha: 250,
      o: 'm 0 -166 b 14 -180 0 -173 6 -180 l 445 -180 b 459 -166 454 -180 459 -173 b 458 -158 459 -163 458 -160 l 239 173 b 228 180 238 177 233 180 b 216 173 225 180 219 177 l 1 -158 b 0 -166 1 -160 0 -163 z m 145 -96 b 228 108 145 -17 197 56 b 310 -98 259 55 310 -17 b 288 -137 310 -111 301 -137 l 170 -137 b 145 -96 157 -137 145 -109 z',
    },
    noteheadTriangleUpHalf: {
      x_min: 0,
      x_max: 285,
      y_min: -125,
      y_max: 125,
      ha: 250,
      o: 'm 14 -180 l 396 -180 b 410 -166 406 -180 410 -173 b 409 -158 410 -163 410 -161 l 228 173 b 215 180 226 174 220 180 b 202 173 210 180 204 177 l 3 -157 b 0 -166 1 -160 0 -163 b 14 -180 0 -173 7 -180 z m 115 -138 l 232 76 l 297 -37 l 246 -138 z',
    },
    noteheadTriangleUpBlack: {
      x_min: 0,
      x_max: 293,
      y_min: -125,
      y_max: 125,
      ha: 250,
      o: 'm 422 -180 l 207 180 l 0 -180 z',
    },
    noteheadDiamondWhole: {
      x_min: 0,
      x_max: 270,
      y_min: -125,
      y_max: 125,
      ha: 250,
      o: 'm 4 7 l 258 -179 b 264 -180 261 -179 262 -180 b 272 -176 268 -180 271 -179 l 386 -23 b 389 -16 387 -20 389 -19 b 383 -7 389 -13 386 -9 l 130 179 b 122 180 128 180 125 180 b 115 177 120 180 117 180 l 3 23 b 0 17 1 20 0 19 b 4 7 0 16 3 10 z m 109 111 b 112 112 109 112 111 112 b 118 111 115 112 117 111 l 320 -37 b 324 -46 323 -39 324 -42 b 275 -111 278 -111 276 -111 b 268 -108 272 -111 271 -109 l 66 40 b 62 48 65 42 62 45 z',
    },
    noteheadDiamondHalf: {
      x_min: 0,
      x_max: 251,
      y_min: -125,
      y_max: 125,
      ha: 250,
      o: 'm 4 -7 l 174 -177 b 180 -180 176 -180 179 -180 b 189 -177 183 -180 186 -180 l 359 -7 b 361 0 360 -6 361 -3 b 359 7 361 3 360 4 l 189 177 b 180 180 186 179 183 180 b 174 177 179 180 176 179 l 4 7 b 0 0 1 4 0 3 b 4 -7 0 -3 1 -6 z m 215 73 b 266 26 238 73 266 50 b 138 -71 266 -12 176 -71 b 96 -50 121 -71 108 -63 b 88 -24 89 -43 88 -32 b 215 73 88 13 177 73 z',
    },
    noteheadDiamondBlack: {
      x_min: 0,
      x_max: 250,
      y_min: -125,
      y_max: 125,
      ha: 250,
      o: 'm 4 -7 l 173 -177 b 180 -180 176 -180 177 -180 b 187 -177 181 -180 184 -180 l 357 -6 b 360 1 359 -4 360 -1 b 357 9 360 4 359 7 l 189 177 b 180 180 187 179 184 180 b 171 177 177 180 173 179 l 3 9 b 0 1 0 6 0 4 b 4 -7 0 -1 1 -4 z',
    },
    noteheadSquareWhite: {
      x_min: 0,
      x_max: 313,
      y_min: -125,
      y_max: 125,
      ha: 250,
      o: 'm 451 -180 l 451 180 l 0 180 l 0 -180 z m 40 -138 l 40 140 l 410 140 l 410 -138 z',
    },
    noteheadSquareBlack: {
      x_min: 0,
      x_max: 313,
      y_min: -125,
      y_max: 125,
      ha: 250,
      o: 'm 451 -180 l 451 180 l 0 180 l 0 -180 z',
    },
    augmentationDot: {
      x_min: 0,
      x_max: 100,
      y_min: -50,
      y_max: 50,
      ha: 100,
      o: 'm 72 -72 b 144 0 112 -72 144 -40 b 72 72 144 40 112 72 b 0 0 32 72 0 40 b 72 -72 0 -40 32 -72 z',
    },
    tremolo1: {
      x_min: -150,
      x_max: 150,
      y_min: -93,
      y_max: 94,
      ha: 187,
      o: 'm 216 -45 l 216 135 l -216 46 l -216 -134 z',
    },
    flag8thUp: {
      x_min: 0,
      x_max: 264,
      y_min: -810.1921176545984,
      y_max: 9,
      ha: 819.1921176545984,
      o: 'm 284 -688 b 318 -904 305 -737 318 -819 b 284 -1102 318 -969 308 -1037 b 279 -1123 281 -1110 279 -1117 b 302 -1165 279 -1146 294 -1159 b 343 -1138 311 -1171 336 -1162 b 380 -888 343 -1138 380 -1001 b 215 -395 380 -708 305 -539 b 58 -19 141 -281 81 -157 b 14 13 53 4 42 13 b 0 -9 6 13 0 9 l 0 -353 b 284 -688 95 -370 232 -566 z',
    },
    flag8thDown: {
      x_min: 0,
      x_max: 306,
      y_min: -14,
      y_max: 808,
      ha: 822,
      o: 'm 16 -20 b 58 12 43 -20 55 -12 b 262 387 82 148 189 274 b 441 881 353 530 441 701 b 400 1142 441 994 412 1096 b 377 1164 396 1158 387 1164 b 346 1094 356 1164 331 1136 b 376 897 366 1034 376 962 b 318 642 376 812 340 691 b 0 340 265 521 193 405 l 0 1 b 16 -20 0 -16 7 -20 z',
    },
    flag16thUp: {
      x_min: 0,
      x_max: 279,
      y_min: -813,
      y_max: 2,
      ha: 815,
      o: 'm 7 -570 b 298 -778 96 -573 199 -576 b 344 -992 331 -847 344 -917 b 333 -1120 344 -1034 340 -1077 b 331 -1133 331 -1126 331 -1129 b 363 -1171 331 -1152 343 -1171 b 392 -1146 373 -1171 383 -1165 b 402 -988 397 -1139 402 -1057 l 402 -956 b 360 -783 402 -896 386 -837 b 359 -770 360 -779 359 -776 b 360 -760 359 -768 359 -765 b 396 -577 364 -752 396 -665 b 392 -526 396 -559 395 -543 b 236 -275 377 -428 340 -387 b 53 -16 158 -192 78 -168 b 24 3 50 0 33 3 b 0 1 16 3 0 1 l 0 -570 z m 78 -312 l 89 -312 b 302 -464 177 -312 255 -393 b 341 -592 328 -501 341 -546 b 340 -621 341 -602 341 -611 b 330 -658 337 -632 337 -647 b 311 -667 328 -662 318 -667 b 301 -661 307 -667 304 -665 b 223 -562 278 -625 253 -596 b 59 -331 156 -484 89 -449 b 58 -327 58 -330 58 -328 b 78 -312 58 -321 66 -312 z',
    },
    flag16thDown: {
      x_min: 0,
      x_max: 290.8951581511223,
      y_min: -9,
      y_max: 812.0064,
      ha: 821.0064,
      o: 'm 0 -12 b 24 -13 0 -12 16 -13 b 53 6 33 -13 50 -10 b 406 516 88 228 372 289 b 410 567 409 531 410 549 b 374 750 410 655 379 742 b 373 760 373 753 373 756 b 374 773 373 766 374 769 b 405 1138 426 881 428 1022 b 370 1169 397 1171 387 1169 b 346 1132 353 1168 341 1156 b 312 768 367 1011 367 880 b 7 559 213 566 96 562 l 0 559 z m 58 317 b 59 321 58 318 58 320 b 238 552 89 439 170 472 b 315 651 268 585 292 613 b 325 657 318 655 321 657 b 344 647 333 657 343 652 b 354 611 351 636 351 622 b 356 582 356 600 356 590 b 317 454 356 534 343 491 b 89 302 269 383 177 302 l 78 302 b 58 317 66 302 58 310 z',
    },
    flag32ndUp: {
      x_min: 0,
      x_max: 261,
      y_min: -812,
      y_max: 149,
      ha: 961,
      o: 'm 7 -609 b 278 -802 91 -612 186 -615 b 323 -999 310 -865 323 -930 b 311 -1122 323 -1040 318 -1080 b 310 -1132 311 -1126 310 -1129 b 328 -1166 310 -1149 318 -1162 b 337 -1169 331 -1168 334 -1169 b 366 -1146 346 -1169 356 -1162 b 376 -1009 370 -1138 376 -1071 b 374 -969 376 -995 374 -982 b 337 -806 372 -913 359 -858 b 336 -796 336 -804 336 -801 b 337 -788 336 -793 336 -791 b 370 -616 340 -778 370 -698 b 340 -482 370 -570 360 -524 b 369 -330 353 -445 369 -386 b 366 -289 369 -315 369 -302 b 220 -58 350 -202 317 -163 b 46 187 148 20 71 43 b 17 215 45 200 26 215 b 0 197 9 215 0 197 l 0 -609 z m 300 -261 b 321 -330 315 -289 321 -311 b 317 -360 321 -341 318 -350 b 300 -423 314 -374 307 -399 b 220 -334 279 -397 253 -370 b 56 -92 150 -256 79 -232 b 300 -261 135 -92 220 -127 z m 55 -386 b 73 -367 55 -384 65 -369 b 318 -622 189 -367 318 -505 b 315 -657 318 -634 317 -645 b 308 -690 312 -668 312 -680 b 292 -698 307 -694 300 -698 b 282 -693 288 -698 284 -697 b 216 -608 261 -661 240 -636 l 209 -600 b 55 -386 147 -527 84 -497 z',
    },
    flag32ndDown: {
      x_min: 0,
      x_max: 273,
      y_min: -172,
      y_max: 812,
      ha: 984,
      o: 'm 17 -248 b 48 -219 27 -248 46 -232 b 229 36 72 -69 154 -46 b 380 278 330 145 364 186 b 383 320 383 291 383 305 b 351 484 383 382 364 445 b 384 629 374 526 384 580 b 356 780 384 704 361 766 b 351 793 356 785 351 789 b 356 804 351 796 353 799 l 361 814 b 393 958 380 850 387 865 l 393 973 b 333 1169 393 1002 383 1169 b 324 1168 330 1169 327 1169 b 304 1130 314 1164 304 1149 b 305 1120 304 1128 305 1125 b 334 962 317 1056 334 1011 b 289 821 334 922 323 880 b 0 619 180 625 88 622 l 0 -229 b 17 -248 0 -229 9 -248 z m 56 76 b 229 331 81 226 154 249 b 310 423 264 369 289 397 b 330 350 318 396 325 366 b 334 320 331 340 334 331 b 311 248 334 301 328 278 b 59 72 229 109 141 72 b 56 76 56 73 56 75 z m 56 386 b 217 609 86 501 153 533 b 292 706 246 642 269 670 b 304 711 295 710 300 711 b 321 703 311 711 320 707 b 328 670 325 693 325 681 b 331 634 330 658 331 645 b 82 367 331 516 199 367 l 75 367 b 56 386 62 367 56 379 z',
    },
    flag64thUp: {
      x_min: 0,
      x_max: 261,
      y_min: -812,
      y_max: 347,
      ha: 1159,
      o: 'm 0 -609 l 7 -609 b 278 -802 91 -612 186 -615 b 323 -999 310 -865 323 -930 b 311 -1122 323 -1040 318 -1080 b 310 -1132 311 -1126 310 -1129 b 328 -1166 310 -1149 318 -1162 b 337 -1169 331 -1168 334 -1169 b 366 -1146 346 -1169 356 -1162 b 376 -1009 370 -1138 376 -1071 b 374 -969 376 -995 374 -982 b 337 -806 372 -913 359 -858 b 336 -796 336 -804 336 -801 b 337 -788 336 -793 336 -791 b 370 -616 340 -778 370 -698 b 340 -482 370 -570 360 -524 b 369 -330 353 -445 369 -386 b 337 -203 369 -287 359 -242 b 369 -43 350 -167 369 -104 b 366 -4 369 -30 367 -17 b 220 228 350 84 317 122 b 46 472 148 305 71 328 b 17 500 45 485 26 500 b 0 482 9 500 0 482 z m 56 193 b 300 24 138 193 220 157 b 321 -45 315 -4 321 -26 b 317 -75 321 -56 318 -65 l 298 -145 b 220 -58 278 -121 253 -94 b 58 187 148 20 82 43 b 56 193 58 189 58 192 z m 300 -261 b 321 -330 315 -289 321 -311 b 317 -360 321 -341 318 -350 b 300 -423 314 -374 307 -399 b 220 -334 279 -397 253 -370 b 56 -92 150 -256 79 -232 b 300 -261 135 -92 220 -127 z m 55 -386 b 73 -367 55 -384 65 -369 b 318 -622 189 -367 318 -505 b 315 -657 318 -634 317 -645 b 308 -690 312 -668 312 -680 b 292 -698 307 -694 300 -698 b 282 -693 288 -698 284 -697 b 216 -608 261 -661 240 -636 l 209 -600 b 55 -386 147 -527 84 -497 z',
    },
    flag64thDown: {
      x_min: 0,
      x_max: 273,
      y_min: -376,
      y_max: 812,
      ha: 1188,
      o: 'm 17 -541 b 48 -513 27 -541 46 -526 b 229 -258 72 -363 154 -340 b 380 -16 330 -148 364 -108 b 384 27 383 -1 384 13 b 351 189 384 88 366 151 b 380 278 366 216 374 243 b 383 320 383 291 383 305 b 351 484 383 382 364 445 b 384 629 374 526 384 580 b 356 780 384 704 361 766 b 351 793 356 785 351 789 b 356 804 351 796 353 799 l 361 814 b 393 958 380 850 387 865 l 393 973 b 333 1169 393 1002 383 1169 b 324 1168 330 1169 327 1169 b 304 1130 314 1164 304 1149 b 305 1120 304 1128 305 1125 b 334 962 317 1056 334 1011 b 289 821 334 922 323 880 b 0 619 180 625 88 622 l 0 -523 b 17 -541 0 -523 9 -541 z m 56 76 b 229 331 81 226 154 249 b 310 423 264 369 289 397 b 330 350 318 396 325 366 b 334 320 331 340 334 331 b 311 248 334 301 328 278 b 59 72 229 109 141 72 b 56 76 56 73 56 75 z m 229 36 b 311 128 264 73 289 102 l 330 56 b 334 26 331 46 334 37 b 311 -46 334 7 328 -16 b 56 -222 229 -184 137 -222 b 229 36 75 -86 145 -55 z m 217 609 b 292 706 246 642 269 670 b 304 711 295 710 300 711 b 321 703 311 711 320 707 b 328 670 325 693 325 681 b 331 634 330 658 331 645 b 82 367 331 516 199 367 l 75 367 b 56 386 62 367 56 379 b 217 609 86 501 153 533 z',
    },
    flag128thUp: {
      x_min: 0,
      x_max: 261,
      y_min: -812,
      y_max: 533,
      ha: 1345,
      o: 'm 7 -609 b 278 -802 91 -612 186 -615 b 323 -999 310 -865 323 -930 b 311 -1122 323 -1040 318 -1080 b 310 -1132 311 -1126 310 -1129 b 328 -1166 310 -1149 318 -1162 b 337 -1169 331 -1168 334 -1169 b 366 -1146 346 -1169 356 -1162 b 376 -1009 370 -1138 376 -1071 b 374 -969 376 -995 374 -982 b 337 -806 372 -913 359 -858 b 336 -796 336 -804 336 -801 b 337 -788 336 -793 336 -791 b 370 -616 340 -778 370 -698 b 340 -482 370 -570 360 -524 b 369 -330 353 -445 369 -386 b 337 -203 369 -287 359 -242 b 369 -43 350 -167 369 -104 b 366 -4 369 -30 367 -17 b 341 75 360 26 353 50 b 369 222 354 111 369 167 b 366 264 369 236 369 251 b 220 495 350 351 317 390 b 46 740 148 573 71 596 b 17 768 45 753 26 768 b 0 750 9 768 0 750 l 0 -609 z m 300 24 b 321 -45 315 -4 321 -26 b 317 -75 321 -56 318 -65 l 298 -145 b 220 -58 278 -121 253 -94 b 56 187 148 20 81 43 b 55 193 56 189 56 192 b 300 24 137 193 220 157 z m 300 -261 b 321 -330 315 -289 321 -311 b 317 -360 321 -341 318 -350 b 300 -423 314 -374 307 -399 b 220 -334 279 -397 253 -370 b 56 -92 150 -256 79 -232 b 300 -261 135 -92 220 -127 z m 55 -386 b 73 -367 55 -384 65 -369 b 318 -622 189 -367 318 -505 b 315 -657 318 -634 317 -645 b 308 -690 312 -668 312 -680 b 292 -698 307 -694 300 -698 b 282 -693 288 -698 284 -697 b 216 -608 261 -661 240 -636 l 209 -600 b 55 -386 147 -527 84 -497 z m 300 292 b 321 223 315 264 321 242 b 317 193 321 212 318 203 b 301 135 314 180 308 158 b 220 228 281 161 255 190 b 55 461 151 304 79 327 b 300 292 134 461 220 426 z',
    },
    flag128thDown: {
      x_min: 0,
      x_max: 273,
      y_min: -580,
      y_max: 812,
      ha: 1392,
      o: 'm 17 -835 b 48 -806 27 -835 46 -819 b 229 -552 72 -657 154 -634 b 380 -310 330 -442 364 -402 b 384 -266 383 -295 384 -281 b 351 -105 384 -206 366 -143 b 384 27 372 -66 384 -16 b 351 189 384 88 366 151 b 380 278 366 216 374 243 b 383 320 383 291 383 305 b 351 484 383 382 364 445 b 384 629 374 526 384 580 b 356 780 384 704 361 766 b 351 793 356 785 351 789 b 356 804 351 796 353 799 l 361 814 b 393 958 380 850 387 865 l 393 973 b 333 1169 393 1002 383 1169 b 324 1168 330 1169 327 1169 b 304 1130 314 1164 304 1149 b 305 1120 304 1128 305 1125 b 334 962 317 1056 334 1011 b 289 821 334 922 323 880 b 0 619 180 625 88 622 l 0 -816 b 17 -835 0 -816 9 -835 z m 229 331 b 310 423 264 369 289 397 b 330 350 318 396 325 366 b 334 320 331 340 334 331 b 311 248 334 301 328 278 b 59 72 229 109 141 72 b 56 76 56 73 56 75 b 229 331 81 226 154 249 z m 56 -516 b 229 -258 75 -380 145 -348 b 311 -166 264 -220 289 -192 l 330 -238 b 334 -268 331 -248 334 -256 b 311 -340 334 -287 328 -310 b 56 -516 229 -478 137 -516 z m 56 -222 b 229 36 75 -86 145 -55 b 311 128 264 73 289 102 l 330 56 b 334 26 331 46 334 37 b 311 -46 334 7 328 -16 b 56 -222 229 -184 137 -222 z m 217 609 b 292 706 246 642 269 670 b 304 711 295 710 300 711 b 321 703 311 711 320 707 b 328 670 325 693 325 681 b 331 634 330 658 331 645 b 82 367 331 516 199 367 l 75 367 b 56 386 62 367 56 379 b 217 609 86 501 153 533 z',
    },
    accidentalFlat: {
      x_min: 0,
      x_max: 226,
      y_min: -175,
      y_max: 439,
      ha: 614,
      o: 'm 17 -245 b 30 -252 22 -251 26 -252 b 39 -249 35 -252 39 -249 b 153 -161 82 -225 117 -186 b 325 82 281 -72 325 16 b 196 220 325 164 262 216 b 117 196 171 220 137 209 b 85 176 108 189 92 176 b 78 177 82 176 81 176 b 62 202 68 181 62 192 b 72 608 63 233 72 579 b 45 632 72 624 59 632 b 0 592 24 632 1 618 b 17 -245 0 592 6 -230 z m 66 73 b 167 144 76 102 134 144 b 226 60 209 144 226 96 b 98 -134 226 -17 160 -95 b 84 -138 92 -137 88 -138 b 68 -117 71 -138 68 -124 b 63 27 68 -117 63 -30 b 66 73 63 50 65 68 z',
    },
    accidentalNatural: {
      x_min: 0,
      x_max: 168,
      y_min: -335,
      y_max: 341,
      ha: 676,
      o: 'm 0 -268 b 12 -281 0 -276 4 -281 b 22 -278 13 -281 20 -279 b 164 -235 42 -269 122 -235 b 189 -251 179 -235 189 -239 l 189 -465 b 206 -482 189 -475 196 -482 l 225 -482 b 242 -465 233 -482 242 -475 l 242 258 b 230 269 242 265 236 269 b 225 268 229 269 226 269 l 203 261 b 197 259 200 261 199 259 b 68 226 197 259 105 226 b 53 233 59 226 53 228 l 53 474 b 36 491 53 484 45 491 l 17 491 b 0 474 7 491 0 484 z m 176 114 b 189 107 184 114 189 112 l 189 -42 b 71 -101 189 -68 107 -101 b 53 -92 60 -101 53 -98 l 53 56 b 176 114 53 76 141 114 z',
    },
    accidentalSharp: {
      x_min: 0,
      x_max: 249,
      y_min: -348,
      y_max: 350,
      ha: 698,
      o: 'm 12 37 b 49 53 17 37 45 50 b 53 55 50 53 52 55 b 72 29 63 55 72 40 l 72 -114 b 56 -147 72 -130 65 -143 b 17 -163 48 -150 17 -163 b 0 -186 7 -166 0 -177 l 0 -288 b 12 -301 0 -297 4 -301 b 17 -300 13 -301 16 -300 b 50 -287 17 -300 37 -291 b 55 -285 52 -285 53 -285 b 72 -308 65 -285 72 -301 l 72 -485 b 91 -501 72 -494 81 -501 b 115 -485 105 -501 115 -494 l 115 -285 b 130 -253 115 -266 122 -256 l 217 -217 b 223 -216 219 -217 222 -216 b 242 -242 235 -216 242 -233 l 242 -422 b 261 -438 242 -431 251 -438 b 285 -422 276 -438 285 -431 l 285 -217 b 301 -184 285 -206 291 -189 b 341 -168 311 -180 341 -168 b 359 -144 351 -164 359 -153 l 359 -42 b 348 -30 359 -35 354 -30 b 341 -32 346 -30 344 -30 l 304 -46 b 285 -20 295 -46 285 -37 l 285 114 b 304 156 285 124 292 151 l 341 170 b 359 194 351 174 359 186 l 359 297 b 348 308 359 304 354 308 b 341 307 346 308 344 308 b 305 294 341 307 312 295 b 285 312 295 294 285 301 l 285 488 b 265 504 285 497 276 504 b 242 488 251 504 242 497 l 242 301 b 223 259 240 287 236 268 b 132 223 206 249 157 229 b 115 252 120 223 115 240 l 115 425 b 95 441 115 433 105 441 b 72 425 81 441 72 433 l 72 230 b 55 192 72 210 63 196 b 17 176 46 187 17 176 b 0 153 7 173 0 161 l 0 50 b 12 37 0 42 4 37 z m 111 -43 b 115 63 111 1 112 52 b 220 118 118 88 184 118 b 242 109 230 118 239 115 b 248 27 245 102 248 66 b 242 -65 248 -12 245 -52 b 132 -122 233 -94 166 -122 b 115 -115 124 -122 117 -120 b 111 -43 112 -109 111 -78 z',
    },
    accidentalDoubleSharp: {
      x_min: 0,
      x_max: 247,
      y_min: -125,
      y_max: 127,
      ha: 252,
      o: 'm 0 -111 b 7 -166 0 -137 3 -163 b 65 -180 17 -174 40 -180 b 118 -166 86 -180 109 -176 b 130 -111 127 -158 130 -134 b 132 -105 130 -109 131 -107 b 177 -45 141 -85 158 -45 b 226 -111 196 -45 220 -91 b 233 -166 226 -137 228 -161 b 291 -180 243 -174 266 -180 b 356 -114 346 -180 356 -166 b 346 -56 356 -89 351 -63 b 288 -46 338 -49 312 -46 l 274 -46 b 206 1 258 -37 206 -9 b 274 50 206 22 253 43 b 291 49 279 50 285 49 b 346 63 314 49 336 55 b 356 115 353 71 356 92 b 292 183 356 174 351 183 b 233 173 266 183 240 180 b 226 117 228 168 226 143 b 179 49 219 101 196 49 b 130 117 158 49 135 96 b 118 173 130 141 125 167 b 66 183 112 180 89 183 b 7 173 42 183 16 180 b 0 120 3 170 0 145 b 7 63 0 94 3 68 b 68 49 17 55 43 49 b 82 50 73 49 78 50 b 150 3 98 42 150 13 b 84 -46 150 -16 104 -39 l 69 -46 b 7 -56 43 -46 16 -49 b 0 -111 3 -60 0 -85 z',
    },
    accidentalDoubleFlat: {
      x_min: 0,
      x_max: 411,
      y_min: -175,
      y_max: 437,
      ha: 612,
      o: 'm 17 -245 b 30 -252 22 -251 26 -252 b 39 -249 35 -252 39 -249 b 153 -161 84 -226 120 -186 b 274 -50 206 -124 246 -85 b 284 -245 276 -158 279 -240 b 295 -252 288 -251 292 -252 b 304 -249 300 -252 304 -249 b 416 -163 348 -226 383 -186 b 592 82 546 -72 592 16 b 461 217 592 163 528 216 l 452 217 b 384 194 426 217 408 207 b 350 176 374 189 363 176 b 343 177 347 176 344 176 b 328 202 333 180 328 190 b 337 606 328 232 337 579 b 310 629 337 622 324 629 b 265 592 291 629 268 616 b 269 194 265 592 266 395 b 196 217 248 209 223 217 l 187 217 b 120 194 160 217 143 207 b 85 176 108 189 98 176 b 78 177 82 176 81 176 b 62 202 68 180 62 190 b 72 606 62 232 72 579 b 45 629 72 622 59 629 b 0 592 24 629 1 616 b 17 -245 0 592 7 -232 z m 66 72 b 168 144 75 101 134 144 b 226 59 212 144 226 95 b 96 -134 226 -22 161 -94 b 84 -138 92 -137 86 -138 b 68 -115 72 -138 68 -124 b 63 26 68 -115 63 -30 b 66 72 63 49 65 66 z m 328 39 b 330 72 328 55 328 68 b 433 144 338 101 399 144 b 468 130 448 144 459 140 b 490 59 481 112 490 88 b 361 -134 490 -22 426 -94 b 348 -138 356 -137 351 -138 b 333 -115 337 -138 333 -124 b 328 39 333 -115 328 -16 z',
    },
    accidentalParensLeft: {
      x_min: 0,
      x_max: 141,
      y_min: -248,
      y_max: 247,
      ha: 495,
      o: 'm 199 -357 b 203 -354 200 -357 203 -356 l 203 -333 b 200 -327 203 -330 202 -328 b 86 0 118 -253 86 -160 b 200 324 86 158 120 251 b 203 331 202 325 203 327 l 203 351 b 202 356 203 354 203 356 b 0 0 60 281 0 140 b 199 -357 0 -144 60 -269 z',
    },
    accidentalParensRight: {
      x_min: 0,
      x_max: 141,
      y_min: -248,
      y_max: 247,
      ha: 495,
      o: 'm 0 331 b 3 324 0 327 1 325 b 117 0 84 251 117 158 b 3 -327 117 -160 85 -253 b 0 -333 1 -328 0 -330 l 0 -354 b 4 -357 0 -356 3 -357 b 203 0 143 -269 203 -144 b 1 356 203 140 143 281 b 0 351 0 356 0 354 z',
    },
    accidentalQuarterToneFlatStein: {
      x_min: 1,
      x_max: 227,
      y_min: -175,
      y_max: 439,
      ha: 614,
      o: 'm 174 -161 b 288 -249 210 -186 245 -225 b 297 -252 288 -249 292 -252 b 310 -245 301 -252 305 -251 b 327 592 321 -230 327 592 b 282 632 325 618 302 632 b 255 608 268 632 255 624 b 265 202 255 579 264 233 b 249 177 265 192 259 181 b 242 176 246 176 245 176 b 210 196 235 176 219 189 b 131 220 190 209 156 220 b 1 85 65 216 1 164 b 174 -161 1 16 46 -72 z m 101 60 b 160 144 101 96 118 144 b 261 73 193 144 251 102 b 264 27 262 68 264 50 b 259 -117 264 -30 259 -117 b 243 -138 259 -124 256 -138 b 229 -134 239 -138 235 -137 b 101 60 167 -95 101 -17 z',
    },
    accidentalThreeQuarterTonesFlatZimmermann: {
      x_min: 1,
      x_max: 466,
      y_min: -175,
      y_max: 439,
      ha: 614,
      o: 'm 363 -245 b 376 -252 367 -251 372 -252 b 384 -249 380 -252 384 -249 b 497 -161 428 -226 464 -186 b 671 84 625 -72 671 16 b 541 220 671 164 606 217 b 513 217 531 220 523 219 b 464 196 495 212 480 206 b 431 176 452 189 442 176 b 423 177 428 176 426 176 b 408 202 413 180 408 190 l 419 608 b 392 632 419 625 406 632 b 346 592 372 632 347 618 b 363 -245 346 592 351 -230 z m 177 -163 b 289 -249 210 -186 245 -226 b 297 -252 289 -249 292 -252 b 310 -245 300 -252 305 -251 b 328 592 321 -230 328 592 b 282 631 327 618 302 631 b 255 608 268 631 255 624 l 266 202 b 251 177 266 190 261 180 b 243 176 248 176 246 176 b 210 196 232 176 222 189 b 166 216 196 204 180 210 b 161 217 164 216 163 217 b 132 220 151 219 143 220 b 1 84 65 217 1 163 b 177 -163 1 16 48 -72 z m 102 60 b 124 128 102 88 111 112 b 161 144 134 138 147 144 b 199 134 173 144 184 141 b 262 72 219 122 256 92 b 265 26 264 66 265 49 b 261 -115 265 -30 261 -115 b 245 -138 261 -124 258 -138 b 230 -134 240 -138 236 -137 b 102 60 166 -92 102 -20 z m 409 26 b 412 72 409 49 410 66 b 514 144 420 102 480 144 b 570 60 557 144 570 96 b 442 -134 570 -23 508 -91 b 429 -138 436 -137 433 -138 b 413 -115 418 -138 413 -124 b 409 26 413 -115 409 -30 z',
    },
    accidentalQuarterToneSharpStein: {
      x_min: 0,
      x_max: 179,
      y_min: -353,
      y_max: 307,
      ha: 660,
      o: 'm 12 -315 b 85 -285 17 -315 76 -289 b 105 -312 92 -282 105 -301 l 105 -492 b 125 -508 105 -501 114 -508 b 150 -484 147 -508 150 -498 l 150 -285 b 151 -274 150 -281 150 -278 b 164 -253 153 -265 158 -256 b 240 -225 176 -251 240 -225 b 258 -202 249 -222 258 -210 l 258 -99 b 246 -86 258 -91 253 -86 b 240 -88 245 -86 242 -88 l 240 -86 b 168 -115 240 -86 174 -114 b 148 -91 158 -115 148 -107 l 148 43 b 167 85 148 55 156 81 b 240 114 180 91 240 114 b 258 138 249 118 258 128 l 258 240 b 246 252 258 248 252 252 b 240 251 245 252 242 252 b 168 225 240 251 171 225 b 150 253 156 225 150 240 l 150 426 b 130 442 150 435 141 442 b 105 418 108 442 105 429 l 105 230 b 91 193 105 219 101 202 b 17 161 65 183 42 171 b 0 138 9 158 0 147 l 0 36 b 12 23 0 27 4 23 b 17 24 13 23 16 24 b 85 53 17 24 73 49 b 89 55 86 53 88 55 b 107 30 98 55 107 42 l 107 -114 b 92 -145 107 -130 101 -143 l 17 -177 b 0 -200 9 -180 0 -192 l 0 -302 b 12 -315 0 -311 4 -315 z',
    },
    accidentalThreeQuarterTonesSharpStein: {
      x_min: 3,
      x_max: 317,
      y_min: -347,
      y_max: 369,
      ha: 716,
      o: 'm 14 -301 b 53 -287 16 -301 40 -291 b 62 -285 56 -285 59 -285 b 72 -298 69 -285 72 -289 l 72 -477 b 95 -500 72 -495 76 -500 b 118 -477 114 -500 118 -495 l 118 -278 b 127 -259 118 -269 121 -261 l 196 -232 b 207 -243 204 -232 207 -235 l 207 -432 b 230 -455 207 -452 212 -455 b 253 -432 249 -455 253 -451 l 253 -228 b 268 -204 253 -216 259 -207 l 320 -186 b 328 -183 323 -184 325 -183 b 337 -194 334 -183 337 -187 l 337 -387 b 360 -410 337 -408 341 -410 b 383 -387 379 -410 383 -406 l 383 -174 b 395 -157 383 -166 390 -158 l 445 -138 b 456 -127 452 -135 456 -132 l 456 -14 b 448 -3 456 -10 454 -3 b 399 -22 445 -3 408 -17 b 383 -6 387 -22 383 -22 l 383 163 b 392 181 383 173 384 179 b 445 202 397 183 445 202 b 456 213 452 203 456 207 l 456 324 b 448 336 456 330 454 336 b 393 317 445 336 400 320 b 389 315 392 315 390 315 b 383 325 386 315 383 318 l 383 508 b 360 531 383 528 379 531 b 337 508 341 531 337 527 l 337 318 b 325 291 337 300 334 294 b 268 268 320 288 287 276 b 253 281 256 268 253 274 l 253 464 b 230 487 253 484 249 487 b 207 464 212 487 207 482 l 207 264 b 194 240 207 253 204 245 l 132 217 b 128 216 131 217 130 216 b 118 229 122 216 118 220 l 118 420 b 95 444 118 439 114 444 b 72 420 76 444 72 439 l 72 212 b 60 190 72 197 68 193 l 16 173 b 4 161 9 170 4 167 l 4 50 b 13 39 4 45 9 39 b 58 55 16 39 46 49 b 63 56 60 56 62 56 b 72 42 71 56 72 50 l 72 -125 b 58 -150 72 -137 65 -147 l 16 -166 b 4 -177 9 -168 4 -171 l 4 -289 b 14 -301 4 -295 9 -301 z m 114 -48 b 118 78 114 6 115 68 b 200 114 122 91 180 114 b 207 111 204 114 206 112 b 212 22 210 107 212 66 b 207 -94 212 -29 210 -85 b 127 -130 203 -108 148 -130 b 118 -127 122 -130 120 -128 b 114 -48 114 -121 114 -86 z m 253 19 b 258 130 253 69 255 122 b 333 163 264 141 315 163 b 337 161 334 163 337 161 b 341 78 340 157 341 120 b 337 -45 341 24 340 -37 b 266 -78 333 -56 287 -78 b 258 -75 262 -78 259 -76 b 253 19 255 -71 253 -27 z',
    },
    accidentalBuyukMucennebFlat: {
      x_min: 1,
      x_max: 287,
      y_min: -174,
      y_max: 438,
      ha: 612,
      o: 'm 1 480 l 1 406 b 12 395 1 400 4 395 b 79 419 14 395 76 418 b 89 412 86 419 89 415 b 91 376 89 399 89 386 b 82 359 91 364 89 361 b 16 331 76 356 16 331 b 1 321 6 331 1 328 l 1 248 b 13 236 1 242 4 236 b 79 262 16 236 71 258 b 92 251 89 262 92 256 b 107 -242 95 23 101 -236 b 120 -251 111 -249 115 -251 b 128 -248 124 -251 128 -248 b 240 -160 171 -225 207 -184 b 413 84 367 -71 413 16 b 284 220 413 166 350 216 b 207 196 259 220 229 209 b 171 176 196 190 184 176 b 167 177 170 176 168 177 b 151 203 157 181 151 192 b 153 269 151 210 151 236 b 163 292 153 275 153 289 b 366 367 173 297 366 367 b 379 383 374 370 379 376 l 379 452 b 370 464 379 458 377 464 b 164 389 366 464 170 392 b 156 396 163 389 156 393 b 157 436 157 409 157 428 b 167 452 157 445 161 449 b 366 526 173 455 366 526 b 379 540 374 528 379 534 l 379 611 b 370 622 379 616 377 622 b 170 550 366 622 174 552 b 160 557 163 550 160 554 b 161 608 160 585 161 602 b 134 631 161 624 148 631 b 89 590 114 631 91 616 l 89 528 b 81 517 89 526 88 518 b 16 491 76 514 16 491 b 1 480 6 490 1 485 z m 154 73 b 219 135 160 92 197 124 b 255 144 232 141 243 144 b 292 130 269 144 282 140 b 314 62 305 114 314 91 b 186 -132 314 -17 251 -94 b 173 -137 180 -135 176 -137 b 157 -114 161 -137 157 -122 b 153 35 157 -114 153 -22 b 154 73 153 53 153 68 z',
    },
    accidentalBakiyeFlat: {
      x_min: -1,
      x_max: 286,
      y_min: -175,
      y_max: 439,
      ha: 614,
      o: 'm -1 248 b 9 236 -1 242 1 236 b 81 264 12 236 78 261 b 89 258 86 264 89 261 b 104 -245 92 30 96 -236 b 115 -252 108 -251 112 -252 b 124 -249 120 -252 124 -249 b 239 -161 167 -226 203 -186 b 412 84 367 -72 412 17 b 282 220 412 166 348 216 b 255 216 274 220 264 219 b 203 196 238 212 222 206 b 171 177 193 189 177 177 b 163 179 168 177 166 177 b 147 202 153 181 147 192 b 150 276 147 210 150 268 b 158 291 150 287 154 289 b 363 370 163 292 363 370 b 377 384 373 373 377 379 l 377 454 b 369 467 377 458 376 467 b 363 465 367 467 364 467 b 161 390 363 465 167 393 b 153 399 154 390 153 395 b 157 608 154 494 157 593 b 130 632 157 624 144 632 b 86 592 111 632 88 618 b 88 377 86 592 86 501 b 76 356 88 373 88 360 l 12 331 b -1 320 3 330 -1 327 z m 148 27 b 151 73 148 50 150 68 b 255 144 161 105 219 144 b 312 62 298 144 312 99 b 181 -134 312 -19 249 -96 b 167 -138 176 -137 171 -138 b 153 -117 156 -138 153 -125 b 148 27 153 -117 148 -30 z',
    },
    accidentalKomaSharp: {
      x_min: 0,
      x_max: 229,
      y_min: -337,
      y_max: 322,
      ha: 659,
      o: 'm 10 39 b 17 40 13 39 14 39 l 128 81 b 138 52 138 81 138 63 l 138 -91 b 124 -124 138 -107 132 -120 b 17 -167 115 -127 17 -167 b 0 -192 7 -171 0 -181 l 0 -294 b 10 -305 0 -301 4 -305 b 17 -304 13 -305 14 -305 b 127 -261 17 -304 117 -264 b 138 -276 138 -261 138 -262 l 138 -469 b 157 -485 138 -478 147 -485 b 181 -462 179 -485 181 -475 l 181 -262 b 183 -252 181 -258 181 -255 b 197 -232 186 -243 190 -235 b 312 -187 207 -228 312 -187 b 330 -163 323 -183 330 -173 l 330 -60 b 320 -49 330 -53 327 -49 b 312 -50 318 -49 315 -49 l 200 -94 b 193 -95 197 -95 194 -95 b 181 -68 183 -95 181 -85 l 181 66 b 200 108 181 92 189 104 l 312 151 b 330 176 323 156 330 166 l 330 278 b 320 289 330 285 327 289 b 312 288 318 289 315 289 b 200 246 312 288 203 248 b 181 275 187 246 181 264 l 181 448 b 163 464 181 456 173 464 b 138 441 140 464 138 452 l 138 253 b 122 215 137 240 132 225 b 17 177 92 203 45 177 b 0 153 7 173 0 163 l 0 50 b 10 39 0 43 4 39 z',
    },
    accidentalKucukMucennebSharp: {
      x_min: -1,
      x_max: 339,
      y_min: -338,
      y_max: 321,
      ha: 659,
      o: 'm -1 -45 l -1 -138 b 12 -154 -1 -145 3 -154 l 215 -79 b 220 -84 219 -79 220 -81 l 220 -105 b 210 -122 220 -115 219 -120 b 99 -168 202 -127 99 -168 b 82 -193 89 -173 82 -183 l 82 -295 b 92 -307 82 -302 86 -307 b 99 -305 95 -307 96 -307 b 209 -262 99 -305 199 -265 b 220 -278 220 -262 220 -264 l 220 -471 b 239 -487 220 -480 229 -487 b 264 -464 261 -487 264 -477 l 264 -264 b 265 -253 264 -259 264 -256 b 279 -233 268 -245 272 -236 b 395 -189 289 -229 395 -189 b 412 -164 405 -184 412 -174 l 412 -62 b 402 -50 412 -55 409 -50 b 395 -52 400 -50 397 -50 l 278 -96 b 264 -86 268 -96 264 -94 l 264 -68 b 269 -59 264 -62 265 -60 b 471 17 274 -58 471 17 b 488 36 484 22 488 27 l 488 127 b 477 144 488 134 487 144 b 471 141 475 144 472 141 l 471 143 b 274 68 471 143 282 71 b 268 66 272 68 269 66 b 264 71 264 66 264 69 l 264 92 b 271 102 264 98 265 99 l 395 150 b 412 174 405 154 412 164 l 412 276 b 402 288 412 284 409 288 b 395 287 400 288 397 288 b 282 245 395 287 285 246 b 264 274 269 245 264 262 l 264 446 b 245 462 264 455 255 462 b 220 439 222 462 220 451 l 220 252 b 204 213 219 239 215 223 b 99 176 174 202 127 176 b 82 151 89 171 82 161 l 82 49 b 92 37 82 42 86 37 b 99 39 95 37 96 37 l 210 79 b 216 81 212 81 215 81 b 220 78 219 81 220 79 l 220 56 b 216 46 220 52 220 48 b 16 -29 210 45 16 -29 b -1 -45 4 -32 -1 -36 z',
    },
    accidentalKoron: {
      x_min: 0,
      x_max: 300,
      y_min: -472,
      y_max: 157,
      ha: 629,
      o: 'm 0 -672 b 7 -680 0 -677 3 -680 l 45 -680 b 52 -672 49 -680 52 -677 l 52 -193 l 415 -22 b 432 -4 418 -20 432 -13 b 415 10 432 1 418 9 l 4 226 b 0 223 1 226 0 225 z m 327 -7 l 52 -137 l 52 144 z',
    },
    accidentalSori: {
      x_min: 0,
      x_max: 421,
      y_min: -318,
      y_max: 328,
      ha: 646,
      o: 'm 0 265 l 0 223 b 3 213 0 216 0 215 l 131 160 l 131 -150 l 3 -203 b 0 -212 0 -204 0 -206 l 0 -255 b 3 -259 0 -258 1 -259 l 131 -204 l 131 -451 b 138 -458 131 -455 134 -458 l 176 -458 b 183 -451 180 -458 183 -455 l 183 -183 l 330 -120 l 330 -410 b 337 -418 330 -415 333 -418 l 374 -418 b 382 -410 379 -418 382 -415 l 382 -98 l 589 -9 b 606 10 592 -9 606 0 b 589 23 606 16 592 22 l 382 109 l 382 465 b 374 472 382 469 379 472 l 337 472 b 330 465 333 472 330 469 l 330 132 l 183 194 l 183 425 b 176 432 183 429 180 432 l 138 432 b 131 425 134 432 131 429 l 131 216 l 3 269 b 0 265 0 269 0 266 z m 183 138 l 330 76 l 330 -66 l 183 -128 z m 501 6 l 382 -45 l 382 55 z',
    },
    articAccentAbove: {
      x_min: 0,
      x_max: 339,
      y_min: 1,
      y_max: 245,
      ha: 244,
      o: 'm 0 318 b 20 298 0 311 4 304 b 346 187 20 298 331 193 b 356 177 353 186 356 181 b 344 167 356 173 353 170 b 20 58 328 163 20 58 b 0 36 4 50 0 43 b 3 23 0 32 1 27 b 23 1 7 13 13 1 b 29 3 24 1 27 1 l 469 151 b 488 177 488 156 488 166 b 469 203 488 189 488 197 l 37 350 b 24 353 32 351 26 353 b 3 333 12 353 7 344 b 0 318 1 327 0 323 z',
    },
    articAccentBelow: {
      x_min: 0,
      x_max: 339,
      y_min: -244,
      y_max: 0,
      ha: 244,
      o: 'm 0 -35 b 20 -55 0 -42 4 -49 b 346 -166 20 -55 331 -160 b 356 -176 353 -167 356 -171 b 344 -186 356 -180 353 -183 b 20 -295 328 -190 20 -295 b 0 -317 4 -302 0 -310 b 3 -330 0 -321 1 -325 b 23 -351 7 -340 13 -351 b 29 -350 24 -351 27 -351 l 469 -202 b 488 -176 488 -197 488 -187 b 469 -150 488 -164 488 -156 l 37 -3 b 24 0 32 -1 26 0 b 3 -20 12 0 7 -9 b 0 -35 1 -26 0 -30 z',
    },
    articTenutoAbove: {
      x_min: -1,
      x_max: 338,
      y_min: 0,
      y_max: 48,
      ha: 48,
      o: 'm 33 0 l 452 0 b 487 35 485 0 487 16 b 452 69 487 53 487 69 l 33 69 b -1 35 -1 69 -1 53 b 33 0 -1 16 -1 0 z',
    },
    articTenutoBelow: {
      x_min: -1,
      x_max: 338,
      y_min: -48,
      y_max: 0,
      ha: 48,
      o: 'm 33 -69 l 452 -69 b 487 -35 485 -69 487 -53 b 452 0 487 -16 487 0 l 33 0 b -1 -35 -1 0 -1 -16 b 33 -69 -1 -53 -1 -69 z',
    },
    articStaccatoAbove: {
      x_min: 0,
      x_max: 84,
      y_min: 0,
      y_max: 84,
      ha: 84,
      o: 'm 60 0 b 121 60 94 0 121 27 b 60 121 121 94 94 121 b 0 60 27 121 0 94 b 60 0 0 27 27 0 z',
    },
    articStaccatoBelow: {
      x_min: 0,
      x_max: 84,
      y_min: -84,
      y_max: 0,
      ha: 84,
      o: 'm 60 -121 b 121 -60 94 -121 121 -94 b 60 0 121 -27 94 0 b 0 -60 27 0 0 -27 b 60 -121 0 -94 27 -121 z',
    },
    articStaccatissimoAbove: {
      x_min: 1,
      x_max: 100,
      y_min: -2,
      y_max: 293,
      ha: 295,
      o: 'm 1 390 b 72 -3 1 369 39 -3 b 144 389 108 -3 144 356 b 72 422 144 410 111 422 b 1 390 35 422 3 409 z',
    },
    articStaccatissimoBelow: {
      x_min: 1,
      x_max: 100,
      y_min: -295,
      y_max: 0,
      ha: 295,
      o: 'm 1 -393 b 72 -425 3 -412 35 -425 b 144 -392 111 -425 144 -413 b 72 0 144 -359 108 0 b 1 -393 39 0 1 -372 z',
    },
    articMarcatoAbove: {
      x_min: -1,
      x_max: 235,
      y_min: -1,
      y_max: 253,
      ha: 254,
      o: 'm -1 16 b 9 0 -1 9 1 1 b 16 -1 10 -1 14 -1 b 32 9 22 -1 29 1 b 112 186 32 9 109 180 b 118 190 114 189 115 190 b 127 186 121 190 124 189 b 209 9 128 180 209 9 b 225 0 213 3 219 0 l 323 0 b 338 16 333 1 338 7 b 337 23 338 19 338 22 l 181 356 b 167 364 177 361 173 364 b 153 356 157 364 153 356 l 0 23 b -1 16 -1 20 -1 19 z',
    },
    articMarcatoBelow: {
      x_min: -1,
      x_max: 235,
      y_min: -254,
      y_max: 0,
      ha: 254,
      o: 'm -1 -17 b 0 -24 -1 -20 -1 -23 l 156 -357 b 170 -366 160 -363 164 -366 b 184 -357 180 -366 184 -357 l 337 -24 b 338 -17 338 -22 338 -20 b 328 -1 338 -10 336 -3 b 321 0 327 0 323 0 b 305 -10 315 0 308 -3 b 225 -187 305 -10 228 -181 b 219 -192 223 -190 222 -192 b 210 -187 216 -192 213 -190 b 128 -10 209 -181 128 -10 b 112 -1 124 -4 118 -1 l 14 -1 b -1 -17 4 -3 -1 -9 z',
    },
    fermataAbove: {
      x_min: 3,
      x_max: 605,
      y_min: -3,
      y_max: 329,
      ha: 332,
      o: 'm 4 14 b 23 -4 4 0 12 -4 b 52 26 36 -4 43 6 b 56 39 53 27 55 33 b 435 318 73 98 138 318 b 818 36 742 318 804 91 b 821 26 819 32 819 27 b 851 -4 831 6 837 -4 b 871 16 864 -4 871 1 b 870 30 871 20 871 24 b 438 474 780 471 480 474 b 6 30 392 474 94 471 b 4 14 4 24 4 19 z m 359 75 b 436 -4 359 32 395 -4 b 516 75 480 -4 516 32 b 436 153 516 117 480 153 b 359 75 395 153 359 117 z',
    },
    fermataBelow: {
      x_min: 3,
      x_max: 605,
      y_min: -332,
      y_max: 0,
      ha: 332,
      o: 'm 6 -35 b 438 -478 94 -475 392 -478 b 870 -35 480 -478 780 -475 b 871 -20 871 -29 871 -24 b 851 0 871 -6 864 0 b 821 -30 837 0 831 -10 b 818 -40 819 -32 819 -36 b 435 -323 804 -95 742 -323 b 56 -43 138 -323 73 -102 b 52 -30 55 -37 53 -32 b 23 0 43 -10 36 0 b 4 -19 12 0 4 -4 b 6 -35 4 -23 4 -29 z m 436 -157 b 516 -79 480 -157 516 -121 b 436 0 516 -36 480 0 b 359 -79 395 0 359 -36 b 436 -157 359 -121 395 -157 z',
    },
    breathMarkComma: {
      x_min: 1,
      x_max: 152,
      y_min: 2,
      y_max: 251,
      ha: 249,
      o: 'm 1 271 b 82 190 1 222 35 190 b 122 160 118 190 122 160 b 125 144 124 154 125 150 b 102 88 125 124 115 105 b 37 32 78 56 40 35 b 26 19 32 29 26 26 b 27 14 26 17 27 16 b 37 3 29 6 33 3 b 181 102 85 3 158 66 b 219 239 210 147 219 197 l 219 249 b 104 361 219 317 170 361 b 1 271 42 361 1 321 z',
    },
    breathMarkUpbow: {
      x_min: 1,
      x_max: 249,
      y_min: 1,
      y_max: 495,
      ha: 494,
      o: 'm 1 690 b 3 683 1 687 1 685 l 154 22 b 181 1 157 10 167 1 b 206 22 193 1 203 10 l 359 683 l 359 688 b 338 713 359 700 351 710 l 333 713 b 308 694 321 713 311 706 l 180 140 l 53 694 b 27 713 49 706 39 713 l 22 713 b 1 690 10 710 1 700 z',
    },
    caesura: {
      x_min: 0,
      x_max: 384,
      y_min: -1,
      y_max: 532,
      ha: 533,
      o: 'm 258 1 b 271 -1 262 -1 266 -1 b 308 26 287 -1 302 9 l 552 713 b 553 726 553 717 553 721 b 513 766 553 747 534 766 b 475 739 495 766 481 756 l 232 52 b 230 39 230 48 230 43 b 258 1 230 23 240 7 z m 27 1 b 40 -1 32 -1 36 -1 b 78 26 58 -1 72 9 l 321 713 b 323 726 323 717 323 721 b 282 766 323 747 304 766 b 245 739 265 766 251 756 l 3 52 b 0 37 1 48 0 42 b 27 1 0 22 10 7 z',
    },
    caesuraCurved: {
      x_min: 0,
      x_max: 373,
      y_min: 0,
      y_max: 530,
      ha: 530,
      o: 'm 0 29 b 29 0 0 14 12 0 b 53 16 39 0 48 6 l 82 69 b 314 716 187 264 314 498 b 268 763 314 742 295 763 b 222 719 245 763 223 744 b 29 98 209 507 117 295 l 3 39 b 0 29 1 36 0 33 z m 223 27 b 252 0 223 13 233 0 b 276 16 262 0 272 6 b 537 716 386 230 537 478 b 491 763 537 742 518 763 b 445 719 468 763 446 744 b 252 98 432 507 340 295 l 226 39 b 223 27 225 35 223 32 z',
    },
    restMaxima: {
      x_min: 0,
      x_max: 381,
      y_min: -249,
      y_max: 250,
      ha: 499,
      o: 'm 369 331 l 369 -330 b 392 -359 369 -354 379 -359 l 524 -359 b 549 -330 539 -359 549 -354 l 549 331 b 524 360 549 356 539 360 l 392 360 b 369 331 379 360 369 356 z m 23 -359 l 156 -359 b 180 -330 170 -359 180 -354 l 180 331 b 156 360 180 356 170 360 l 23 360 b 0 331 10 360 0 356 l 0 -330 b 23 -359 0 -354 10 -359 z',
    },
    restDoubleWhole: {
      x_min: 0,
      x_max: 125,
      y_min: 0,
      y_max: 250,
      ha: 250,
      o: 'm 23 0 l 156 0 b 180 22 170 0 180 10 l 180 338 b 156 360 180 350 170 360 l 23 360 b 0 338 10 360 0 350 l 0 22 b 23 0 0 10 10 0 z',
    },
    restWhole: {
      x_min: 0,
      x_max: 282,
      y_min: -135,
      y_max: 9,
      ha: 144,
      o: 'm 37 -194 l 369 -194 b 406 -157 389 -194 406 -177 l 406 -24 b 369 13 406 -3 389 13 l 37 13 b 0 -24 16 13 0 -3 l 0 -157 b 37 -194 0 -177 16 -194 z',
    },
    restHalf: {
      x_min: 0,
      x_max: 282,
      y_min: -2,
      y_max: 142,
      ha: 144,
      o: 'm 37 -3 l 369 -3 b 406 35 389 -3 406 14 l 406 167 b 369 204 406 189 389 204 l 37 204 b 0 167 16 204 0 189 l 0 35 b 37 -3 0 14 16 -3 z',
    },
    restQuarter: {
      x_min: 1,
      x_max: 270,
      y_min: -375,
      y_max: 373,
      ha: 748,
      o: 'm 168 -527 b 206 -540 180 -536 194 -540 b 228 -531 216 -540 226 -537 b 230 -521 229 -527 230 -524 b 207 -487 230 -508 219 -497 b 170 -435 189 -487 173 -448 b 164 -397 166 -423 164 -410 b 255 -292 164 -338 194 -292 b 367 -317 297 -292 344 -308 b 372 -318 369 -317 370 -318 b 382 -320 376 -320 379 -320 b 389 -314 386 -320 389 -318 b 336 -232 389 -297 351 -249 b 236 -32 281 -166 236 -112 b 238 -13 236 -26 238 -19 b 333 199 243 71 295 140 b 338 220 337 206 338 213 b 333 248 338 235 333 248 b 95 526 333 248 120 501 b 69 537 88 533 78 537 b 40 507 55 537 40 527 b 46 484 40 500 42 492 b 134 291 52 468 134 395 b 48 108 134 238 112 176 b 27 66 33 94 27 78 b 42 32 27 46 42 32 l 112 -55 b 174 -141 135 -84 156 -111 b 183 -161 177 -147 183 -158 b 181 -167 183 -163 183 -166 b 166 -174 179 -173 173 -174 b 143 -170 160 -174 148 -171 b 120 -166 135 -170 127 -166 b 1 -304 58 -166 1 -228 b 168 -527 1 -376 63 -446 z',
    },
    rest8th: {
      x_min: 0,
      x_max: 247,
      y_min: -251,
      y_max: 174,
      ha: 425,
      o: 'm 39 81 b 117 56 62 65 89 56 b 173 66 137 56 157 60 b 225 88 193 72 206 78 b 232 89 228 89 230 89 b 239 76 238 89 239 84 b 238 60 239 72 239 66 b 104 -343 233 39 130 -248 b 145 -361 104 -360 137 -361 b 196 -347 161 -361 181 -359 b 341 161 200 -344 341 161 b 356 217 347 187 354 210 b 338 240 356 232 341 239 b 323 235 336 240 331 240 b 193 140 312 226 240 140 l 193 154 b 96 251 193 207 150 251 b 0 154 43 251 0 207 b 39 81 0 124 17 98 z',
    },
    rest16th: {
      x_min: 0,
      x_max: 320,
      y_min: -500,
      y_max: 179,
      ha: 679,
      o: 'm 115 -301 b 223 -271 153 -301 190 -288 b 229 -278 226 -271 229 -274 b 228 -282 229 -279 228 -281 l 91 -690 b 89 -694 91 -691 89 -693 b 134 -720 89 -706 102 -720 b 189 -687 176 -720 183 -703 l 356 -138 b 420 81 393 -16 420 81 b 459 226 420 81 456 207 b 461 232 459 229 461 230 b 446 248 461 240 449 246 b 431 242 439 248 435 245 b 300 145 420 233 348 147 l 300 160 b 202 258 300 215 256 258 b 104 160 148 258 104 215 b 219 62 104 101 164 62 b 331 94 258 62 298 75 b 341 96 336 95 338 96 b 348 86 346 96 348 94 b 265 -173 348 63 275 -151 b 194 -217 253 -200 215 -217 b 196 -203 196 -212 196 -207 b 98 -105 196 -148 151 -105 b 0 -203 43 -105 0 -148 b 115 -301 0 -262 60 -301 z',
    },
    rest32nd: {
      x_min: 0,
      x_max: 363,
      y_min: -500,
      y_max: 426,
      ha: 926,
      o: 'm 0 -203 b 115 -301 0 -262 60 -301 b 228 -269 154 -301 194 -288 b 232 -268 229 -268 230 -268 b 240 -276 236 -268 240 -272 b 138 -688 240 -282 141 -678 b 137 -697 137 -691 137 -694 b 176 -720 137 -708 145 -720 b 232 -690 222 -720 226 -706 b 484 436 236 -672 484 436 b 521 582 484 436 518 564 b 523 588 521 585 523 586 b 508 603 523 600 511 603 b 492 598 501 603 497 600 b 361 503 482 590 410 503 l 361 516 b 264 613 361 570 318 613 b 166 516 210 613 166 570 b 206 444 166 487 183 461 b 246 423 217 433 232 428 b 284 418 258 420 269 418 b 393 449 321 418 360 432 b 399 451 395 451 397 451 b 415 428 409 451 415 436 b 413 422 415 426 413 423 l 357 192 b 279 140 350 168 302 140 b 281 153 281 144 281 148 b 183 251 281 207 236 251 b 85 153 128 251 85 207 b 125 81 85 124 102 98 b 164 60 137 71 150 65 b 203 55 176 58 189 55 b 311 86 240 55 278 69 b 315 88 312 88 314 88 b 325 69 323 88 325 76 l 268 -167 b 194 -217 261 -197 216 -216 b 196 -203 196 -212 196 -207 b 98 -105 196 -148 153 -105 b 0 -203 45 -105 0 -148 z',
    },
    rest64th: {
      x_min: 0,
      x_max: 423,
      y_min: -753,
      y_max: 430,
      ha: 1183,
      o: 'm 0 -554 b 40 -626 0 -583 17 -609 b 118 -652 60 -644 92 -652 b 210 -629 145 -652 186 -642 b 216 -628 213 -628 215 -628 b 228 -644 223 -628 228 -635 b 226 -652 228 -647 226 -649 l 122 -1054 b 121 -1064 121 -1058 121 -1061 b 167 -1084 121 -1077 134 -1084 b 215 -1060 202 -1084 209 -1076 b 402 -278 217 -1047 229 -1021 b 436 -135 403 -278 431 -161 l 570 441 b 609 588 570 441 605 569 b 596 609 609 603 602 608 b 580 603 589 609 585 606 b 448 507 569 595 497 507 b 449 521 449 511 449 516 b 351 619 449 575 405 619 b 253 521 297 619 253 575 b 372 422 253 461 317 422 b 481 454 410 422 446 438 b 491 456 484 455 488 456 b 504 441 498 456 504 451 b 501 426 504 436 503 432 b 445 202 500 422 451 217 b 359 144 435 174 383 144 l 359 158 b 261 256 359 212 315 256 b 163 158 207 256 163 212 b 243 65 163 112 202 78 b 279 60 255 62 266 60 b 397 91 320 60 360 73 b 403 92 400 92 402 92 b 412 79 409 92 412 86 b 410 72 412 76 412 75 b 351 -161 408 59 356 -150 b 281 -212 340 -199 301 -212 l 281 -197 b 183 -99 281 -144 238 -99 b 85 -197 130 -99 85 -144 b 125 -271 85 -228 102 -253 b 166 -291 138 -279 151 -287 b 204 -297 177 -294 192 -297 b 262 -287 225 -297 245 -292 b 305 -265 282 -279 287 -274 b 310 -264 307 -264 308 -264 b 318 -284 317 -264 318 -275 b 317 -295 318 -288 317 -294 b 259 -524 315 -302 265 -508 b 194 -567 251 -554 213 -567 b 196 -554 196 -563 196 -559 b 98 -456 196 -500 153 -456 b 0 -554 45 -456 0 -500 z',
    },
    rest128th: {
      x_min: 0,
      x_max: 485,
      y_min: -750,
      y_max: 689,
      ha: 1439,
      o: 'm 118 -652 b 176 -642 138 -652 160 -648 b 180 -641 177 -642 179 -641 b 228 -621 197 -635 210 -629 b 232 -619 229 -621 230 -619 b 239 -626 236 -619 239 -622 b 238 -632 239 -628 239 -631 b 131 -1057 235 -642 134 -1050 b 173 -1080 131 -1071 140 -1080 b 230 -1057 219 -1080 225 -1074 l 658 815 b 697 960 658 815 694 942 b 698 966 697 963 698 965 b 684 982 698 975 687 981 b 668 976 677 982 672 979 b 537 880 658 969 586 881 l 537 894 b 439 992 537 949 494 992 b 341 894 386 992 341 949 b 382 822 341 865 359 840 b 459 796 402 805 433 796 b 517 806 480 796 501 801 b 521 808 518 806 520 808 b 569 828 539 814 552 819 b 580 831 572 829 577 831 b 598 812 589 831 598 825 b 596 801 598 809 598 805 b 540 575 590 773 546 595 b 448 510 534 553 475 510 l 448 524 b 350 622 448 577 405 622 b 252 524 297 622 252 577 b 292 451 252 494 269 468 b 369 426 318 433 337 426 b 429 435 389 426 412 429 b 494 464 449 442 475 455 b 498 465 495 465 497 465 b 505 446 504 465 505 456 b 503 426 505 439 504 432 l 446 202 b 366 144 439 173 389 144 l 366 158 b 268 256 366 212 323 256 b 170 158 215 256 170 212 b 289 59 170 98 235 59 b 347 69 310 59 330 63 b 397 91 367 76 379 82 b 406 94 400 92 403 94 b 415 79 412 94 415 88 b 412 63 415 75 413 69 b 357 -157 408 42 364 -134 b 281 -212 346 -196 302 -212 b 282 -197 281 -207 282 -203 b 184 -99 282 -144 238 -99 b 86 -197 130 -99 86 -144 b 204 -297 86 -258 150 -297 b 262 -287 225 -297 245 -292 b 312 -265 282 -279 294 -274 b 318 -264 314 -264 317 -264 b 327 -275 324 -264 327 -269 b 266 -517 324 -287 278 -490 b 200 -569 248 -566 220 -567 l 196 -554 b 98 -456 196 -500 153 -456 b 0 -554 45 -456 0 -500 b 118 -652 0 -615 63 -652 z',
    },
    dynamicPiano: {
      x_min: -89,
      x_max: 366,
      y_min: -142,
      y_max: 274,
      ha: 416,
      o: 'm -128 -187 b -111 -204 -128 -199 -122 -204 l 167 -204 b 186 -186 180 -204 186 -199 b 168 -168 186 -174 180 -168 l 111 -168 b 98 -164 102 -168 98 -168 b 101 -154 98 -163 99 -158 l 166 7 b 179 24 168 14 171 24 b 213 -1 186 24 190 10 b 276 -14 233 -12 252 -14 b 527 266 415 -14 527 130 b 395 395 527 350 475 395 b 292 357 350 395 318 380 b 262 328 272 340 268 328 b 246 363 255 328 259 338 b 177 393 236 380 215 393 b 1 251 92 393 46 333 b -9 223 -6 238 -9 230 b 7 207 -9 213 -1 207 b 30 229 17 207 23 216 b 127 338 72 301 101 338 b 143 321 138 338 143 331 b 134 285 143 310 138 295 l -43 -154 b -65 -168 -48 -166 -50 -168 l -109 -168 b -128 -187 -122 -168 -128 -174 z m 207 81 b 235 180 207 111 219 140 l 264 251 b 356 341 284 300 321 341 b 389 288 380 341 389 320 b 243 35 389 217 312 35 b 207 81 219 35 207 50 z',
    },
    dynamicMezzo: {
      x_min: -20,
      x_max: 446,
      y_min: -10,
      y_max: 274,
      ha: 284,
      o: 'm -29 223 b -13 207 -29 213 -22 207 b 9 226 -3 207 1 215 b 107 338 52 300 81 338 b 122 321 118 338 122 331 b 114 285 122 310 118 295 l 9 24 b 4 9 6 17 4 13 b 20 0 4 3 9 0 l 91 0 b 114 17 104 0 108 3 l 207 251 b 287 323 225 292 255 323 b 308 302 304 323 308 314 b 294 249 308 285 302 269 b 203 24 294 248 292 248 b 199 9 200 17 199 13 b 215 0 199 3 203 0 l 285 0 b 308 17 298 0 302 3 l 402 251 b 481 323 419 292 449 323 b 503 302 498 323 503 314 b 413 43 503 252 413 104 b 478 -14 413 6 436 -14 b 629 102 533 -14 583 26 b 642 132 638 117 642 125 b 629 145 642 141 636 145 b 608 127 619 145 615 138 b 534 49 580 84 553 49 b 523 62 526 49 523 53 b 606 317 523 112 606 238 b 528 395 606 353 588 395 b 431 350 487 395 454 374 b 409 330 416 336 415 330 b 397 360 402 330 406 341 b 334 395 389 379 370 395 b 236 350 292 395 259 374 b 215 330 222 336 220 330 b 203 360 207 330 212 340 b 147 393 194 379 174 393 b -19 251 71 393 26 331 b -29 223 -26 238 -29 230 z',
    },
    dynamicForte: {
      x_min: -141,
      x_max: 364,
      y_min: -152,
      y_max: 444,
      ha: 596,
      o: 'm -203 -122 b -95 -219 -203 -186 -156 -219 b 161 17 14 -219 82 -145 b 269 315 203 105 235 194 b 289 336 269 323 284 336 l 383 336 b 406 359 399 336 406 343 b 384 380 406 373 399 380 l 298 380 b 284 387 288 380 284 380 b 287 405 284 392 285 396 b 419 606 315 530 347 606 b 442 595 431 606 442 603 b 419 580 442 586 435 588 b 389 526 400 572 389 552 b 454 465 389 485 418 465 b 524 543 491 465 524 490 b 400 639 524 596 491 639 b 135 402 261 639 183 540 b 107 380 128 380 127 380 l 23 380 b 0 357 7 380 0 373 b 22 336 0 343 7 336 l 105 336 b 117 330 114 336 117 336 b 114 315 117 327 115 323 l 23 0 b -101 -187 -17 -141 -43 -187 b -127 -174 -120 -187 -127 -181 b -92 -156 -127 -163 -114 -170 b -63 -102 -75 -144 -63 -125 b -128 -43 -63 -65 -89 -43 b -203 -122 -171 -43 -203 -78 z',
    },
    dynamicRinforzando: {
      x_min: -20,
      x_max: 277,
      y_min: 0,
      y_max: 274,
      ha: 274,
      o: 'm -13 207 b 9 226 -3 207 3 215 b 107 338 52 301 81 338 b 122 321 118 338 122 331 b 114 285 122 310 118 295 l 9 24 b 4 9 6 17 4 13 b 20 0 4 3 9 0 l 91 0 b 114 17 104 0 108 3 l 207 251 b 304 351 226 298 272 351 b 318 343 312 351 318 348 b 287 285 318 330 287 325 b 338 239 287 256 308 239 b 399 318 373 239 399 268 b 324 395 399 360 377 395 b 235 350 287 395 256 374 b 215 330 222 336 220 330 b 203 360 207 330 213 337 b 145 393 194 379 174 393 b -19 251 75 393 27 337 b -29 223 -26 238 -29 230 b -13 207 -29 213 -22 207 z',
    },
    dynamicSforzando: {
      x_min: 0,
      x_max: 229,
      y_min: -10,
      y_max: 273,
      ha: 283,
      o: 'm 125 -14 b 291 120 219 -14 291 36 b 220 232 291 160 276 190 b 151 314 168 271 151 287 b 213 361 151 337 168 361 b 258 346 238 361 258 356 b 240 333 258 340 251 340 b 226 298 232 325 226 314 b 276 252 226 269 248 252 b 330 307 311 252 330 279 b 212 393 330 360 285 393 b 68 274 127 393 68 350 b 145 161 68 223 95 196 b 200 85 187 132 200 114 b 127 20 200 53 173 20 b 66 42 91 20 66 32 b 91 56 66 49 75 46 b 111 98 104 65 111 79 b 59 145 111 127 86 145 b 0 78 24 145 0 117 b 125 -14 0 30 49 -14 z',
    },
    dynamicZ: {
      x_min: -30,
      x_max: 244,
      y_min: -10,
      y_max: 268,
      ha: 278,
      o: 'm -24 -1 b 4 16 -12 -1 -3 10 b 39 30 16 24 27 30 b 179 -14 79 30 108 -14 b 297 102 259 -14 297 43 b 245 166 297 147 271 166 b 197 115 219 166 197 145 b 236 72 197 88 216 72 b 259 79 251 72 255 79 b 264 75 262 79 264 78 b 258 60 264 72 261 66 b 229 45 252 50 242 45 b 117 95 186 45 173 95 b 85 86 98 95 89 86 b 102 111 85 86 95 104 l 333 338 b 351 370 344 350 351 359 b 333 386 351 380 343 386 b 298 377 321 386 314 382 b 239 370 282 373 259 370 b 94 383 153 370 111 383 b 68 364 79 383 72 377 l 33 264 b 29 242 30 255 29 248 b 45 228 29 232 36 228 b 66 249 55 228 60 236 l 81 279 b 96 297 85 288 88 297 b 168 292 102 297 127 292 b 223 302 194 292 215 302 b 196 269 229 302 197 271 l -26 45 b -43 16 -37 33 -43 27 b -24 -1 -43 6 -36 -1 z',
    },
    ornamentTrill: {
      x_min: 0,
      x_max: 521,
      y_min: -10,
      y_max: 390,
      ha: 400,
      o: 'm 95 210 b 140 213 112 210 131 213 b 144 209 143 213 144 212 b 140 194 144 206 143 202 l 124 156 b 96 58 108 117 96 88 b 179 -14 96 17 124 -14 b 325 153 253 -14 325 46 b 307 251 325 187 320 219 b 302 265 304 258 302 261 b 334 294 302 274 311 281 l 343 298 b 455 348 393 328 428 348 b 474 327 468 348 474 344 b 465 285 474 312 469 295 l 360 24 b 356 9 357 17 356 13 b 372 0 356 3 360 0 l 442 0 b 465 17 455 0 459 3 l 559 251 b 655 351 577 298 624 351 b 670 343 664 351 670 348 b 638 285 670 330 638 325 b 690 239 638 256 660 239 b 750 318 724 239 750 268 b 675 395 750 360 729 395 b 586 350 638 395 608 374 b 566 330 573 336 572 330 b 553 361 559 330 564 340 b 490 393 543 380 521 393 b 347 348 432 393 377 364 b 312 333 328 338 320 333 b 308 337 310 333 308 334 b 315 359 308 343 312 351 l 387 537 b 392 553 390 544 392 549 b 383 562 392 559 389 562 b 364 557 377 562 369 559 l 294 534 b 269 511 281 530 275 526 l 217 384 b 206 367 212 370 210 367 b 179 380 200 367 192 374 b 118 393 158 389 140 393 b 0 292 50 393 0 353 b 95 210 0 248 30 210 z m 118 360 b 192 325 134 360 192 347 b 186 307 192 321 189 314 l 180 292 b 148 265 173 274 167 269 b 98 258 130 261 112 258 b 39 301 50 258 39 281 b 118 360 39 327 60 360 z m 196 48 b 207 92 196 59 202 78 b 264 230 207 94 209 94 b 272 240 266 238 268 240 b 279 229 276 240 276 236 b 292 151 279 204 292 177 b 212 30 292 88 253 30 b 196 48 200 30 196 37 z',
    },
    ornamentTurn: {
      x_min: 0,
      x_max: 460,
      y_min: 0,
      y_max: 218,
      ha: 218,
      o: 'm 0 148 b 128 0 0 45 66 0 b 209 63 173 0 209 20 b 157 115 209 95 187 115 b 84 82 115 115 114 82 b 36 150 59 82 36 112 b 130 242 36 212 79 242 b 285 134 176 242 223 203 b 513 1 356 56 419 1 b 662 166 608 1 662 73 b 534 314 662 269 596 314 b 454 251 490 314 454 294 b 505 199 454 219 475 199 b 579 232 547 199 549 232 b 626 164 603 232 626 202 b 533 72 626 102 583 72 b 377 180 487 72 439 111 b 150 312 307 258 243 312 b 0 148 55 312 0 240 z',
    },
    ornamentTurnSlash: {
      x_min: 0,
      x_max: 460,
      y_min: -90,
      y_max: 306,
      ha: 396,
      o: 'm 0 147 b 128 -1 0 43 66 -1 b 209 62 173 -1 209 19 b 157 114 209 94 187 114 b 84 81 115 114 114 81 b 36 148 59 81 36 111 b 130 240 36 210 79 240 b 285 128 176 240 222 197 b 307 79 304 108 307 105 l 307 -107 b 330 -130 307 -122 312 -130 b 353 -107 347 -130 353 -122 l 353 37 b 360 59 353 53 353 59 b 402 33 369 59 376 49 b 513 0 435 13 471 0 b 662 164 608 0 662 72 b 534 312 662 268 596 312 b 454 249 490 312 454 292 b 505 197 454 217 475 197 b 579 230 547 197 549 230 b 626 163 603 230 626 200 b 533 71 626 101 583 71 b 377 183 487 71 441 114 b 356 232 359 203 356 206 l 356 418 b 333 441 356 433 350 441 b 310 418 315 441 310 433 l 310 274 b 302 252 310 258 308 252 b 261 278 294 252 287 262 b 150 311 228 298 192 311 b 0 147 55 311 0 239 z',
    },
    ornamentMordent: {
      x_min: 1,
      x_max: 729,
      y_min: -73,
      y_max: 319,
      ha: 392,
      o: 'm 30 59 b 88 94 53 59 73 79 b 144 143 107 109 124 127 b 176 161 158 154 168 161 b 197 144 183 161 189 156 l 323 10 b 351 0 328 3 340 0 b 377 9 361 0 372 3 b 498 114 392 17 475 94 l 498 -105 l 544 -105 l 544 153 b 562 160 550 157 556 160 b 585 144 569 160 576 156 b 710 10 590 135 697 24 b 737 0 716 3 727 0 b 765 9 749 0 759 3 b 1030 295 776 17 1011 274 l 1032 300 b 1050 328 1041 308 1050 318 b 1012 353 1050 343 1024 353 b 986 343 1002 353 994 348 b 854 190 971 330 871 206 b 828 176 842 180 835 176 b 802 190 818 176 809 183 b 681 333 791 202 696 320 b 645 353 668 344 657 353 b 613 340 634 353 626 350 b 580 304 600 330 590 315 l 546 265 l 546 459 l 501 459 l 501 216 l 459 167 b 449 156 455 164 452 160 b 302 327 397 216 310 317 b 258 353 291 338 282 351 b 226 340 245 353 238 348 b 193 304 213 330 203 317 l 187 298 b 72 167 148 255 109 212 l 20 107 b 1 73 12 98 1 84 b 30 59 1 65 9 59 z',
    },
    ornamentShortTrill: {
      x_min: 0,
      x_max: 725,
      y_min: 0,
      y_max: 245,
      ha: 245,
      o: 'm 0 72 b 29 58 0 63 7 58 b 88 92 50 58 72 78 b 143 141 105 109 124 125 b 147 144 144 143 145 144 b 174 160 158 153 168 160 b 197 143 181 160 187 154 b 321 10 203 135 310 24 b 350 0 327 3 338 0 b 377 7 361 0 372 3 l 436 65 b 469 92 449 72 459 84 b 524 141 487 109 505 125 l 528 145 b 533 148 531 147 531 148 b 554 160 541 154 550 160 b 577 143 562 160 569 154 b 703 10 585 135 691 24 b 732 0 708 3 720 0 b 759 7 743 0 753 3 b 1024 294 769 16 1005 272 b 1044 327 1032 305 1044 321 b 1005 353 1044 341 1018 353 b 979 343 996 353 988 348 b 848 189 963 330 864 204 b 821 174 837 179 828 174 b 796 189 811 174 804 181 b 674 331 783 202 688 318 b 641 351 662 343 651 351 b 606 340 628 351 619 350 b 573 304 593 328 583 315 b 452 167 533 258 491 213 l 445 158 l 301 325 b 256 353 291 338 282 350 b 225 340 246 353 238 350 b 192 304 212 328 203 315 l 17 107 b 0 72 12 96 0 76 z',
    },
    ornamentTremblement: {
      x_min: 1,
      x_max: 985,
      y_min: 0,
      y_max: 244,
      ha: 244,
      o: 'm 1 72 b 30 58 1 63 9 58 b 89 92 52 58 73 78 l 144 141 b 148 144 147 143 147 144 b 176 160 160 153 170 160 b 199 143 183 160 189 154 b 324 10 204 134 311 23 b 351 0 330 3 340 0 b 379 7 363 0 373 3 b 488 111 386 13 446 72 b 520 141 498 122 508 132 b 524 144 521 143 523 144 b 552 160 536 153 546 160 b 575 143 559 160 564 154 b 698 10 580 134 687 23 b 727 0 704 3 716 0 b 755 7 739 0 749 3 l 899 141 b 930 160 913 153 923 160 b 952 143 937 160 943 154 l 1077 10 b 1107 0 1084 3 1096 0 b 1133 7 1117 0 1128 3 b 1398 294 1143 16 1380 272 b 1418 327 1407 305 1418 321 b 1381 351 1418 343 1394 351 b 1354 341 1371 351 1362 348 b 1223 189 1338 328 1238 204 b 1195 174 1211 179 1202 174 b 1171 189 1185 174 1178 181 b 1048 331 1158 200 1063 318 b 1012 351 1035 343 1024 351 b 981 338 1002 351 994 350 b 948 304 968 328 958 315 b 827 166 907 258 865 212 b 821 160 825 164 822 163 l 678 325 b 634 351 667 338 657 350 b 602 338 621 351 613 348 b 569 304 590 328 580 315 l 444 161 b 302 325 392 222 311 317 b 258 351 291 338 281 350 b 228 338 245 351 238 348 b 193 304 215 328 204 315 l 19 107 b 1 72 13 96 1 76 z',
    },
    ornamentPrecompAppoggTrill: {
      x_min: 0,
      x_max: 1119,
      y_min: 0,
      y_max: 481,
      ha: 481,
      o: 'm 121 0 b 249 68 168 0 232 53 b 279 94 262 75 271 86 b 336 144 298 111 315 128 b 367 163 350 156 360 163 b 389 145 374 163 380 157 b 514 12 395 137 501 26 b 543 1 520 4 531 1 b 569 9 553 1 563 4 b 636 73 576 14 605 43 l 658 94 b 714 144 677 111 694 128 b 746 163 729 156 739 163 b 768 145 753 163 759 157 b 893 12 773 137 880 26 b 922 1 899 4 910 1 b 948 9 932 1 942 4 l 1012 71 b 1037 94 1022 78 1030 86 b 1092 144 1054 111 1073 128 b 1123 161 1106 156 1115 161 b 1146 145 1130 161 1136 157 b 1270 12 1152 137 1259 26 b 1299 1 1276 4 1287 1 b 1326 9 1310 1 1320 4 b 1591 297 1336 19 1572 275 b 1611 328 1600 307 1611 320 b 1574 354 1611 343 1585 354 b 1548 344 1565 354 1555 350 b 1416 192 1532 331 1431 206 b 1388 177 1404 181 1395 177 b 1365 190 1380 177 1371 184 b 1243 333 1352 203 1256 321 b 1205 354 1228 346 1217 354 b 1174 341 1195 354 1187 351 b 1140 305 1161 330 1152 317 l 1015 163 b 873 328 963 223 880 318 b 828 354 860 344 847 353 b 796 341 816 354 809 351 b 763 305 783 331 773 317 b 642 168 721 261 681 215 b 636 163 641 167 639 164 b 494 328 585 223 501 318 b 449 354 481 344 468 353 b 418 341 438 354 431 351 b 384 305 405 331 395 317 b 264 168 343 261 302 215 l 242 144 b 144 88 232 124 171 88 b 79 197 81 88 79 189 l 79 648 b 60 693 79 683 71 693 b 52 691 58 693 55 693 b 0 616 3 672 0 625 l 0 207 b 121 0 0 40 68 0 z',
    },
    ornamentPrecompSlideTrillDAnglebert: {
      x_min: 2,
      x_max: 1150,
      y_min: -367,
      y_max: 245,
      ha: 612,
      o: 'm 3 -144 b 4 -168 3 -153 3 -160 b 246 -482 24 -315 99 -422 b 458 -528 340 -521 410 -528 b 514 -526 485 -528 504 -526 b 552 -508 531 -526 552 -517 b 514 -497 552 -503 541 -498 l 503 -497 b 194 -390 432 -494 298 -488 b 69 -151 194 -390 69 -279 b 184 96 69 -60 128 27 b 328 183 202 118 258 183 b 477 96 413 183 454 118 b 559 10 510 62 552 19 b 588 0 566 3 576 0 b 613 7 598 0 609 3 b 723 112 622 14 681 73 b 789 161 733 122 776 161 b 811 144 796 161 802 156 b 936 10 816 135 923 24 b 965 0 942 3 953 0 b 991 7 975 0 985 3 b 1051 66 996 12 1022 37 b 1081 92 1063 73 1073 84 b 1136 143 1099 109 1117 127 b 1168 160 1151 154 1159 160 b 1191 144 1175 160 1181 156 b 1315 10 1197 135 1303 24 b 1344 0 1320 3 1332 0 b 1371 7 1355 0 1365 3 b 1636 295 1381 17 1617 274 b 1656 327 1644 305 1656 318 b 1619 353 1656 341 1630 353 b 1593 343 1610 353 1600 348 b 1460 190 1577 330 1476 204 b 1433 176 1449 180 1440 176 b 1410 189 1424 176 1416 183 b 1287 331 1397 202 1300 320 b 1250 353 1273 344 1261 353 b 1218 340 1240 353 1231 350 b 1185 304 1205 328 1197 315 l 1058 160 b 916 327 1007 220 923 317 b 871 353 903 343 890 351 b 840 340 860 353 852 350 b 806 304 827 330 816 315 b 685 167 765 259 724 213 l 680 160 l 615 235 b 419 344 582 275 523 344 b 3 -144 258 344 3 26 z',
    },
    ornamentPrecompSlideTrillBach: {
      x_min: 0,
      x_max: 1048,
      y_min: -367,
      y_max: 331,
      ha: 698,
      o: 'm 0 -144 b 1 -168 0 -153 0 -160 b 243 -482 22 -315 96 -422 b 455 -528 337 -521 408 -528 b 511 -526 482 -528 501 -526 b 549 -508 528 -526 549 -517 b 511 -497 549 -503 539 -498 l 500 -497 b 192 -390 429 -494 295 -488 b 66 -151 127 -336 66 -238 b 189 105 66 -58 127 35 b 232 143 203 118 216 131 b 264 161 246 154 256 161 b 285 144 271 161 276 156 b 410 10 291 135 397 24 b 439 0 416 3 428 0 b 465 7 449 0 459 3 l 531 72 b 554 92 540 78 547 86 b 611 143 573 109 590 127 b 642 161 625 154 635 161 b 664 144 649 161 655 156 b 789 10 670 135 776 24 b 818 0 795 3 806 0 b 844 7 828 0 838 3 b 904 66 850 12 876 37 b 935 92 916 73 924 84 b 979 134 949 107 963 121 l 979 -88 l 1037 -88 l 1037 151 l 1044 144 b 1168 10 1050 135 1156 24 b 1197 0 1174 3 1185 0 b 1224 7 1208 0 1218 3 b 1489 295 1234 17 1470 274 b 1509 327 1498 305 1509 318 b 1472 353 1509 341 1483 353 b 1446 343 1463 353 1453 348 b 1313 190 1430 330 1329 204 b 1286 176 1302 180 1293 176 b 1263 189 1277 176 1269 183 b 1140 331 1250 202 1153 320 b 1103 353 1126 344 1115 353 b 1071 340 1093 353 1084 350 b 1038 304 1058 328 1050 315 l 1038 477 l 979 477 l 979 238 l 912 160 b 769 327 858 220 775 317 b 724 353 756 343 743 351 b 693 340 713 353 706 350 b 660 304 680 330 670 315 b 539 167 618 259 577 213 b 533 161 536 166 534 163 b 390 327 480 220 396 317 b 346 353 377 343 364 351 l 340 353 b 308 340 330 353 321 350 b 275 304 295 330 285 315 b 117 122 220 243 168 186 b 0 -144 68 62 0 -48 z',
    },
    ornamentPrecompTrillSuffixDandrieu: {
      x_min: 0,
      x_max: 949,
      y_min: 0,
      y_max: 381,
      ha: 381,
      o: 'm 0 73 b 29 58 0 65 7 58 b 86 92 56 59 72 79 b 143 143 105 109 122 127 b 174 161 157 154 167 161 b 196 144 181 161 187 156 b 321 10 202 135 308 24 b 350 0 327 3 338 0 b 376 7 360 0 370 3 b 485 112 384 14 444 73 b 552 161 495 122 539 161 b 573 144 559 161 564 156 b 698 10 579 135 685 24 b 727 0 704 3 716 0 b 753 7 737 0 747 3 b 863 112 762 14 821 73 b 929 161 873 122 916 161 b 950 144 936 161 942 156 b 1076 10 956 135 1063 24 b 1104 0 1081 3 1093 0 b 1130 7 1115 0 1125 3 b 1236 108 1139 14 1195 69 b 1367 314 1297 160 1367 233 b 1250 521 1367 419 1318 482 b 1107 549 1211 537 1145 549 b 1083 546 1096 549 1087 549 b 1066 528 1071 540 1066 534 b 1079 520 1066 524 1070 520 b 1323 351 1187 517 1323 487 b 1201 171 1323 269 1260 219 b 1194 166 1201 171 1198 168 b 1056 327 1142 226 1063 317 b 1011 353 1043 343 1030 351 b 979 340 999 353 992 350 b 946 304 966 330 956 315 b 825 167 904 259 864 213 l 821 161 b 678 327 768 222 685 317 b 634 353 665 343 652 351 b 602 340 622 353 615 350 b 569 304 589 330 579 315 b 448 167 527 259 487 213 l 444 161 b 301 327 390 222 308 317 b 256 353 288 343 275 351 b 225 340 245 353 238 350 b 192 304 212 330 202 315 b 71 167 150 259 109 213 b 17 105 52 147 36 127 b 0 73 10 98 0 84 z',
    },
    ornamentPrecompDoubleCadenceUpperPrefix: {
      x_min: 0,
      x_max: 1278,
      y_min: 0,
      y_max: 247,
      ha: 247,
      o: 'm 1 285 b 308 0 42 190 157 0 b 530 120 415 1 482 63 b 559 144 539 128 549 137 b 590 163 573 156 583 163 b 612 145 598 163 603 157 b 739 10 618 137 724 24 b 768 0 744 3 756 0 b 793 7 778 0 788 3 b 903 114 802 14 861 75 l 939 144 b 971 163 953 156 963 163 b 992 145 978 163 984 157 b 1119 10 998 137 1106 24 b 1148 0 1125 3 1136 0 b 1174 7 1158 0 1168 3 b 1284 114 1182 14 1241 75 b 1316 144 1282 115 1312 141 b 1348 161 1331 156 1339 161 b 1371 145 1355 161 1361 157 b 1496 10 1377 137 1485 24 b 1525 0 1502 3 1513 0 b 1552 7 1536 0 1547 3 b 1819 298 1562 17 1800 276 b 1840 330 1829 308 1840 320 b 1832 344 1840 334 1837 340 b 1801 356 1820 351 1810 356 b 1776 346 1793 356 1783 351 b 1642 192 1760 333 1659 206 b 1614 177 1630 181 1621 177 b 1591 190 1606 177 1597 184 b 1469 334 1578 203 1482 323 b 1430 356 1453 347 1441 356 b 1398 343 1420 356 1411 353 b 1365 307 1385 331 1377 318 l 1240 164 b 1097 330 1187 226 1104 320 b 1053 356 1084 346 1071 354 b 1021 343 1041 356 1034 353 b 988 307 1008 333 998 318 b 865 168 946 262 904 216 l 861 163 b 717 330 808 223 724 320 b 672 356 704 346 691 354 b 641 343 661 356 654 353 b 608 307 628 333 618 318 b 485 168 566 262 524 216 l 455 134 b 284 46 409 88 351 46 b 16 285 148 46 32 265 b 3 295 9 292 4 295 b 0 291 1 295 0 292 b 1 285 0 288 1 285 z',
    },
    ornamentPrecompDoubleCadenceUpperPrefixTurn: {
      x_min: 0,
      x_max: 1277,
      y_min: -62,
      y_max: 333,
      ha: 395,
      o: 'm 0 289 b 1 284 0 287 1 284 b 308 -1 42 189 157 -1 b 530 118 415 0 481 62 b 557 143 539 127 547 135 b 590 161 572 154 582 161 b 612 144 598 161 603 156 b 737 9 618 135 724 24 b 768 -1 743 1 755 -1 b 793 6 778 -1 788 1 b 903 112 802 13 861 73 l 937 143 b 971 161 953 154 963 161 b 992 144 978 161 984 156 b 1117 9 998 135 1104 24 b 1148 -1 1123 1 1136 -1 b 1174 6 1158 -1 1168 1 l 1230 60 l 1230 -89 l 1273 -89 l 1273 102 l 1283 112 b 1348 160 1295 125 1332 160 b 1371 144 1355 160 1361 156 b 1496 9 1377 135 1483 24 b 1525 -1 1502 1 1513 -1 b 1552 6 1536 -1 1547 1 b 1819 297 1562 16 1800 275 b 1839 328 1827 307 1839 320 b 1801 354 1839 343 1813 354 b 1776 344 1793 354 1783 350 b 1642 190 1760 331 1657 206 b 1614 176 1630 180 1621 176 b 1591 189 1606 176 1597 183 b 1467 333 1578 203 1480 321 b 1430 354 1453 346 1441 354 b 1398 341 1420 354 1411 351 b 1365 305 1385 330 1377 317 l 1273 202 l 1273 480 l 1230 480 l 1230 174 l 1097 328 b 1053 354 1084 344 1071 353 b 1021 341 1041 354 1034 351 b 988 305 1008 331 998 317 b 865 167 945 261 904 215 l 861 161 b 717 328 808 222 724 318 b 672 354 704 344 691 353 b 641 341 661 354 654 351 b 608 305 628 331 618 317 b 485 167 564 261 524 215 b 455 132 474 156 465 144 b 284 45 410 88 350 45 b 14 284 148 45 30 264 b 3 294 9 291 4 294 b 0 289 1 294 0 291 z',
    },
    ornamentPrecompTrillLowerSuffix: {
      x_min: 0,
      x_max: 859,
      y_min: -222,
      y_max: 246,
      ha: 468,
      o: 'm 0 73 b 29 58 0 65 7 58 b 86 92 56 59 72 79 b 143 143 105 109 122 127 b 176 161 157 154 168 161 b 197 144 183 161 189 156 b 323 9 203 135 310 23 b 353 -1 328 1 340 -1 b 379 6 363 -1 373 1 b 488 112 387 13 446 73 l 523 143 b 556 161 539 154 549 161 b 577 144 563 161 569 156 b 703 9 583 135 690 23 b 733 -1 708 1 721 -1 b 759 6 743 -1 753 1 b 868 112 768 13 827 73 b 955 183 878 122 943 183 b 1081 107 965 183 1031 153 b 1156 -89 1128 63 1156 6 l 1156 -102 b 948 -297 1156 -204 1048 -297 b 806 -271 904 -297 850 -282 l 792 -266 b 801 -288 792 -268 795 -282 b 948 -320 809 -297 880 -320 b 1237 -50 1092 -320 1237 -199 b 1164 217 1237 75 1218 122 b 1031 351 1138 259 1063 351 b 1011 337 1020 351 1024 347 b 828 167 952 291 886 217 l 824 164 b 683 328 772 225 690 318 b 638 354 670 344 657 353 b 606 341 626 354 619 351 b 573 305 593 331 583 317 b 451 167 530 261 490 215 l 446 161 b 302 328 393 222 310 318 b 258 354 289 344 276 353 b 226 341 246 354 239 351 b 193 305 213 331 203 317 b 71 167 150 261 109 215 b 17 105 52 147 36 127 b 0 73 10 98 0 84 z',
    },
    stringsDownBow: {
      x_min: 0,
      x_max: 312,
      y_min: 0,
      y_max: 318,
      ha: 318,
      o: 'm 17 0 l 37 0 b 55 17 46 0 55 7 l 55 253 b 225 278 55 269 140 278 b 395 253 310 278 395 269 l 395 17 b 413 0 395 7 403 0 l 432 0 b 449 17 441 0 449 7 l 449 420 b 412 458 449 441 432 458 l 37 458 b 0 420 17 458 0 441 l 0 17 b 17 0 0 7 9 0 z',
    },
    stringsUpBow: {
      x_min: 1,
      x_max: 249,
      y_min: 1,
      y_max: 495,
      ha: 494,
      o: 'm 1 690 b 3 683 1 687 1 685 l 154 22 b 181 1 157 10 167 1 b 206 22 193 1 203 10 l 359 683 l 359 688 b 338 713 359 700 351 710 l 333 713 b 308 694 321 713 311 706 l 180 140 l 53 694 b 27 713 49 706 39 713 l 22 713 b 1 690 10 710 1 700 z',
    },
    stringsHarmonic: {
      x_min: 0,
      x_max: 200,
      y_min: 0,
      y_max: 200,
      ha: 200,
      o: 'm 144 0 b 288 144 223 0 288 65 b 144 288 288 225 223 288 b 0 144 65 288 0 225 b 144 0 0 65 65 0 z m 39 144 b 144 249 39 203 86 249 b 249 144 203 249 249 203 b 144 39 249 86 203 39 b 39 144 86 39 39 86 z',
    },
    pluckedSnapPizzicatoAbove: {
      x_min: 0,
      x_max: 200,
      y_min: 0,
      y_max: 300,
      ha: 300,
      o: 'm 144 0 b 288 144 223 0 288 63 b 167 285 288 215 235 275 l 167 432 l 121 432 l 121 285 b 0 144 52 275 0 215 b 144 0 0 63 65 0 z m 39 144 b 121 246 39 193 73 236 l 121 144 l 167 144 l 167 246 b 249 144 213 236 249 193 b 144 39 249 85 202 39 b 39 144 85 39 39 85 z',
    },
    pluckedSnapPizzicatoBelow: {
      x_min: 0,
      x_max: 200,
      y_min: 0,
      y_max: 300,
      ha: 300,
      o: 'm 121 145 l 121 0 l 167 0 l 167 145 b 288 288 235 157 288 216 b 144 432 288 369 223 432 b 0 288 65 432 0 369 b 121 145 0 216 52 157 z m 39 288 b 144 393 39 347 86 393 b 249 288 203 393 249 347 b 167 186 249 238 215 196 l 167 288 l 121 288 l 121 186 b 39 288 75 196 39 238 z',
    },
    pluckedLeftHandPizzicato: {
      x_min: 0,
      x_max: 272,
      y_min: 0,
      y_max: 272,
      ha: 272,
      o: 'm 0 219 l 0 173 l 173 173 l 173 0 l 219 0 l 219 173 l 392 173 l 392 219 l 219 219 l 219 392 l 173 392 l 173 219 z',
    },
    keyboardPedalPed: {
      x_min: 0,
      x_max: 1019,
      y_min: -8,
      y_max: 555,
      ha: 563,
      o: 'm 122 376 b 240 540 189 376 240 452 b 225 586 240 579 233 586 b 204 549 213 586 212 573 b 138 480 199 527 181 480 b 85 549 96 480 85 517 l 85 554 b 353 762 89 690 230 762 b 373 752 364 762 373 760 b 351 708 373 740 360 723 b 274 546 330 675 274 585 b 353 416 274 508 333 444 b 412 304 372 390 412 351 b 382 228 412 275 403 256 b 334 190 363 202 361 200 b 147 29 271 167 147 88 b 196 -12 147 4 171 -12 b 343 108 239 -12 279 33 l 363 132 b 387 150 370 141 376 150 b 543 -4 445 150 467 -4 b 631 42 567 -4 586 0 l 668 78 b 685 89 674 84 680 89 b 696 75 688 89 690 86 b 809 -9 717 29 753 -9 b 946 66 854 -9 894 13 b 988 107 971 92 981 107 b 1002 89 994 107 996 99 b 1152 -4 1030 36 1077 -4 b 1329 248 1238 -4 1329 82 b 792 717 1329 556 1047 665 b 766 720 785 719 775 720 b 747 703 752 720 747 711 b 780 680 747 693 756 685 b 1223 222 1028 621 1223 504 b 1152 39 1223 122 1205 39 b 1073 229 1104 39 1073 132 b 1132 423 1073 314 1086 377 b 1142 442 1140 432 1142 436 b 1126 458 1142 451 1136 458 b 1093 446 1119 458 1109 455 b 975 216 1022 408 975 337 l 975 190 b 943 121 975 160 972 150 b 852 69 899 76 877 69 b 776 148 816 69 786 117 b 773 163 775 154 773 158 b 786 177 773 167 776 170 l 801 187 b 937 366 867 235 937 284 b 844 454 937 422 900 454 b 665 217 711 454 665 331 b 671 153 665 197 667 176 l 671 147 b 662 134 671 143 670 140 b 605 111 639 118 625 111 b 521 160 572 111 546 135 b 451 203 497 184 474 197 b 426 212 435 207 426 206 b 436 230 426 216 429 220 b 510 389 464 269 510 340 b 429 521 510 435 480 462 b 369 629 387 570 369 599 b 402 720 369 648 384 691 b 462 763 425 759 446 763 b 611 624 540 763 611 704 b 564 575 611 592 590 575 b 501 602 540 575 520 582 b 474 622 492 611 487 622 b 459 603 465 622 459 615 b 603 471 459 570 510 471 b 711 588 670 471 711 524 b 422 799 711 742 554 799 l 413 799 b 179 749 327 798 261 789 b 0 517 107 713 0 632 b 122 376 0 454 37 376 z m 1405 0 b 1467 62 1441 0 1467 26 b 1405 124 1467 98 1441 124 b 1344 62 1369 124 1344 98 b 1405 0 1344 26 1369 0 z m 756 282 b 815 403 756 346 772 403 b 848 343 838 403 848 383 b 780 226 848 295 824 261 b 765 217 773 220 768 217 b 759 228 762 217 759 220 b 756 282 757 245 756 262 z',
    },
    keyboardPedalUp: {
      x_min: 0,
      x_max: 450,
      y_min: 0,
      y_max: 450,
      ha: 450,
      o: 'm 66 252 b 132 281 94 252 115 264 b 183 308 153 301 161 308 l 190 308 b 236 271 216 308 236 300 b 216 239 236 261 229 252 l 210 233 b 158 219 197 220 184 219 b 73 147 114 219 73 196 b 147 73 73 107 107 73 b 219 158 196 73 219 114 b 233 210 219 184 220 197 l 239 216 b 271 236 252 229 261 236 b 308 190 300 236 308 216 l 308 183 b 281 132 308 161 301 153 b 252 66 264 115 252 94 b 324 0 252 23 285 0 b 396 66 363 0 396 23 b 367 132 396 94 384 115 b 340 183 347 153 340 161 l 340 190 b 377 236 340 216 348 236 b 409 216 387 236 396 229 l 415 210 b 429 158 428 197 429 184 b 501 73 429 114 452 73 b 575 147 541 73 575 107 b 490 219 575 196 534 219 b 438 233 464 219 451 220 l 432 239 b 412 271 419 252 412 261 b 458 308 412 300 432 308 l 465 308 b 516 281 487 308 495 301 b 582 252 533 264 554 252 b 648 324 625 252 648 285 b 582 396 648 363 625 396 b 516 367 554 396 533 384 b 465 340 495 347 487 340 l 458 340 b 412 377 432 340 412 348 b 432 409 412 387 419 396 l 438 415 b 490 429 451 428 464 429 b 575 501 534 429 575 452 b 501 575 575 541 541 575 b 429 490 452 575 429 534 b 415 438 429 464 428 451 l 409 432 b 377 412 396 419 387 412 b 340 458 348 412 340 432 l 340 465 b 367 516 340 487 347 495 b 396 582 384 533 396 554 b 324 648 396 625 363 648 b 252 582 285 648 252 625 b 281 516 252 554 264 533 b 308 465 301 495 308 487 l 308 458 b 271 412 308 432 300 412 b 239 432 261 412 252 419 l 233 438 b 219 490 220 451 219 464 b 147 575 219 534 196 575 b 73 501 107 575 73 541 b 158 429 73 452 114 429 b 210 415 184 429 197 428 l 216 409 b 236 377 229 396 236 387 b 190 340 236 348 216 340 l 183 340 b 132 367 161 340 153 347 b 66 396 115 384 94 396 b 0 324 23 396 0 363 b 66 252 0 285 23 252 z m 271 324 b 324 377 271 357 291 377 b 377 324 357 377 377 357 b 324 271 377 291 357 271 b 271 324 291 271 271 291 z',
    },
    pictChokeCymbal: {
      x_min: 1,
      x_max: 152,
      y_min: 2,
      y_max: 251,
      ha: 249,
      o: 'm 1 271 b 82 190 1 222 35 190 b 122 160 118 190 122 160 b 125 144 124 154 125 150 b 102 88 125 124 115 105 b 37 32 78 56 40 35 b 26 19 32 29 26 26 b 27 14 26 17 27 16 b 37 3 29 6 33 3 b 181 102 85 3 158 66 b 219 239 210 147 219 197 l 219 249 b 104 361 219 317 170 361 b 1 271 42 361 1 321 z',
    },
    wiggleArpeggiatoUp: {
      x_min: -33,
      x_max: 292,
      y_min: 0,
      y_max: 119,
      ha: 119,
      o: 'm -29 42 b -10 46 -23 42 -16 43 b 56 63 12 56 29 63 b 248 0 121 63 135 0 b 419 127 361 0 410 104 b 420 132 420 130 420 131 b 412 140 420 137 416 140 b 386 130 403 140 392 134 b 334 107 367 117 353 107 b 318 108 330 107 324 107 b 240 138 289 112 265 128 b 130 171 209 153 168 171 b -39 68 16 171 -14 91 b -48 53 -45 62 -48 58 b -29 42 -48 46 -39 42 z',
    },
    arrowheadBlackUp: {
      x_min: 0,
      x_max: 228,
      y_min: 0,
      y_max: 299,
      ha: 299,
      o: 'm 0 20 b 19 1 0 4 7 1 b 166 50 43 16 160 50 b 308 1 171 50 289 13 b 312 0 310 1 311 0 b 328 20 321 0 328 12 b 166 431 328 30 220 274 b 0 20 111 274 0 30 z',
    },
    arrowheadBlackDown: {
      x_min: 0,
      x_max: 228,
      y_min: 0,
      y_max: 299,
      ha: 299,
      o: 'm 166 0 b 328 410 220 157 328 400 b 312 431 328 419 321 431 b 308 429 311 431 310 429 b 166 380 289 418 171 380 b 19 429 160 380 43 415 b 0 410 7 429 0 426 b 166 0 0 400 111 157 z',
    },
    arpeggiatoUp: {
      x_min: 1,
      x_max: 229,
      y_min: 7,
      y_max: 1511,
      ha: 1504,
      o: 'm 121 1848 b 92 1778 115 1822 101 1800 l 89 1773 b 59 1668 75 1741 59 1702 b 96 1555 59 1614 76 1580 b 99 1551 98 1554 99 1551 l 102 1547 b 124 1496 115 1531 124 1515 b 122 1482 124 1492 124 1488 b 92 1404 118 1453 102 1428 b 59 1293 78 1372 59 1332 b 105 1172 59 1234 81 1198 b 124 1123 115 1158 124 1145 b 122 1110 124 1119 122 1115 b 92 1032 118 1081 102 1057 b 59 922 78 1001 59 960 b 115 792 59 855 86 816 b 124 760 121 782 124 773 b 122 744 124 756 124 750 b 92 667 118 716 102 693 b 59 556 78 635 59 595 b 108 433 59 495 82 458 b 124 389 117 420 124 408 b 122 374 124 384 124 379 b 92 298 118 346 102 323 l 89 292 b 59 186 75 261 59 222 b 163 19 59 73 140 42 b 177 10 168 13 173 10 b 189 29 184 10 189 19 b 184 48 189 35 187 42 b 167 114 174 69 167 85 b 230 305 167 179 229 193 b 181 423 230 357 209 396 b 167 484 173 442 167 458 b 230 675 167 547 229 563 b 179 796 230 729 206 769 b 167 850 171 812 167 827 b 230 1040 167 913 229 929 b 183 1158 230 1092 209 1130 b 167 1220 173 1178 167 1194 b 230 1411 167 1284 229 1300 b 186 1526 230 1462 210 1499 b 167 1594 176 1529 167 1584 b 230 1786 167 1659 229 1673 b 219 1848 230 1809 226 1829 l 330 1848 l 164 2176 l 1 1848 z',
    },
    arpeggiatoDown: {
      x_min: 1,
      x_max: 229,
      y_min: -4,
      y_max: 1500,
      ha: 1504,
      o: 'm 1 323 l 164 -6 l 330 323 l 219 323 b 230 384 226 341 230 361 b 167 576 229 497 167 511 b 186 644 167 586 176 641 b 230 759 210 671 230 708 b 167 950 229 870 167 886 b 183 1012 167 976 173 992 b 230 1130 209 1040 230 1079 b 167 1320 229 1241 167 1257 b 179 1374 167 1344 171 1358 b 230 1495 206 1401 230 1441 b 167 1686 229 1607 167 1623 b 181 1747 167 1712 173 1728 b 230 1865 209 1774 230 1813 b 167 2056 229 1977 167 1992 b 184 2123 167 2085 174 2101 b 189 2141 187 2128 189 2136 b 177 2160 189 2151 184 2160 b 163 2151 173 2160 168 2157 b 59 1984 140 2128 59 2097 b 89 1878 59 1948 75 1909 l 92 1872 b 122 1796 102 1848 118 1824 b 124 1781 124 1791 124 1786 b 108 1737 124 1763 117 1750 b 59 1614 82 1712 59 1675 b 92 1503 59 1575 78 1535 b 122 1426 102 1477 118 1454 b 124 1410 124 1420 124 1414 b 115 1378 124 1397 121 1388 b 59 1248 86 1354 59 1315 b 92 1138 59 1210 78 1169 b 122 1060 102 1113 118 1089 b 124 1047 122 1056 124 1051 b 105 998 124 1025 115 1012 b 59 877 81 972 59 936 b 92 766 59 838 78 798 b 122 688 102 742 118 717 b 124 674 124 683 124 678 b 102 624 124 655 115 639 l 99 619 b 96 615 99 619 98 616 b 59 503 76 590 59 556 b 89 397 59 468 75 429 l 92 392 b 121 323 101 370 115 348 z',
    },
    repeat1Bar: {
      x_min: 0,
      x_max: 532,
      y_min: -250,
      y_max: 279,
      ha: 529,
      o: 'm 0 -350 b 12 -360 0 -356 4 -360 l 154 -360 b 184 -340 167 -360 177 -348 l 759 380 b 766 395 763 386 766 390 b 757 402 766 399 763 402 l 605 402 b 579 380 596 402 589 393 l 4 -340 b 0 -350 1 -343 0 -347 z m 586 -161 b 675 -251 586 -210 626 -251 b 766 -161 726 -251 766 -210 b 675 -71 766 -111 726 -71 b 586 -161 626 -71 586 -111 z m 0 197 b 89 108 0 148 40 108 b 180 197 140 108 180 148 b 89 288 180 248 140 288 b 0 197 40 288 0 248 z',
    },
    repeat2Bars: {
      x_min: 0,
      x_max: 762,
      y_min: -250,
      y_max: 279,
      ha: 529,
      o: 'm 0 -350 b 12 -360 0 -356 4 -360 l 154 -360 b 184 -340 167 -360 177 -348 l 759 380 b 766 395 763 386 766 390 b 757 402 766 399 763 402 l 605 402 b 579 380 596 402 589 393 l 4 -340 b 0 -350 1 -343 0 -347 z m 343 -360 l 485 -360 b 516 -340 498 -360 508 -348 l 1090 380 b 1097 395 1094 386 1097 390 b 1089 402 1097 399 1094 402 l 936 402 b 910 380 927 402 920 393 l 336 -340 b 331 -350 333 -343 331 -347 b 343 -360 331 -356 336 -360 z m 917 -161 b 1007 -251 917 -210 958 -251 b 1097 -161 1057 -251 1097 -210 b 1007 -71 1097 -111 1057 -71 b 917 -161 958 -71 917 -111 z m 89 108 b 180 197 140 108 180 148 b 89 288 180 248 140 288 b 0 197 40 288 0 248 b 89 108 0 148 40 108 z',
    },
    repeat4Bars: {
      x_min: 0,
      x_max: 1232,
      y_min: -250,
      y_max: 279,
      ha: 529,
      o: 'm 331 -350 b 343 -360 331 -356 336 -360 l 485 -360 b 516 -340 498 -360 508 -348 l 1090 380 b 1097 395 1094 386 1097 390 b 1089 402 1097 399 1094 402 l 936 402 b 910 380 927 402 920 393 l 336 -340 b 331 -350 333 -343 331 -347 z m 1008 -350 b 1020 -360 1008 -356 1012 -360 l 1162 -360 b 1192 -340 1175 -360 1185 -348 l 1767 380 b 1774 395 1771 386 1774 390 b 1765 402 1774 399 1771 402 l 1613 402 b 1587 380 1604 402 1597 393 l 1012 -340 b 1008 -350 1009 -343 1008 -347 z m 688 -360 l 831 -360 b 861 -340 844 -360 854 -348 l 1436 380 b 1443 395 1440 386 1443 390 b 1434 402 1443 399 1440 402 l 1282 402 b 1256 380 1273 402 1266 393 l 681 -340 b 677 -350 678 -343 677 -347 b 688 -360 677 -356 681 -360 z m 0 -350 b 12 -360 0 -356 4 -360 l 154 -360 b 184 -340 167 -360 177 -348 l 759 380 b 766 395 763 386 766 390 b 757 402 766 399 763 402 l 605 402 b 579 380 596 402 589 393 l 4 -340 b 0 -350 1 -343 0 -347 z m 1683 -251 b 1774 -161 1734 -251 1774 -210 b 1683 -71 1774 -111 1734 -71 b 1594 -161 1634 -71 1594 -111 b 1683 -251 1594 -210 1634 -251 z m 0 197 b 89 108 0 148 40 108 b 180 197 140 108 180 148 b 89 288 180 248 140 288 b 0 197 40 288 0 248 z',
    },
    repeatBarSlash: {
      x_min: 0,
      x_max: 532,
      y_min: -250,
      y_max: 279,
      ha: 529,
      o: 'm 12 -360 l 154 -360 b 184 -340 167 -360 177 -348 l 759 380 b 766 395 763 386 766 390 b 757 402 766 399 763 402 l 605 402 b 579 380 596 402 589 393 l 4 -340 b 0 -350 1 -343 0 -347 b 12 -360 0 -356 4 -360 z',
    },
    csymDiminished: {
      x_min: 0,
      x_max: 473,
      y_min: 0,
      y_max: 473,
      ha: 473,
      o: 'm 0 341 b 341 0 0 153 153 0 b 681 341 530 0 681 153 b 341 681 681 530 530 681 b 0 341 153 681 0 530 z m 63 341 b 341 618 63 494 189 618 b 618 341 495 618 618 495 b 341 63 618 189 494 63 b 63 341 187 63 63 187 z',
    },
    csymHalfDiminished: {
      x_min: -16,
      x_max: 488,
      y_min: -15,
      y_max: 489,
      ha: 504,
      o: 'm 22 -22 l 122 79 b 340 0 181 30 258 0 b 680 341 528 0 680 153 b 602 559 680 423 651 500 l 703 660 l 658 704 l 557 603 b 340 681 498 652 422 681 b -1 341 151 681 -1 530 b 78 124 -1 259 29 183 l -23 23 z m 557 514 b 616 341 596 465 616 405 b 340 63 616 189 492 63 b 167 124 276 63 216 85 z m 340 618 b 513 559 403 618 464 598 l 122 168 b 62 341 84 217 62 278 b 340 618 62 494 187 618 z',
    },
    csymAugmented: {
      x_min: 0,
      x_max: 395,
      y_min: 1,
      y_max: 396,
      ha: 395,
      o: 'm 0 318 l 0 255 l 253 255 l 253 1 l 317 1 l 317 255 l 569 255 l 569 318 l 317 318 l 317 570 l 253 570 l 253 318 z',
    },
    csymMajorSeventh: {
      x_min: 0,
      x_max: 558,
      y_min: 1,
      y_max: 477,
      ha: 476,
      o: 'm 402 562 l 693 65 l 111 65 z m 402 687 l 0 1 l 804 1 z',
    },
    csymMinor: {
      x_min: 0,
      x_max: 325,
      y_min: 216,
      y_max: 260,
      ha: 44,
      o: 'm 468 374 l 0 374 l 0 311 l 468 311 z',
    },
    csymParensLeftTall: {
      x_min: 1,
      x_max: 185,
      y_min: 0,
      y_max: 997,
      ha: 997,
      o: 'm 259 1 b 264 0 261 0 262 0 b 266 9 265 0 266 6 l 266 48 b 261 65 266 55 264 62 b 92 719 157 212 92 400 b 262 1371 92 1037 154 1228 b 266 1394 266 1378 266 1394 l 266 1424 b 264 1436 266 1431 266 1436 b 259 1434 262 1436 259 1434 b 1 719 84 1261 1 1011 b 259 1 1 429 79 177 z',
    },
    csymParensRightTall: {
      x_min: -20,
      x_max: 164,
      y_min: 0,
      y_max: 997,
      ha: 997,
      o: 'm -29 1424 l -29 1394 b -24 1371 -29 1394 -29 1378 b 145 719 84 1228 145 1037 b -23 65 145 400 81 212 b -29 48 -26 62 -29 55 l -29 9 b -26 0 -29 6 -27 0 b -22 1 -24 0 -23 0 b 236 719 158 177 236 429 b -22 1434 236 1011 154 1261 b -26 1436 -22 1434 -24 1436 b -29 1424 -29 1436 -29 1431 z',
    },
    csymBracketLeftTall: {
      x_min: 0,
      x_max: 155,
      y_min: 0,
      y_max: 1000,
      ha: 1000,
      o: 'm 0 1436 l 0 4 b 6 0 0 1 3 0 l 217 0 b 223 9 220 0 223 4 l 223 37 b 217 46 223 42 220 46 l 92 46 l 92 1394 l 217 1394 b 223 1403 220 1394 223 1398 l 223 1431 b 217 1440 223 1436 220 1440 l 6 1440 b 0 1436 3 1440 0 1439 z',
    },
    csymBracketRightTall: {
      x_min: 1,
      x_max: 156,
      y_min: 0,
      y_max: 1000,
      ha: 1000,
      o: 'm 1 9 b 7 0 1 4 4 0 l 219 0 b 225 4 222 0 225 1 l 225 1436 b 219 1440 225 1439 222 1440 l 7 1440 b 1 1431 4 1440 1 1436 l 1 1403 b 7 1394 1 1398 4 1394 l 132 1394 l 132 46 l 7 46 b 1 37 4 46 1 42 z',
    },
    csymParensLeftVeryTall: {
      x_min: 0,
      x_max: 122,
      y_min: 0,
      y_max: 993,
      ha: 993,
      o: 'm 170 3 b 171 0 170 1 170 0 b 176 6 173 0 176 4 l 176 32 b 171 49 176 39 174 46 b 60 716 104 194 60 399 b 173 1382 60 1032 101 1241 b 176 1405 176 1390 176 1405 l 176 1427 b 173 1430 176 1428 174 1430 b 0 716 40 1297 0 978 b 170 3 0 428 50 179 z',
    },
    csymParensRightVeryTall: {
      x_min: -15,
      x_max: 107,
      y_min: 0,
      y_max: 993,
      ha: 993,
      o: 'm -22 1427 l -22 1405 b -19 1382 -22 1405 -22 1390 b 94 716 53 1241 94 1032 b -17 49 94 399 50 194 b -22 32 -20 46 -22 39 l -22 6 b -17 0 -22 4 -19 0 b -16 3 -16 0 -16 1 b 154 716 104 179 154 428 b -19 1430 154 978 114 1297 b -22 1427 -20 1430 -22 1428 z',
    },
    csymDiagonalArrangementSlash: {
      x_min: 0,
      x_max: 999,
      y_min: 0,
      y_max: 1000,
      ha: 1000,
      o: 'm 1439 1380 l 1377 1440 l 0 60 l 62 0 z',
    },
    brassScoop: {
      x_min: 1,
      x_max: 320,
      y_min: -373,
      y_max: 13,
      ha: 386,
      leftSideBearing: 1,
      advanceWidth: 318,
      o: 'm 1 -482 l 1 -505 b 26 -537 1 -526 3 -537 l 35 -537 b 461 -12 194 -518 461 -289 b 438 19 461 13 451 19 b 410 -9 425 19 413 9 b 35 -425 357 -366 92 -403 b 1 -482 13 -433 1 -438 z',
    },
    brassDoitMedium: {
      x_min: 0,
      x_max: 489,
      y_min: -40,
      y_max: 346,
      ha: 386,
      leftSideBearing: 0,
      advanceWidth: 490,
      o: 'm 0 -3 l 0 -26 b 24 -58 0 -46 1 -58 l 33 -58 b 704 468 255 -58 683 186 b 681 498 704 494 693 498 b 654 471 668 498 658 488 b 33 55 550 118 91 76 b 0 -3 12 46 0 42 z',
    },
    brassFallLipShort: {
      x_min: 1,
      x_max: 293,
      y_min: -345,
      y_max: 42,
      ha: 387,
      leftSideBearing: 1,
      advanceWidth: 293,
      o: 'm 1 35 l 1 6 b 26 -50 3 -40 10 -43 b 32 -52 27 -50 30 -50 b 376 -469 85 -73 327 -111 b 400 -497 379 -487 387 -497 b 422 -467 412 -497 422 -491 b 32 60 422 -187 177 40 l 22 60 b 1 35 4 60 1 52 z',
    },
    brassLiftMedium: {
      x_min: 0,
      x_max: 811,
      y_min: 0,
      y_max: 852,
      ha: 852,
      leftSideBearing: 0,
      advanceWidth: 812,
      o: 'm 33 0 b 49 17 40 0 49 10 b 71 63 52 35 56 49 b 212 115 102 95 154 59 b 239 186 230 134 239 160 b 236 210 239 194 238 202 b 256 249 239 225 243 236 b 397 301 288 281 340 245 b 425 372 416 320 425 346 b 422 396 425 380 423 387 b 442 435 425 410 429 422 b 583 487 474 467 526 431 b 611 557 602 505 611 531 b 608 582 611 566 609 573 b 628 621 611 596 615 608 b 769 672 660 652 711 618 b 796 743 788 691 796 717 b 793 768 796 752 795 759 b 814 806 796 782 801 793 b 955 858 845 838 897 804 b 982 929 973 877 982 903 b 979 953 982 937 981 945 b 999 992 982 968 986 979 b 1140 1045 1031 1024 1083 989 b 1168 1116 1161 1066 1168 1090 b 1138 1220 1168 1162 1145 1207 b 1135 1225 1135 1223 1135 1224 b 1129 1227 1133 1227 1130 1227 b 1117 1207 1122 1227 1117 1212 l 1117 1201 b 1109 1164 1117 1187 1117 1172 b 1100 1156 1107 1161 1104 1158 b 959 1104 1058 1128 995 1140 b 929 1032 936 1081 929 1056 b 932 1007 929 1024 930 1015 b 923 976 932 995 930 985 l 914 971 b 773 919 873 942 809 955 b 743 847 750 896 743 870 b 746 821 743 838 744 829 b 737 791 746 809 744 799 l 729 783 b 588 733 687 756 624 769 b 557 661 564 710 557 684 b 560 635 557 652 559 644 b 552 605 560 624 559 612 l 543 598 b 402 547 501 570 438 583 b 372 475 379 524 372 498 b 374 449 372 467 373 458 b 366 419 374 438 373 426 l 357 412 b 216 361 315 384 252 397 b 186 289 193 338 186 312 b 189 264 186 281 187 272 b 180 233 189 252 187 240 b 171 226 177 232 174 229 b 30 176 130 199 66 212 b 0 104 7 153 0 128 b 33 0 0 88 14 0 z',
    },
    brassFallRoughMedium: {
      x_min: 0,
      x_max: 811,
      y_min: 0,
      y_max: 852,
      ha: 852,
      leftSideBearing: 0,
      advanceWidth: 812,
      o: 'm 0 1116 b 27 1045 0 1090 7 1066 b 168 992 85 989 137 1024 b 189 953 181 979 186 968 b 186 929 187 945 186 937 b 213 858 186 903 194 877 b 354 806 271 804 323 838 b 374 768 367 793 372 782 b 372 743 373 759 372 752 b 399 672 372 717 380 691 b 540 621 456 618 508 652 b 560 582 553 608 557 596 b 557 557 559 573 557 566 b 585 487 557 531 566 505 b 726 435 642 431 694 467 b 746 396 739 422 743 410 b 743 372 744 387 743 380 b 770 301 743 346 752 320 b 912 249 828 245 880 281 b 932 210 924 236 929 225 b 929 186 930 202 929 194 b 956 115 929 160 937 134 b 1097 63 1014 59 1066 95 b 1119 17 1112 49 1116 35 b 1135 0 1119 10 1128 0 b 1168 104 1153 0 1168 91 b 1138 176 1168 128 1161 153 b 996 226 1102 212 1038 199 b 988 233 994 229 991 232 b 979 264 981 240 979 252 b 982 289 981 272 982 281 b 952 361 982 312 975 338 b 811 412 916 397 852 384 l 802 419 b 793 449 795 426 793 438 b 796 475 795 458 796 467 b 766 547 796 498 789 524 b 625 598 730 583 667 570 l 616 605 b 608 635 609 612 608 624 b 611 661 609 644 611 652 b 580 733 611 684 603 710 b 439 783 544 769 481 756 l 431 791 b 422 821 423 799 422 809 b 425 847 423 829 425 838 b 395 919 425 870 418 896 b 253 971 359 955 295 942 l 245 976 b 236 1007 238 985 236 995 b 239 1032 238 1015 239 1024 b 209 1104 239 1056 232 1081 b 68 1156 173 1140 109 1128 b 59 1164 63 1158 60 1161 b 50 1201 50 1172 50 1187 l 50 1207 b 39 1227 50 1212 46 1227 b 33 1225 37 1227 35 1227 b 30 1220 33 1224 33 1223 b 0 1116 23 1207 0 1162 z',
    },
    brassBend: {
      x_min: 0,
      x_max: 392,
      y_min: 0,
      y_max: 282,
      ha: 282,
      leftSideBearing: 0,
      advanceWidth: 393,
      o: 'm 13 72 b 282 0 108 23 196 0 b 552 72 369 0 456 23 b 564 92 560 75 564 84 l 564 383 b 541 406 564 395 554 406 b 518 383 528 406 518 395 l 518 107 b 282 46 435 65 357 46 b 46 107 207 46 130 65 l 46 383 b 23 406 46 395 36 406 b 0 383 10 406 0 395 l 0 92 b 13 72 0 84 4 75 z',
    },
    brassMuteClosed: {
      x_min: 0,
      x_max: 272,
      y_min: 0,
      y_max: 272,
      ha: 272,
      leftSideBearing: 0,
      advanceWidth: 272,
      o: 'm 0 219 l 0 173 l 173 173 l 173 0 l 219 0 l 219 173 l 392 173 l 392 219 l 219 219 l 219 392 l 173 392 l 173 219 z',
    },
    brassMuteOpen: {
      x_min: 0,
      x_max: 304,
      y_min: 0,
      y_max: 304,
      ha: 304,
      leftSideBearing: 0,
      advanceWidth: 305,
      o: 'm 0 219 b 219 0 0 98 98 0 b 438 219 340 0 438 98 b 219 438 438 340 340 438 b 0 219 98 438 0 340 z m 219 392 b 392 219 314 392 392 314 b 219 46 392 124 314 46 b 46 219 124 46 46 124 b 219 392 46 314 124 392 z',
    },
    brassFlip: {
      x_min: 0,
      x_max: 379,
      y_min: 0,
      y_max: 282,
      ha: 282,
      leftSideBearing: 0,
      advanceWidth: 379,
      o: 'm 23 0 b 46 23 36 0 46 10 l 46 337 l 508 4 b 523 0 513 1 517 0 b 541 9 530 0 536 3 b 546 22 544 13 546 17 b 536 42 546 29 541 36 l 36 402 b 23 406 33 405 27 406 b 0 383 12 406 0 395 l 0 23 b 23 0 0 10 10 0 z',
    },
    brassJazzTurn: {
      x_min: 0,
      x_max: 620,
      y_min: 0,
      y_max: 245,
      ha: 245,
      leftSideBearing: 0,
      advanceWidth: 620,
      o: 'm 0 121 b 16 107 0 114 4 108 b 84 143 26 107 76 137 b 118 160 92 150 108 160 b 141 143 125 160 131 154 b 265 10 147 135 253 24 b 294 0 271 3 282 0 b 321 7 305 0 315 3 b 498 160 321 7 478 158 b 521 143 505 160 513 154 b 647 10 528 135 635 24 b 675 0 652 3 664 0 b 703 7 687 0 697 3 b 874 186 713 16 855 164 b 893 220 881 196 893 212 b 873 245 890 235 883 243 b 796 194 847 245 815 213 l 792 190 b 765 176 780 179 772 176 b 740 190 755 176 747 183 b 629 325 727 202 644 312 b 593 347 616 338 605 347 b 562 334 583 346 575 344 b 528 298 549 323 539 310 l 406 176 b 389 168 406 176 399 168 b 374 176 384 168 379 170 b 245 325 360 192 245 325 b 200 353 232 343 219 351 b 168 340 190 353 181 350 l 17 156 b 0 121 10 147 0 132 z',
    },
    brassSmear: {
      x_min: 1,
      x_max: 306,
      y_min: 0,
      y_max: 170,
      ha: 170,
      leftSideBearing: 1,
      advanceWidth: 307,
      o: 'm 7 107 b 36 122 13 107 22 112 b 92 151 55 137 65 151 b 183 89 125 151 161 112 b 189 84 184 88 187 86 l 193 79 b 308 0 219 50 264 0 b 439 117 396 0 438 102 b 441 128 439 121 441 124 b 433 141 441 135 439 141 b 416 130 429 141 423 137 b 343 94 390 107 370 94 b 269 153 315 94 294 121 l 265 158 b 144 245 239 190 180 245 b 6 134 62 245 10 143 b 1 114 3 125 1 118 b 7 107 1 108 4 107 z',
    },
    accSagittal5v7KleismaUp: {
      x_min: 0,
      x_max: 156,
      y_min: -359,
      y_max: 172,
      ha: 531,
      o: 'm 0 -517 l 45 -517 l 45 -35 b 135 -112 68 -86 99 -112 b 225 68 194 -112 225 -53 l 180 68 b 144 -4 180 20 168 -4 b 122 0 138 -4 131 -3 b 23 248 86 14 52 96 l 0 248 z',
    },
    accSagittal5v7KleismaDown: {
      x_min: 0,
      x_max: 156,
      y_min: -172,
      y_max: 359,
      ha: 531,
      o: 'm 0 517 l 45 517 l 45 35 b 135 112 68 86 99 112 b 225 -68 194 112 225 53 l 180 -68 b 144 4 180 -20 168 4 b 122 0 138 4 131 3 b 23 -248 86 -14 52 -96 l 0 -248 z',
    },
    accSagittal5CommaUp: {
      x_min: 0,
      x_max: 156,
      y_min: -359,
      y_max: 172,
      ha: 531,
      o: 'm 225 -517 l 225 248 l 203 248 l 0 -112 l 0 -284 l 180 33 l 180 -517 z',
    },
    accSagittal5CommaDown: {
      x_min: 0,
      x_max: 156,
      y_min: -172,
      y_max: 359,
      ha: 531,
      o: 'm 225 517 l 225 -248 l 203 -248 l 0 112 l 0 284 l 180 -33 l 180 517 z',
    },
    accSagittal7CommaUp: {
      x_min: 0,
      x_max: 156,
      y_min: -359,
      y_max: 172,
      ha: 531,
      o: 'm 0 248 l 0 -517 l 45 -517 l 45 112 l 89 112 b 180 -68 150 112 180 53 l 180 -248 l 225 -248 l 225 68 b 135 248 225 187 194 248 z',
    },
    accSagittal7CommaDown: {
      x_min: 0,
      x_max: 156,
      y_min: -172,
      y_max: 359,
      ha: 531,
      o: 'm 0 -248 l 0 517 l 45 517 l 45 -112 l 89 -112 b 180 68 150 -112 180 -53 l 180 248 l 225 248 l 225 -68 b 135 -248 225 -187 194 -248 z',
    },
    accSagittal25SmallDiesisUp: {
      x_min: 0,
      x_max: 250,
      y_min: -359,
      y_max: 172,
      ha: 531,
      o: 'm 0 -157 l 0 -259 l 315 -89 l 315 -517 l 360 -517 l 360 248 l 337 248 l 0 68 l 0 -33 l 315 135 l 315 10 z',
    },
    accSagittal25SmallDiesisDown: {
      x_min: 0,
      x_max: 250,
      y_min: -172,
      y_max: 359,
      ha: 531,
      o: 'm 0 157 l 0 259 l 315 89 l 315 517 l 360 517 l 360 -248 l 337 -248 l 0 -68 l 0 33 l 315 -135 l 315 -10 z',
    },
    accSagittal35MediumDiesisUp: {
      x_min: 0,
      x_max: 281,
      y_min: -359,
      y_max: 172,
      ha: 531,
      o: 'm 0 -284 l 180 33 l 180 -517 l 225 -517 l 225 112 l 271 112 b 360 -68 330 112 360 53 l 360 -248 l 405 -248 l 405 68 b 315 248 405 187 374 248 l 203 248 l 0 -112 z',
    },
    accSagittal35MediumDiesisDown: {
      x_min: 0,
      x_max: 281,
      y_min: -172,
      y_max: 359,
      ha: 531,
      o: 'm 0 284 l 180 -33 l 180 517 l 225 517 l 225 -112 l 271 -112 b 360 68 330 -112 360 -53 l 360 248 l 405 248 l 405 -68 b 315 -248 405 -187 374 -248 l 203 -248 l 0 112 z',
    },
    accSagittal11MediumDiesisUp: {
      x_min: 0,
      x_max: 344,
      y_min: -359,
      y_max: 172,
      ha: 531,
      o: 'm 225 53 l 225 -517 l 271 -517 l 271 53 l 495 -248 l 495 -89 l 248 248 l 0 -89 l 0 -248 z',
    },
    accSagittal11MediumDiesisDown: {
      x_min: 0,
      x_max: 344,
      y_min: -172,
      y_max: 359,
      ha: 531,
      o: 'm 225 -53 l 225 517 l 271 517 l 271 -53 l 495 248 l 495 89 l 248 -248 l 0 89 l 0 248 z',
    },
    accSagittal11LargeDiesisUp: {
      x_min: 0,
      x_max: 344,
      y_min: -359,
      y_max: 172,
      ha: 531,
      o: 'm 0 68 l 0 -248 l 45 -248 l 45 -68 b 180 112 45 53 89 112 l 225 112 l 225 -517 l 271 -517 l 271 112 l 315 112 b 449 -68 405 112 449 53 l 449 -248 l 495 -248 l 495 68 b 360 248 495 187 449 248 l 135 248 b 0 68 45 248 0 187 z',
    },
    accSagittal11LargeDiesisDown: {
      x_min: 0,
      x_max: 344,
      y_min: -172,
      y_max: 359,
      ha: 531,
      o: 'm 0 -68 l 0 248 l 45 248 l 45 68 b 180 -112 45 -53 89 -112 l 225 -112 l 225 517 l 271 517 l 271 -112 l 315 -112 b 449 68 405 -112 449 -53 l 449 248 l 495 248 l 495 -68 b 360 -248 495 -187 449 -248 l 135 -248 b 0 -68 45 -248 0 -187 z',
    },
    accSagittal35LargeDiesisUp: {
      x_min: 0,
      x_max: 375,
      y_min: -359,
      y_max: 172,
      ha: 531,
      o: 'm 0 -248 l 45 -248 l 45 -68 b 180 112 45 53 89 112 l 225 112 l 225 -517 l 271 -517 l 271 58 l 540 -274 l 540 -112 l 248 248 l 135 248 b 0 68 45 248 0 187 z',
    },
    accSagittal35LargeDiesisDown: {
      x_min: 0,
      x_max: 375,
      y_min: -172,
      y_max: 359,
      ha: 531,
      o: 'm 0 248 l 45 248 l 45 68 b 180 -112 45 -53 89 -112 l 225 -112 l 225 517 l 271 517 l 271 -58 l 540 274 l 540 112 l 248 -248 l 135 -248 b 0 -68 45 -248 0 -187 z',
    },
    accSagittalSharp25SDown: {
      x_min: 0,
      x_max: 344,
      y_min: -359,
      y_max: 172,
      ha: 531,
      o: 'm 0 68 b 112 -112 0 -53 36 -112 l 135 -112 l 135 -517 l 180 -517 l 180 -89 b 248 26 206 -65 229 -27 b 315 -89 264 -27 287 -65 l 315 -517 l 360 -517 l 360 -112 l 383 -112 b 495 68 458 -112 495 -53 l 449 68 b 399 -4 449 20 433 -4 b 248 248 297 -4 261 171 b 122 0 216 96 176 14 b 94 -4 112 -3 102 -4 b 45 68 60 -4 45 20 z',
    },
    accSagittalFlat25SUp: {
      x_min: 0,
      x_max: 344,
      y_min: -172,
      y_max: 359,
      ha: 531,
      o: 'm 0 -68 b 112 112 0 53 36 112 l 135 112 l 135 517 l 180 517 l 180 89 b 248 -26 206 65 229 27 b 315 89 264 27 287 65 l 315 517 l 360 517 l 360 112 l 383 112 b 495 -68 458 112 495 53 l 449 -68 b 399 4 449 -20 433 4 b 248 -248 297 4 261 -171 b 122 0 216 -96 176 -14 b 94 4 112 3 102 4 b 45 -68 60 4 45 -20 z',
    },
    accSagittalSharp7CDown: {
      x_min: 0,
      x_max: 250,
      y_min: -359,
      y_max: 172,
      ha: 531,
      o: 'm 0 -517 l 45 -517 l 45 112 l 89 112 b 180 104 124 112 154 109 l 180 -517 l 225 -517 l 225 89 b 315 -68 285 60 315 9 l 315 -248 l 360 -248 l 360 68 b 135 248 360 187 285 248 l 0 248 z',
    },
    accSagittalFlat7CUp: {
      x_min: 0,
      x_max: 250,
      y_min: -172,
      y_max: 359,
      ha: 531,
      o: 'm 0 517 l 45 517 l 45 -112 l 89 -112 b 180 -104 124 -112 154 -109 l 180 517 l 225 517 l 225 -89 b 315 68 285 -60 315 -9 l 315 248 l 360 248 l 360 -68 b 135 -248 360 -187 285 -248 l 0 -248 z',
    },
    accSagittalSharp5CDown: {
      x_min: 0,
      x_max: 281,
      y_min: -359,
      y_max: 172,
      ha: 531,
      o: 'm 45 -517 l 45 71 l 180 -56 l 180 -517 l 225 -517 l 225 -98 l 405 -268 l 405 -112 l 23 248 l 0 248 l 0 -517 z',
    },
    accSagittalFlat5CUp: {
      x_min: 0,
      x_max: 281,
      y_min: -172,
      y_max: 359,
      ha: 531,
      o: 'm 45 517 l 45 -71 l 180 56 l 180 517 l 225 517 l 225 98 l 405 268 l 405 112 l 23 -248 l 0 -248 l 0 517 z',
    },
    accSagittalSharp5v7kDown: {
      x_min: 0,
      x_max: 344,
      y_min: -359,
      y_max: 172,
      ha: 531,
      o: 'm 0 -112 l 0 -276 l 135 -82 l 135 -517 l 180 -517 l 180 -17 l 271 112 l 315 112 l 315 -517 l 360 -517 l 360 107 b 449 -68 420 89 449 30 l 449 -248 l 495 -248 l 495 68 b 360 248 495 189 449 248 l 248 248 z',
    },
    accSagittalFlat5v7kUp: {
      x_min: 0,
      x_max: 344,
      y_min: -172,
      y_max: 359,
      ha: 531,
      o: 'm 0 112 l 0 276 l 135 82 l 135 517 l 180 517 l 180 17 l 271 -112 l 315 -112 l 315 517 l 360 517 l 360 -107 b 449 68 420 -89 449 -30 l 449 248 l 495 248 l 495 -68 b 360 -248 495 -189 449 -248 l 248 -248 z',
    },
    accSagittalSharp: {
      x_min: 0,
      x_max: 406,
      y_min: -359,
      y_max: 172,
      ha: 531,
      o: 'm 180 -53 l 180 -517 l 225 -517 l 225 0 l 292 85 l 360 0 l 360 -517 l 405 -517 l 405 -53 l 585 -274 l 585 -112 l 292 248 l 0 -112 l 0 -274 z',
    },
    accSagittalFlat: {
      x_min: 0,
      x_max: 406,
      y_min: -172,
      y_max: 359,
      ha: 531,
      o: 'm 180 53 l 180 517 l 225 517 l 225 0 l 292 -85 l 360 0 l 360 517 l 405 517 l 405 53 l 585 274 l 585 112 l 292 -248 l 0 112 l 0 274 z',
    },
    accSagittalSharp5v7kUp: {
      x_min: 0,
      x_max: 312,
      y_min: -361,
      y_max: 172,
      ha: 533,
      o: 'm 45 -517 l 45 -10 b 135 -92 68 -48 98 -75 l 135 -520 l 180 -520 l 180 -108 b 248 -115 203 -112 225 -115 b 271 -112 256 -115 264 -115 l 271 -517 l 315 -517 l 315 -107 b 449 68 405 -89 449 -30 l 405 68 b 297 -4 405 19 369 -4 b 23 248 131 -4 56 85 l 0 248 l 0 -517 z',
    },
    accSagittalFlat5v7kDown: {
      x_min: 0,
      x_max: 312,
      y_min: -172,
      y_max: 361,
      ha: 533,
      o: 'm 45 517 l 45 10 b 135 92 68 48 98 75 l 135 520 l 180 520 l 180 108 b 248 115 203 112 225 115 b 271 112 256 115 264 115 l 271 517 l 315 517 l 315 107 b 449 -68 405 89 449 30 l 405 -68 b 297 4 405 -19 369 4 b 23 -248 131 4 56 -85 l 0 -248 l 0 517 z',
    },
    accSagittalSharp5CUp: {
      x_min: 0,
      x_max: 312,
      y_min: -359,
      y_max: 172,
      ha: 531,
      o: 'm 0 -266 l 135 -153 l 135 -517 l 180 -517 l 180 -115 l 271 -39 l 271 -517 l 315 -517 l 315 0 l 405 75 l 405 -517 l 449 -517 l 449 248 l 428 248 l 0 -112 z',
    },
    accSagittalFlat5CDown: {
      x_min: 0,
      x_max: 312,
      y_min: -172,
      y_max: 359,
      ha: 531,
      o: 'm 0 266 l 135 153 l 135 517 l 180 517 l 180 115 l 271 39 l 271 517 l 315 517 l 315 0 l 405 -75 l 405 517 l 449 517 l 449 -248 l 428 -248 l 0 112 z',
    },
    accSagittalSharp7CUp: {
      x_min: 0,
      x_max: 312,
      y_min: -359,
      y_max: 172,
      ha: 531,
      o: 'm 0 -517 l 45 -517 l 45 112 l 135 112 l 135 -517 l 180 -517 l 180 108 b 271 89 213 105 243 99 l 271 -517 l 315 -517 l 315 73 b 405 -68 374 45 405 -3 l 405 -248 l 449 -248 l 449 68 b 135 248 449 187 346 248 l 0 248 z',
    },
    accSagittalFlat7CDown: {
      x_min: 0,
      x_max: 312,
      y_min: -172,
      y_max: 359,
      ha: 531,
      o: 'm 0 517 l 45 517 l 45 -112 l 135 -112 l 135 517 l 180 517 l 180 -108 b 271 -89 213 -105 243 -99 l 271 517 l 315 517 l 315 -73 b 405 68 374 -45 405 3 l 405 248 l 449 248 l 449 -68 b 135 -248 449 -187 346 -248 l 0 -248 z',
    },
    accSagittalSharp25SUp: {
      x_min: 0,
      x_max: 375,
      y_min: -359,
      y_max: 172,
      ha: 531,
      o: 'm 0 -30 l 495 143 l 495 14 l 0 -157 l 0 -255 l 225 -177 l 225 -517 l 271 -517 l 271 -161 l 360 -130 l 360 -517 l 405 -517 l 405 -115 l 495 -84 l 495 -517 l 540 -517 l 540 248 l 517 248 l 0 68 z',
    },
    accSagittalFlat25SDown: {
      x_min: 0,
      x_max: 375,
      y_min: -172,
      y_max: 359,
      ha: 531,
      o: 'm 0 30 l 495 -143 l 495 -14 l 0 157 l 0 255 l 225 177 l 225 517 l 271 517 l 271 161 l 360 130 l 360 517 l 405 517 l 405 115 l 495 84 l 495 517 l 540 517 l 540 -248 l 517 -248 l 0 -68 z',
    },
    accSagittalSharp35MUp: {
      x_min: 0,
      x_max: 406,
      y_min: -359,
      y_max: 172,
      ha: 531,
      o: 'm 0 -112 l 0 -274 l 135 -108 l 135 -517 l 180 -517 l 180 -53 l 271 58 l 271 -517 l 315 -517 l 315 112 l 360 112 b 405 109 376 112 390 112 l 405 -517 l 449 -517 l 449 96 b 540 -68 510 72 540 17 l 540 -248 l 585 -248 l 585 68 b 405 248 585 187 526 248 l 292 248 z',
    },
    accSagittalFlat35MDown: {
      x_min: 0,
      x_max: 406,
      y_min: -172,
      y_max: 359,
      ha: 531,
      o: 'm 0 112 l 0 274 l 135 108 l 135 517 l 180 517 l 180 53 l 271 -58 l 271 517 l 315 517 l 315 -112 l 360 -112 b 405 -109 376 -112 390 -112 l 405 517 l 449 517 l 449 -96 b 540 68 510 -72 540 -17 l 540 248 l 585 248 l 585 -68 b 405 -248 585 -187 526 -248 l 292 -248 z',
    },
    accSagittalSharp11MUp: {
      x_min: 0,
      x_max: 469,
      y_min: -359,
      y_max: 172,
      ha: 531,
      o: 'm 0 -112 l 0 -271 l 180 -79 l 180 -517 l 225 -517 l 225 -30 l 315 65 l 315 -517 l 360 -517 l 360 65 l 449 -30 l 449 -517 l 495 -517 l 495 -79 l 675 -271 l 675 -112 l 337 248 z',
    },
    accSagittalFlat11MDown: {
      x_min: 0,
      x_max: 469,
      y_min: -172,
      y_max: 359,
      ha: 531,
      o: 'm 0 112 l 0 271 l 180 79 l 180 517 l 225 517 l 225 30 l 315 -65 l 315 517 l 360 517 l 360 -65 l 449 30 l 449 517 l 495 517 l 495 79 l 675 271 l 675 112 l 337 -248 z',
    },
    accSagittalSharp11LUp: {
      x_min: 0,
      x_max: 469,
      y_min: -359,
      y_max: 172,
      ha: 531,
      o: 'm 0 68 l 0 -248 l 45 -248 l 45 -68 b 180 104 45 26 89 82 l 180 -517 l 225 -517 l 225 112 l 271 112 l 315 112 l 315 -517 l 360 -517 l 360 112 l 405 112 l 449 112 l 449 -517 l 495 -517 l 495 104 b 631 -68 585 82 631 26 l 631 -248 l 675 -248 l 675 68 b 449 248 675 187 600 248 l 225 248 b 0 68 75 248 0 187 z',
    },
    accSagittalFlat11LDown: {
      x_min: 0,
      x_max: 469,
      y_min: -172,
      y_max: 359,
      ha: 531,
      o: 'm 0 -68 l 0 248 l 45 248 l 45 68 b 180 -104 45 -26 89 -82 l 180 517 l 225 517 l 225 -112 l 271 -112 l 315 -112 l 315 517 l 360 517 l 360 -112 l 405 -112 l 449 -112 l 449 517 l 495 517 l 495 -104 b 631 68 585 -82 631 -26 l 631 248 l 675 248 l 675 -68 b 449 -248 675 -187 600 -248 l 225 -248 b 0 -68 75 -248 0 -187 z',
    },
    accSagittalSharp35LUp: {
      x_min: 0,
      x_max: 500,
      y_min: -359,
      y_max: 172,
      ha: 531,
      o: 'm 0 -248 l 45 -248 l 45 -68 b 180 104 45 26 89 82 l 180 -517 l 225 -517 l 225 112 l 271 112 l 315 112 l 315 -517 l 360 -517 l 360 71 l 452 -17 l 452 -517 l 495 -517 l 495 -56 l 720 -268 l 720 -112 l 337 248 l 225 248 b 0 68 75 248 0 187 z',
    },
    accSagittalFlat35LDown: {
      x_min: 0,
      x_max: 500,
      y_min: -172,
      y_max: 359,
      ha: 531,
      o: 'm 0 248 l 45 248 l 45 68 b 180 -104 45 -26 89 -82 l 180 517 l 225 517 l 225 -112 l 271 -112 l 315 -112 l 315 517 l 360 517 l 360 -71 l 452 17 l 452 517 l 495 517 l 495 56 l 720 268 l 720 112 l 337 -248 l 225 -248 b 0 -68 75 -248 0 -187 z',
    },
    accSagittalDoubleSharp25SDown: {
      x_min: 0,
      x_max: 406,
      y_min: -359,
      y_max: 172,
      ha: 531,
      o: 'm 0 68 b 135 -112 0 -53 45 -112 b 243 -62 180 -112 215 -95 l 89 -503 l 143 -517 l 292 -82 l 445 -517 l 495 -503 l 343 -62 b 449 -112 372 -95 408 -112 b 585 68 540 -112 585 -53 l 540 68 b 475 -4 540 20 517 -4 b 292 248 350 -4 315 148 b 112 -4 274 148 236 -4 b 45 68 68 -4 45 20 z',
    },
    accSagittalDoubleFlat25SUp: {
      x_min: 0,
      x_max: 406,
      y_min: -172,
      y_max: 359,
      ha: 531,
      o: 'm 0 -68 b 135 112 0 53 45 112 b 243 62 180 112 215 95 l 89 503 l 143 517 l 292 82 l 445 517 l 495 503 l 343 62 b 449 112 372 95 408 112 b 585 -68 540 112 585 53 l 540 -68 b 475 4 540 -20 517 4 b 292 -248 350 4 315 -148 b 112 4 274 -148 236 4 b 45 -68 68 4 45 -20 z',
    },
    accSagittalDoubleSharp7CDown: {
      x_min: 0,
      x_max: 375,
      y_min: -359,
      y_max: 172,
      ha: 531,
      o: 'm 213 112 l 203 82 l 192 112 z m 0 -503 l 52 -517 l 203 -82 l 354 -517 l 405 -503 l 230 0 l 271 108 b 495 -68 420 92 495 35 l 495 -248 l 540 -248 l 540 68 b 225 248 540 187 435 248 l 89 248 l 89 112 l 135 112 l 174 0 z',
    },
    accSagittalDoubleFlat7CUp: {
      x_min: 0,
      x_max: 375,
      y_min: -172,
      y_max: 359,
      ha: 531,
      o: 'm 0 503 l 52 517 l 203 82 l 354 517 l 405 503 l 230 0 l 271 -108 b 495 68 420 -92 495 -35 l 495 248 l 540 248 l 540 -68 b 225 -248 540 -187 435 -248 l 89 -248 l 89 -112 l 135 -112 l 174 0 z m 213 -112 l 203 -82 l 192 -112 z',
    },
    accSagittalDoubleSharp5CDown: {
      x_min: 0,
      x_max: 406,
      y_min: -359,
      y_max: 172,
      ha: 531,
      o: 'm 405 -503 l 230 0 l 232 4 l 585 -264 l 585 -112 l 112 248 l 89 248 l 89 112 l 151 68 l 174 0 l 0 -503 l 52 -517 l 203 -82 l 354 -517 z',
    },
    accSagittalDoubleFlat5CUp: {
      x_min: 0,
      x_max: 406,
      y_min: -172,
      y_max: 359,
      ha: 531,
      o: 'm 405 503 l 230 0 l 232 -4 l 585 264 l 585 112 l 112 -248 l 89 -248 l 89 -112 l 151 -68 l 174 0 l 0 503 l 52 517 l 203 82 l 354 517 z',
    },
    accSagittalDoubleSharp5v7kDown: {
      x_min: 0,
      x_max: 406,
      y_min: -359,
      y_max: 172,
      ha: 531,
      o: 'm 0 -274 l 252 35 l 265 0 l 89 -503 l 141 -517 l 292 -82 l 444 -517 l 495 -503 l 321 0 l 360 112 b 540 -68 480 112 540 53 l 540 -248 l 585 -248 l 585 68 b 405 248 585 187 526 248 l 292 248 l 0 -112 z',
    },
    accSagittalDoubleFlat5v7kUp: {
      x_min: 0,
      x_max: 406,
      y_min: -172,
      y_max: 359,
      ha: 531,
      o: 'm 0 274 l 252 -35 l 265 0 l 89 503 l 141 517 l 292 82 l 444 517 l 495 503 l 321 0 l 360 -112 b 540 68 480 -112 540 -53 l 540 248 l 585 248 l 585 -68 b 405 -248 585 -187 526 -248 l 292 -248 l 0 112 z',
    },
    accSagittalDoubleSharp: {
      x_min: 0,
      x_max: 469,
      y_min: -359,
      y_max: 172,
      ha: 531,
      o: 'm 540 -503 l 366 0 l 380 45 l 675 -271 l 675 -112 l 337 248 l 0 -112 l 0 -271 l 295 45 l 310 0 l 135 -503 l 186 -517 l 337 -82 l 488 -517 z',
    },
    accSagittalDoubleFlat: {
      x_min: 0,
      x_max: 469,
      y_min: -172,
      y_max: 359,
      ha: 531,
      o: 'm 540 503 l 366 0 l 380 -45 l 675 271 l 675 112 l 337 -248 l 0 112 l 0 271 l 295 -45 l 310 0 l 135 503 l 186 517 l 337 82 l 488 517 z',
    },
    accSagittal7v11KleismaUp: {
      x_min: 0,
      x_max: 219,
      y_min: -359,
      y_max: 172,
      ha: 531,
      o: 'm 68 -112 b 135 -45 89 -112 112 -89 l 135 -517 l 180 -517 l 180 -45 b 248 -112 200 -89 225 -112 b 315 68 292 -112 315 -53 l 271 68 b 248 -4 271 20 264 -4 b 236 0 245 -4 240 -3 b 157 248 213 14 187 96 b 78 0 127 96 101 14 b 65 -4 73 -3 68 -4 b 45 68 50 -4 45 20 l 0 68 b 68 -112 0 -53 23 -112 z',
    },
    accSagittal7v11KleismaDown: {
      x_min: 0,
      x_max: 219,
      y_min: -172,
      y_max: 359,
      ha: 531,
      o: 'm 68 112 b 135 45 89 112 112 89 l 135 517 l 180 517 l 180 45 b 248 112 200 89 225 112 b 315 -68 292 112 315 53 l 271 -68 b 248 4 271 -20 264 4 b 236 0 245 4 240 3 b 157 -248 213 -14 187 -96 b 78 0 127 -96 101 -14 b 65 4 73 3 68 4 b 45 -68 50 4 45 -20 l 0 -68 b 68 112 0 53 23 112 z',
    },
    accSagittal17CommaUp: {
      x_min: 0,
      x_max: 281,
      y_min: -359,
      y_max: 172,
      ha: 531,
      o: 'm 45 -203 b 89 -23 45 -82 60 -23 l 157 -23 b 180 -4 164 -23 173 -17 l 180 -517 l 225 -517 l 225 -40 b 315 -118 248 -92 279 -118 b 405 62 374 -118 405 -59 l 360 62 b 324 -10 360 14 348 -10 b 302 -6 318 -10 311 -9 b 206 217 268 9 235 84 l 203 248 b 135 68 177 127 154 68 l 68 68 b 0 -203 23 68 0 -23 z',
    },
    accSagittal17CommaDown: {
      x_min: 0,
      x_max: 281,
      y_min: -172,
      y_max: 359,
      ha: 531,
      o: 'm 45 203 b 89 23 45 82 60 23 l 157 23 b 180 4 164 23 173 17 l 180 517 l 225 517 l 225 40 b 315 118 248 92 279 118 b 405 -62 374 118 405 59 l 360 -62 b 324 10 360 -14 348 10 b 302 6 318 10 311 9 b 206 -217 268 -9 235 -84 l 203 -248 b 135 -68 177 -127 154 -68 l 68 -68 b 0 203 23 -68 0 23 z',
    },
    accSagittal55CommaUp: {
      x_min: 0,
      x_max: 219,
      y_min: -359,
      y_max: 172,
      ha: 531,
      o: 'm 0 248 l 0 -517 l 45 -517 l 45 58 l 315 -274 l 315 -112 l 23 248 z',
    },
    accSagittal55CommaDown: {
      x_min: 0,
      x_max: 219,
      y_min: -172,
      y_max: 359,
      ha: 531,
      o: 'm 0 -248 l 0 517 l 45 517 l 45 -58 l 315 274 l 315 112 l 23 -248 z',
    },
    accSagittal7v11CommaUp: {
      x_min: 0,
      x_max: 188,
      y_min: -359,
      y_max: 172,
      ha: 531,
      o: 'm 0 -248 l 45 -248 l 45 -68 b 180 112 45 53 89 112 l 225 112 l 225 -517 l 271 -517 l 271 248 l 135 248 b 0 68 45 248 0 187 z',
    },
    accSagittal7v11CommaDown: {
      x_min: 0,
      x_max: 188,
      y_min: -172,
      y_max: 359,
      ha: 531,
      o: 'm 0 248 l 45 248 l 45 68 b 180 -112 45 -53 89 -112 l 225 -112 l 225 517 l 271 517 l 271 -248 l 135 -248 b 0 -68 45 -248 0 -187 z',
    },
    accSagittal5v11SmallDiesisUp: {
      x_min: 0,
      x_max: 312,
      y_min: -359,
      y_max: 172,
      ha: 531,
      o: 'm 0 73 l 0 -248 l 45 -248 l 45 -68 b 180 112 45 53 89 112 l 225 112 l 225 -517 l 271 -517 l 271 -40 b 360 -118 295 -92 325 -118 b 449 62 420 -118 449 -59 l 405 62 b 369 -10 405 14 393 -10 b 348 -6 363 -10 356 -9 b 251 217 312 9 279 84 l 248 248 l 135 248 b 0 73 45 248 0 189 z',
    },
    accSagittal5v11SmallDiesisDown: {
      x_min: 0,
      x_max: 312,
      y_min: -172,
      y_max: 359,
      ha: 531,
      o: 'm 0 -73 l 0 248 l 45 248 l 45 68 b 180 -112 45 -53 89 -112 l 225 -112 l 225 517 l 271 517 l 271 40 b 360 118 295 92 325 118 b 449 -62 420 118 449 59 l 405 -62 b 369 10 405 -14 393 10 b 348 6 363 10 356 9 b 251 -217 312 -9 279 -84 l 248 -248 l 135 -248 b 0 -73 45 -248 0 -189 z',
    },
    accSagittalSharp5v11SDown: {
      x_min: 0,
      x_max: 344,
      y_min: -359,
      y_max: 172,
      ha: 531,
      o: 'm 45 -203 b 112 -23 45 -84 68 -23 l 135 -23 l 135 -517 l 180 -517 l 180 -23 b 242 37 203 -23 225 -3 b 315 -89 262 -23 285 -63 l 315 -517 l 360 -517 l 360 -112 l 383 -112 b 495 68 458 -112 495 -53 l 449 68 b 399 -4 449 20 433 -4 b 248 248 297 -4 261 171 b 157 68 222 127 192 68 l 89 68 b 0 -203 30 68 0 -23 z',
    },
    accSagittalFlat5v11SUp: {
      x_min: 0,
      x_max: 344,
      y_min: -172,
      y_max: 359,
      ha: 531,
      o: 'm 45 203 b 112 23 45 84 68 23 l 135 23 l 135 517 l 180 517 l 180 23 b 242 -37 203 23 225 3 b 315 89 262 23 285 63 l 315 517 l 360 517 l 360 112 l 383 112 b 495 -68 458 112 495 53 l 449 -68 b 399 4 449 -20 433 4 b 248 -248 297 4 261 -171 b 157 -68 222 -127 192 -68 l 89 -68 b 0 203 30 -68 0 23 z',
    },
    accSagittalSharp7v11CDown: {
      x_min: 0,
      x_max: 344,
      y_min: -359,
      y_max: 172,
      ha: 531,
      o: 'm 89 -112 l 89 -517 l 135 -517 l 135 -95 b 206 37 163 -73 187 -30 b 271 -23 225 -3 248 -23 l 271 -517 l 315 -517 l 315 -23 l 383 -23 b 449 -203 428 -23 449 -84 l 495 -203 b 405 68 495 -23 465 68 l 292 68 b 203 248 258 68 228 127 b 101 0 173 98 138 16 b 81 -3 94 0 86 -3 b 45 68 56 -3 45 20 l 0 68 b 89 -112 0 -52 30 -112 z',
    },
    accSagittalFlat7v11CUp: {
      x_min: 0,
      x_max: 344,
      y_min: -172,
      y_max: 359,
      ha: 531,
      o: 'm 89 112 l 89 517 l 135 517 l 135 95 b 206 -37 163 73 187 30 b 271 23 225 3 248 23 l 271 517 l 315 517 l 315 23 l 383 23 b 449 203 428 23 449 84 l 495 203 b 405 -68 495 23 465 -68 l 292 -68 b 203 -248 258 -68 228 -127 b 101 0 173 -98 138 -16 b 81 3 94 0 86 3 b 45 -68 56 3 45 -20 l 0 -68 b 89 112 0 52 30 112 z',
    },
    accSagittalSharp55CDown: {
      x_min: 0,
      x_max: 250,
      y_min: -359,
      y_max: 172,
      ha: 531,
      o: 'm 0 -271 l 135 -125 l 135 -517 l 180 -517 l 180 -78 l 315 65 l 315 -517 l 360 -517 l 360 248 l 337 248 l 0 -112 z',
    },
    accSagittalFlat55CUp: {
      x_min: 0,
      x_max: 250,
      y_min: -172,
      y_max: 359,
      ha: 531,
      o: 'm 0 271 l 135 125 l 135 517 l 180 517 l 180 78 l 315 -65 l 315 517 l 360 517 l 360 -248 l 337 -248 l 0 112 z',
    },
    accSagittalSharp17CDown: {
      x_min: 0,
      x_max: 375,
      y_min: -359,
      y_max: 172,
      ha: 531,
      o: 'm 45 -248 l 45 -68 b 180 109 45 36 89 95 l 180 -517 l 225 -517 l 225 112 l 271 112 b 360 -89 292 13 321 -55 l 360 -517 l 405 -517 l 405 -112 l 428 -112 b 540 68 504 -112 540 -53 l 495 68 b 445 -4 495 20 480 -4 b 292 248 343 -4 307 171 l 180 248 b 0 68 60 248 0 187 l 0 -248 z',
    },
    accSagittalFlat17CUp: {
      x_min: 0,
      x_max: 375,
      y_min: -172,
      y_max: 359,
      ha: 531,
      o: 'm 45 248 l 45 68 b 180 -109 45 -36 89 -95 l 180 517 l 225 517 l 225 -112 l 271 -112 b 360 89 292 -13 321 55 l 360 517 l 405 517 l 405 112 l 428 112 b 540 -68 504 112 540 53 l 495 -68 b 445 4 495 -20 480 4 b 292 -248 343 4 307 -171 l 180 -248 b 0 -68 60 -248 0 -187 l 0 248 z',
    },
    accSagittalSharp7v11kDown: {
      x_min: 0,
      x_max: 312,
      y_min: -359,
      y_max: 172,
      ha: 531,
      o: 'm 0 -32 l 405 138 l 405 13 l 0 -157 l 0 -256 l 225 -161 l 225 -517 l 271 -517 l 271 -144 l 405 -86 l 405 -517 l 449 -517 l 449 248 l 428 248 l 0 68 z',
    },
    accSagittalFlat7v11kUp: {
      x_min: 0,
      x_max: 312,
      y_min: -172,
      y_max: 359,
      ha: 531,
      o: 'm 0 32 l 405 -138 l 405 -13 l 0 157 l 0 256 l 225 161 l 225 517 l 271 517 l 271 144 l 405 86 l 405 517 l 449 517 l 449 -248 l 428 -248 l 0 -68 z',
    },
    accSagittalSharp7v11kUp: {
      x_min: 0,
      x_max: 406,
      y_min: -359,
      y_max: 172,
      ha: 531,
      o: 'm 135 -112 l 135 -517 l 180 -517 l 180 -105 b 271 -23 217 -94 248 -65 l 271 -517 l 315 -517 l 315 -23 b 405 -105 337 -65 369 -94 l 405 -517 l 449 -517 l 449 -112 b 585 68 540 -112 585 -53 l 540 68 b 475 -4 540 20 517 -4 b 292 248 350 -4 315 148 b 112 -4 274 148 236 -4 b 45 68 68 -4 45 20 l 0 68 b 135 -112 0 -53 45 -112 z',
    },
    accSagittalFlat7v11kDown: {
      x_min: 0,
      x_max: 406,
      y_min: -172,
      y_max: 359,
      ha: 531,
      o: 'm 135 112 l 135 517 l 180 517 l 180 105 b 271 23 217 94 248 65 l 271 517 l 315 517 l 315 23 b 405 105 337 65 369 94 l 405 517 l 449 517 l 449 112 b 585 -68 540 112 585 53 l 540 -68 b 475 4 540 -20 517 4 b 292 -248 350 4 315 -148 b 112 4 274 -148 236 4 b 45 -68 68 4 45 -20 l 0 -68 b 135 112 0 53 45 112 z',
    },
    accSagittalSharp17CUp: {
      x_min: 0,
      x_max: 406,
      y_min: -359,
      y_max: 172,
      ha: 531,
      o: 'm 45 -203 b 135 -23 45 -84 75 -23 l 135 -517 l 180 -517 l 180 -23 l 203 -23 b 271 14 229 -23 251 -10 l 271 -517 l 315 -517 l 315 -23 b 405 -105 337 -65 369 -94 l 405 -517 l 449 -517 l 449 -112 b 585 68 540 -112 585 -53 l 540 68 b 475 -4 540 20 517 -4 b 292 248 350 -4 312 150 b 180 68 268 127 230 68 l 112 68 b 0 -203 37 68 0 -23 z',
    },
    accSagittalFlat17CDown: {
      x_min: 0,
      x_max: 406,
      y_min: -172,
      y_max: 359,
      ha: 531,
      o: 'm 45 203 b 135 23 45 84 75 23 l 135 517 l 180 517 l 180 23 l 203 23 b 271 -14 229 23 251 10 l 271 517 l 315 517 l 315 23 b 405 105 337 65 369 94 l 405 517 l 449 517 l 449 112 b 585 -68 540 112 585 53 l 540 -68 b 475 4 540 -20 517 4 b 292 -248 350 4 312 -150 b 180 -68 268 -127 230 -68 l 112 -68 b 0 203 37 -68 0 23 z',
    },
    accSagittalSharp55CUp: {
      x_min: 0,
      x_max: 344,
      y_min: -359,
      y_max: 172,
      ha: 531,
      o: 'm 45 -517 l 45 78 l 135 10 l 135 -517 l 180 -517 l 180 -23 l 271 -92 l 271 -517 l 315 -517 l 315 -127 l 495 -264 l 495 -112 l 23 248 l 0 248 l 0 -517 z',
    },
    accSagittalFlat55CDown: {
      x_min: 0,
      x_max: 344,
      y_min: -172,
      y_max: 359,
      ha: 531,
      o: 'm 45 517 l 45 -78 l 135 -10 l 135 517 l 180 517 l 180 23 l 271 92 l 271 517 l 315 517 l 315 127 l 495 264 l 495 112 l 23 -248 l 0 -248 l 0 517 z',
    },
    accSagittalSharp7v11CUp: {
      x_min: 0,
      x_max: 344,
      y_min: -359,
      y_max: 172,
      ha: 531,
      o: 'm 0 68 l 0 -248 l 45 -248 l 45 -68 b 180 86 45 6 89 58 l 180 -517 l 225 -517 l 225 98 b 315 109 252 104 282 108 l 315 -517 l 360 -517 l 360 112 l 405 112 l 449 112 l 449 -517 l 495 -517 l 495 248 l 360 248 b 0 68 121 248 0 189 z',
    },
    accSagittalFlat7v11CDown: {
      x_min: 0,
      x_max: 344,
      y_min: -172,
      y_max: 359,
      ha: 531,
      o: 'm 0 -68 l 0 248 l 45 248 l 45 68 b 180 -86 45 -6 89 -58 l 180 517 l 225 517 l 225 -98 b 315 -109 252 -104 282 -108 l 315 517 l 360 517 l 360 -112 l 405 -112 l 449 -112 l 449 517 l 495 517 l 495 -248 l 360 -248 b 0 -68 121 -248 0 -189 z',
    },
    accSagittalSharp5v11SUp: {
      x_min: 0,
      x_max: 438,
      y_min: -359,
      y_max: 172,
      ha: 531,
      o: 'm 0 -248 l 45 -248 l 45 -68 b 180 104 45 26 89 82 l 180 -517 l 225 -517 l 225 112 l 271 112 l 315 112 l 315 -517 l 360 -517 l 360 -23 b 449 -105 383 -65 415 -94 l 449 -517 l 495 -517 l 495 -112 b 631 68 585 -112 631 -53 l 585 68 b 520 -4 585 20 563 -4 b 337 248 396 -4 360 150 l 225 248 b 0 68 76 248 0 187 z',
    },
    accSagittalFlat5v11SDown: {
      x_min: 0,
      x_max: 438,
      y_min: -172,
      y_max: 359,
      ha: 531,
      o: 'm 0 248 l 45 248 l 45 68 b 180 -104 45 -26 89 -82 l 180 517 l 225 517 l 225 -112 l 271 -112 l 315 -112 l 315 517 l 360 517 l 360 23 b 449 105 383 65 415 94 l 449 517 l 495 517 l 495 112 b 631 -68 585 112 631 53 l 585 -68 b 520 4 585 -20 563 4 b 337 -248 396 4 360 -150 l 225 -248 b 0 -68 76 -248 0 -187 z',
    },
    accSagittalDoubleSharp5v11SDown: {
      x_min: 0,
      x_max: 406,
      y_min: -359,
      y_max: 172,
      ha: 531,
      o: 'm 45 -203 b 135 -23 45 -84 75 -23 l 203 -23 b 262 4 225 -23 245 -13 l 265 0 l 89 -503 l 141 -517 l 292 -82 l 444 -517 l 495 -503 l 341 -60 b 449 -112 370 -95 405 -112 b 585 68 540 -112 585 -53 l 540 68 b 475 -4 540 20 517 -4 b 292 248 350 -4 312 150 b 180 68 268 127 230 68 l 112 68 b 0 -203 37 68 0 -23 z',
    },
    accSagittalDoubleFlat5v11SUp: {
      x_min: 0,
      x_max: 406,
      y_min: -172,
      y_max: 359,
      ha: 531,
      o: 'm 45 203 b 135 23 45 84 75 23 l 203 23 b 262 -4 225 23 245 13 l 265 0 l 89 503 l 141 517 l 292 82 l 444 517 l 495 503 l 341 60 b 449 112 370 95 405 112 b 585 -68 540 112 585 53 l 540 -68 b 475 4 540 -20 517 4 b 292 -248 350 4 312 -150 b 180 -68 268 -127 230 -68 l 112 -68 b 0 203 37 -68 0 23 z',
    },
    accSagittalDoubleSharp7v11CDown: {
      x_min: 0,
      x_max: 375,
      y_min: -359,
      y_max: 172,
      ha: 531,
      o: 'm 112 -112 b 193 -73 143 -112 170 -99 l 45 -501 l 95 -517 l 248 -81 l 397 -517 l 449 -503 l 275 0 l 278 4 b 337 -23 295 -13 315 -23 l 405 -23 b 495 -203 465 -23 495 -84 l 540 -203 b 428 68 540 -23 503 68 l 360 68 b 248 248 310 68 271 127 b 122 0 217 98 176 16 b 95 -3 112 0 104 -3 b 45 68 60 -3 45 20 l 0 68 b 112 -112 0 -52 36 -112 z',
    },
    accSagittalDoubleFlat7v11CUp: {
      x_min: 0,
      x_max: 375,
      y_min: -172,
      y_max: 359,
      ha: 531,
      o: 'm 112 112 b 193 73 143 112 170 99 l 45 501 l 95 517 l 248 81 l 397 517 l 449 503 l 275 0 l 278 -4 b 337 23 295 13 315 23 l 405 23 b 495 203 465 23 495 84 l 540 203 b 428 -68 540 23 503 -68 l 360 -68 b 248 -248 310 -68 271 -127 b 122 0 217 -98 176 -16 b 95 3 112 0 104 3 b 45 -68 60 3 45 -20 l 0 -68 b 112 112 0 52 36 112 z',
    },
    accSagittalDoubleSharp55CDown: {
      x_min: 0,
      x_max: 375,
      y_min: -359,
      y_max: 172,
      ha: 531,
      o: 'm 428 248 l 0 -112 l 0 -266 l 307 -7 l 135 -503 l 186 -517 l 337 -82 l 488 -517 l 540 -503 l 366 0 l 386 59 l 449 112 l 449 248 z',
    },
    accSagittalDoubleFlat55CUp: {
      x_min: 0,
      x_max: 375,
      y_min: -172,
      y_max: 359,
      ha: 531,
      o: 'm 428 -248 l 0 112 l 0 266 l 307 7 l 135 503 l 186 517 l 337 82 l 488 517 l 540 503 l 366 0 l 386 -59 l 449 -112 l 449 -248 z',
    },
    accSagittalDoubleSharp17CDown: {
      x_min: 0,
      x_max: 438,
      y_min: -359,
      y_max: 172,
      ha: 531,
      o: 'm 45 -248 l 45 -68 b 271 112 45 53 120 112 l 310 0 l 135 -503 l 186 -517 l 337 -82 l 488 -517 l 540 -503 l 387 -62 b 495 -112 416 -95 452 -112 b 631 68 585 -112 631 -53 l 585 68 b 520 -4 585 20 563 -4 b 337 248 396 -4 360 150 l 225 248 b 0 68 76 248 0 187 l 0 -248 z',
    },
    accSagittalDoubleFlat17CUp: {
      x_min: 0,
      x_max: 438,
      y_min: -172,
      y_max: 359,
      ha: 531,
      o: 'm 45 248 l 45 68 b 271 -112 45 -53 120 -112 l 310 0 l 135 503 l 186 517 l 337 82 l 488 517 l 540 503 l 387 62 b 495 112 416 95 452 112 b 631 -68 585 112 631 53 l 585 -68 b 520 4 585 -20 563 4 b 337 -248 396 4 360 -150 l 225 -248 b 0 -68 76 -248 0 -187 l 0 248 z',
    },
    accSagittalDoubleSharp7v11kDown: {
      x_min: 0,
      x_max: 438,
      y_min: -359,
      y_max: 172,
      ha: 531,
      o: 'm 416 115 l 442 124 l 428 82 z m 0 68 l 0 -30 l 366 96 l 399 0 l 392 -23 l 0 -157 l 0 -255 l 353 -135 l 225 -503 l 276 -517 l 428 -82 l 579 -517 l 631 -503 l 455 0 l 507 145 l 540 157 l 540 248 l 517 248 z',
    },
    accSagittalDoubleFlat7v11kUp: {
      x_min: 0,
      x_max: 438,
      y_min: -172,
      y_max: 359,
      ha: 531,
      o: 'm 0 -68 l 0 30 l 366 -96 l 399 0 l 392 23 l 0 157 l 0 255 l 353 135 l 225 503 l 276 517 l 428 82 l 579 517 l 631 503 l 455 0 l 507 -145 l 540 -157 l 540 -248 l 517 -248 z m 416 -115 l 442 -124 l 428 -82 z',
    },
    accSagittal23CommaUp: {
      x_min: 0,
      x_max: 188,
      y_min: -359,
      y_max: 172,
      ha: 531,
      o: 'm 0 -517 l 45 -517 l 45 -4 b 68 -23 53 -17 60 -23 l 180 -23 b 225 -203 210 -23 225 -82 l 271 -203 b 206 68 271 -23 248 68 l 89 68 b 23 248 71 68 48 127 l 0 248 z',
    },
    accSagittal23CommaDown: {
      x_min: 0,
      x_max: 188,
      y_min: -172,
      y_max: 359,
      ha: 531,
      o: 'm 0 517 l 45 517 l 45 4 b 68 23 53 17 60 23 l 180 23 b 225 203 210 23 225 82 l 271 203 b 206 -68 271 23 248 -68 l 89 -68 b 23 -248 71 -68 48 -127 l 0 -248 z',
    },
    accSagittal5v19CommaUp: {
      x_min: 0,
      x_max: 156,
      y_min: -359,
      y_max: 172,
      ha: 531,
      o: 'm 0 -284 l 180 33 l 180 -517 l 225 -517 l 225 248 l 203 248 b 86 112 151 157 112 112 b 45 157 59 112 45 127 l 0 157 b 76 23 0 72 26 27 l 0 -112 z',
    },
    accSagittal5v19CommaDown: {
      x_min: 0,
      x_max: 156,
      y_min: -172,
      y_max: 359,
      ha: 531,
      o: 'm 0 284 l 180 -33 l 180 517 l 225 517 l 225 -248 l 203 -248 b 86 -112 151 -157 112 -112 b 45 -157 59 -112 45 -127 l 0 -157 b 76 -23 0 -72 26 -27 l 0 112 z',
    },
    accSagittal5v23SmallDiesisUp: {
      x_min: 0,
      x_max: 312,
      y_min: -359,
      y_max: 172,
      ha: 531,
      o: 'm 0 -284 l 180 33 l 180 -517 l 225 -517 l 225 -4 b 248 -23 233 -17 240 -23 l 360 -23 b 405 -203 390 -23 405 -82 l 449 -203 b 386 68 449 -23 428 68 l 271 68 b 203 248 251 68 228 127 l 0 -112 z',
    },
    accSagittal5v23SmallDiesisDown: {
      x_min: 0,
      x_max: 312,
      y_min: -172,
      y_max: 359,
      ha: 531,
      o: 'm 0 284 l 180 -33 l 180 517 l 225 517 l 225 4 b 248 23 233 17 240 23 l 360 23 b 405 203 390 23 405 82 l 449 203 b 386 -68 449 23 428 -68 l 271 -68 b 203 -248 251 -68 228 -127 l 0 112 z',
    },
    accSagittalSharp5v23SDown: {
      x_min: 0,
      x_max: 281,
      y_min: -359,
      y_max: 172,
      ha: 531,
      o: 'm 0 -517 l 45 -517 l 45 6 b 89 -23 59 -13 73 -23 l 180 -23 l 180 -517 l 225 -517 l 225 -23 l 292 -23 b 360 -203 337 -23 360 -84 l 405 -203 b 315 68 405 -23 374 68 l 112 68 b 23 248 78 68 48 127 l 0 248 z',
    },
    accSagittalFlat5v23SUp: {
      x_min: 0,
      x_max: 281,
      y_min: -172,
      y_max: 359,
      ha: 531,
      o: 'm 0 517 l 45 517 l 45 -6 b 89 23 59 13 73 23 l 180 23 l 180 517 l 225 517 l 225 23 l 292 23 b 360 203 337 23 360 84 l 405 203 b 315 -68 405 23 374 -68 l 112 -68 b 23 -248 78 -68 48 -127 l 0 -248 z',
    },
    accSagittalSharp5v19CDown: {
      x_min: 0,
      x_max: 312,
      y_min: -359,
      y_max: 172,
      ha: 531,
      o: 'm 0 68 b 89 -112 0 -52 30 -112 l 89 -517 l 135 -517 l 135 -95 b 225 112 173 -65 203 4 l 271 112 l 271 -517 l 315 -517 l 315 107 b 405 -68 374 89 405 30 l 405 -248 l 449 -248 l 449 68 b 315 248 449 189 405 248 l 203 248 b 101 0 173 98 138 16 b 81 -3 94 0 86 -3 b 45 68 56 -3 45 23 z',
    },
    accSagittalFlat5v19CUp: {
      x_min: 0,
      x_max: 312,
      y_min: -172,
      y_max: 359,
      ha: 531,
      o: 'm 0 -68 b 89 112 0 52 30 112 l 89 517 l 135 517 l 135 95 b 225 -112 173 65 203 -4 l 271 -112 l 271 517 l 315 517 l 315 -107 b 405 68 374 -89 405 -30 l 405 248 l 449 248 l 449 -68 b 315 -248 449 -189 405 -248 l 203 -248 b 101 0 173 -98 138 -16 b 81 3 94 0 86 3 b 45 -68 56 3 45 -23 z',
    },
    accSagittalSharp23CDown: {
      x_min: 0,
      x_max: 375,
      y_min: -359,
      y_max: 172,
      ha: 531,
      o: 'm 135 -82 l 135 -517 l 180 -517 l 180 -17 l 239 68 b 315 -23 261 7 287 -23 l 315 -517 l 360 -517 l 360 -23 l 428 -23 b 495 -203 472 -23 495 -84 l 540 -203 b 449 68 540 -23 510 68 l 337 68 b 248 248 302 68 271 127 l 0 -112 l 0 -276 z',
    },
    accSagittalFlat23CUp: {
      x_min: 0,
      x_max: 375,
      y_min: -172,
      y_max: 359,
      ha: 531,
      o: 'm 135 82 l 135 517 l 180 517 l 180 17 l 239 -68 b 315 23 261 -7 287 23 l 315 517 l 360 517 l 360 23 l 428 23 b 495 203 472 23 495 84 l 540 203 b 449 -68 540 23 510 -68 l 337 -68 b 248 -248 302 -68 271 -127 l 0 112 l 0 276 z',
    },
    accSagittalSharp23CUp: {
      x_min: 0,
      x_max: 344,
      y_min: -359,
      y_max: 172,
      ha: 531,
      o: 'm 0 -517 l 45 -517 l 45 14 b 112 -23 63 -10 86 -23 l 135 -23 l 135 -517 l 180 -517 l 180 -23 l 271 -23 l 271 -517 l 315 -517 l 315 -23 l 360 -23 b 449 -203 420 -23 449 -84 l 495 -203 b 383 68 495 -23 458 68 l 135 68 b 23 248 85 68 48 127 l 0 248 z',
    },
    accSagittalFlat23CDown: {
      x_min: 0,
      x_max: 344,
      y_min: -172,
      y_max: 359,
      ha: 531,
      o: 'm 0 517 l 45 517 l 45 -14 b 112 23 63 10 86 23 l 135 23 l 135 517 l 180 517 l 180 23 l 271 23 l 271 517 l 315 517 l 315 23 l 360 23 b 449 203 420 23 449 84 l 495 203 b 383 -68 495 23 458 -68 l 135 -68 b 23 -248 85 -68 48 -127 l 0 -248 z',
    },
    accSagittalSharp5v19CUp: {
      x_min: 0,
      x_max: 312,
      y_min: -359,
      y_max: 172,
      ha: 531,
      o: 'm 0 -112 l 0 -266 l 135 -153 l 135 -517 l 180 -517 l 180 -115 l 271 -39 l 271 -517 l 315 -517 l 315 0 l 405 75 l 405 -517 l 449 -517 l 449 248 l 428 248 b 130 68 285 127 186 68 b 45 157 73 68 45 98 l 0 157 b 112 -20 0 53 37 -6 z',
    },
    accSagittalFlat5v19CDown: {
      x_min: 0,
      x_max: 312,
      y_min: -172,
      y_max: 359,
      ha: 531,
      o: 'm 0 112 l 0 266 l 135 153 l 135 517 l 180 517 l 180 115 l 271 39 l 271 517 l 315 517 l 315 0 l 405 -75 l 405 517 l 449 517 l 449 -248 l 428 -248 b 130 -68 285 -127 186 -68 b 45 -157 73 -68 45 -98 l 0 -157 b 112 20 0 -53 37 6 z',
    },
    accSagittalSharp5v23SUp: {
      x_min: 0,
      x_max: 406,
      y_min: -359,
      y_max: 172,
      ha: 531,
      o: 'm 135 -108 l 135 -517 l 180 -517 l 180 -53 l 271 58 l 271 -517 l 315 -517 l 315 14 b 383 -23 334 -10 357 -23 l 405 -23 l 405 -517 l 449 -517 l 449 -23 b 540 -203 510 -23 540 -84 l 585 -203 b 472 68 585 -23 547 68 l 405 68 b 292 248 356 68 318 127 l 0 -112 l 0 -274 z',
    },
    accSagittalFlat5v23SDown: {
      x_min: 0,
      x_max: 406,
      y_min: -172,
      y_max: 359,
      ha: 531,
      o: 'm 135 108 l 135 517 l 180 517 l 180 53 l 271 -58 l 271 517 l 315 517 l 315 -14 b 383 23 334 10 357 23 l 405 23 l 405 517 l 449 517 l 449 23 b 540 203 510 23 540 84 l 585 203 b 472 -68 585 23 547 -68 l 405 -68 b 292 -248 356 -68 318 -127 l 0 112 l 0 274 z',
    },
    accSagittalDoubleSharp5v23SDown: {
      x_min: 0,
      x_max: 406,
      y_min: -359,
      y_max: 172,
      ha: 531,
      o: 'm 52 -517 l 203 -81 l 354 -517 l 405 -503 l 239 -23 l 449 -23 b 540 -203 510 -23 540 -84 l 585 -203 b 472 68 585 -23 547 68 l 225 68 b 112 248 176 68 138 127 l 89 248 l 89 112 b 170 -14 109 45 135 0 l 0 -501 z',
    },
    accSagittalDoubleFlat5v23SUp: {
      x_min: 0,
      x_max: 406,
      y_min: -172,
      y_max: 359,
      ha: 531,
      o: 'm 52 517 l 203 81 l 354 517 l 405 503 l 239 23 l 449 23 b 540 203 510 23 540 84 l 585 203 b 472 -68 585 23 547 -68 l 225 -68 b 112 -248 176 -68 138 -127 l 89 -248 l 89 -112 b 170 14 109 -45 135 0 l 0 501 z',
    },
    accSagittalDoubleSharp5v19CDown: {
      x_min: 0,
      x_max: 375,
      y_min: -359,
      y_max: 172,
      ha: 531,
      o: 'm 0 68 b 112 -112 0 -52 36 -112 b 193 -73 143 -112 170 -99 l 45 -501 l 95 -517 l 248 -81 l 397 -517 l 449 -501 l 275 0 l 315 112 b 495 -68 435 112 495 53 l 495 -248 l 540 -248 l 540 68 b 360 248 540 189 480 248 l 248 248 b 122 0 217 98 176 16 b 95 -3 112 0 104 -3 b 45 68 60 -3 45 20 z',
    },
    accSagittalDoubleFlat5v19CUp: {
      x_min: 0,
      x_max: 375,
      y_min: -172,
      y_max: 359,
      ha: 531,
      o: 'm 0 -68 b 112 112 0 52 36 112 b 193 73 143 112 170 99 l 45 501 l 95 517 l 248 81 l 397 517 l 449 501 l 275 0 l 315 -112 b 495 68 435 -112 495 -53 l 495 248 l 540 248 l 540 -68 b 360 -248 540 -189 480 -248 l 248 -248 b 122 0 217 -98 176 -16 b 95 3 112 0 104 3 b 45 -68 60 3 45 -20 z',
    },
    accSagittalDoubleSharp23CDown: {
      x_min: 0,
      x_max: 406,
      y_min: -359,
      y_max: 172,
      ha: 531,
      o: 'm 252 35 l 265 0 l 89 -503 l 141 -517 l 292 -82 l 444 -517 l 495 -503 l 321 0 l 323 4 b 383 -23 340 -13 360 -23 l 449 -23 b 540 -203 510 -23 540 -84 l 585 -203 b 472 68 585 -23 547 68 l 405 68 b 292 248 356 68 318 127 l 0 -112 l 0 -274 z',
    },
    accSagittalDoubleFlat23CUp: {
      x_min: 0,
      x_max: 406,
      y_min: -172,
      y_max: 359,
      ha: 531,
      o: 'm 252 -35 l 265 0 l 89 503 l 141 517 l 292 82 l 444 517 l 495 503 l 321 0 l 323 -4 b 383 23 340 13 360 23 l 449 23 b 540 203 510 23 540 84 l 585 203 b 472 -68 585 23 547 -68 l 405 -68 b 292 -248 356 -68 318 -127 l 0 112 l 0 274 z',
    },
    accSagittal19SchismaUp: {
      x_min: 0,
      x_max: 125,
      y_min: -359,
      y_max: 172,
      ha: 531,
      o: 'm 68 -112 b 135 -45 89 -112 112 -89 l 135 -517 l 180 -517 l 180 248 l 157 248 b 79 0 127 98 101 16 b 68 -3 73 0 68 -3 b 45 68 52 -3 45 20 l 0 68 b 68 -112 0 -52 23 -112 z',
    },
    accSagittal19SchismaDown: {
      x_min: 0,
      x_max: 125,
      y_min: -172,
      y_max: 359,
      ha: 531,
      o: 'm 68 112 b 135 45 89 112 112 89 l 135 517 l 180 517 l 180 -248 l 157 -248 b 79 0 127 -98 101 -16 b 68 3 73 0 68 3 b 45 -68 52 3 45 -20 l 0 -68 b 68 112 0 52 23 112 z',
    },
    accSagittal17KleismaUp: {
      x_min: 0,
      x_max: 156,
      y_min: -359,
      y_max: 172,
      ha: 531,
      o: 'm 45 -203 b 89 -23 45 -82 60 -23 l 157 -23 b 180 -4 164 -23 173 -17 l 180 -517 l 225 -517 l 225 248 l 203 248 b 135 68 177 127 154 68 l 68 68 b 0 -203 23 68 0 -23 z',
    },
    accSagittal17KleismaDown: {
      x_min: 0,
      x_max: 156,
      y_min: -172,
      y_max: 359,
      ha: 531,
      o: 'm 45 203 b 89 23 45 82 60 23 l 157 23 b 180 4 164 23 173 17 l 180 517 l 225 517 l 225 -248 l 203 -248 b 135 -68 177 -127 154 -68 l 68 -68 b 0 203 23 -68 0 23 z',
    },
    accSagittal143CommaUp: {
      x_min: 0,
      x_max: 156,
      y_min: -359,
      y_max: 172,
      ha: 531,
      o: 'm 0 -203 l 45 -203 b 89 -23 45 -82 60 -23 l 157 -23 b 180 -4 164 -23 173 -17 l 180 -517 l 225 -517 l 225 248 l 203 248 b 135 68 177 127 154 68 l 105 68 b 45 157 65 68 45 98 l 0 157 b 23 20 0 95 7 50 b 0 -203 7 -23 0 -98 z',
    },
    accSagittal143CommaDown: {
      x_min: 0,
      x_max: 156,
      y_min: -172,
      y_max: 359,
      ha: 531,
      o: 'm 0 203 l 45 203 b 89 23 45 82 60 23 l 157 23 b 180 4 164 23 173 17 l 180 517 l 225 517 l 225 -248 l 203 -248 b 135 -68 177 -127 154 -68 l 105 -68 b 45 -157 65 -68 45 -98 l 0 -157 b 23 -20 0 -95 7 -50 b 0 203 7 23 0 98 z',
    },
    accSagittal11v49CommaUp: {
      x_min: 0,
      x_max: 188,
      y_min: -359,
      y_max: 172,
      ha: 531,
      o: 'm 45 -292 b 89 -157 45 -203 60 -157 l 203 -157 b 225 -143 210 -157 217 -153 l 225 -517 l 271 -517 l 271 248 l 248 248 b 180 157 233 187 210 157 l 68 157 b 0 -68 23 157 0 82 l 45 -68 b 89 68 45 23 60 68 l 203 68 b 225 84 209 68 216 72 l 225 -36 b 180 -68 213 -58 199 -68 l 68 -68 b 0 -292 23 -68 0 -143 z',
    },
    accSagittal11v49CommaDown: {
      x_min: 0,
      x_max: 188,
      y_min: -172,
      y_max: 359,
      ha: 531,
      o: 'm 45 292 b 89 157 45 203 60 157 l 203 157 b 225 143 210 157 217 153 l 225 517 l 271 517 l 271 -248 l 248 -248 b 180 -157 233 -187 210 -157 l 68 -157 b 0 68 23 -157 0 -82 l 45 68 b 89 -68 45 -23 60 -68 l 203 -68 b 225 -84 209 -68 216 -72 l 225 36 b 180 68 213 58 199 68 l 68 68 b 0 292 23 68 0 143 z',
    },
    accSagittal19CommaUp: {
      x_min: 0,
      x_max: 281,
      y_min: -359,
      y_max: 172,
      ha: 531,
      o: 'm 0 68 b 68 -112 0 -52 23 -112 b 135 -45 89 -112 112 -89 l 135 -517 l 180 -517 l 180 -4 b 203 -23 187 -17 196 -23 l 315 -23 b 360 -203 346 -23 360 -82 l 405 -203 b 341 68 405 -23 383 68 l 225 68 b 157 248 206 68 183 127 b 79 0 127 98 101 16 b 68 -3 73 0 68 -3 b 45 68 52 -3 45 20 z',
    },
    accSagittal19CommaDown: {
      x_min: 0,
      x_max: 281,
      y_min: -172,
      y_max: 359,
      ha: 531,
      o: 'm 0 -68 b 68 112 0 52 23 112 b 135 45 89 112 112 89 l 135 517 l 180 517 l 180 4 b 203 23 187 17 196 23 l 315 23 b 360 203 346 23 360 82 l 405 203 b 341 -68 405 23 383 -68 l 225 -68 b 157 -248 206 -68 183 -127 b 79 0 127 -98 101 -16 b 68 3 73 0 68 3 b 45 -68 52 3 45 -20 z',
    },
    accSagittal7v19CommaUp: {
      x_min: 0,
      x_max: 250,
      y_min: -359,
      y_max: 172,
      ha: 531,
      o: 'm 0 68 b 68 -112 0 -52 23 -112 b 135 -45 89 -112 112 -89 l 135 -517 l 180 -517 l 180 112 l 225 112 b 315 -68 285 112 315 53 l 315 -248 l 360 -248 l 360 68 b 271 248 360 187 330 248 l 157 248 b 79 0 127 98 101 16 b 68 -3 73 0 68 -3 b 45 68 52 -3 45 20 z',
    },
    accSagittal7v19CommaDown: {
      x_min: 0,
      x_max: 250,
      y_min: -172,
      y_max: 359,
      ha: 531,
      o: 'm 0 -68 b 68 112 0 52 23 112 b 135 45 89 112 112 89 l 135 517 l 180 517 l 180 -112 l 225 -112 b 315 68 285 -112 315 -53 l 315 248 l 360 248 l 360 -68 b 271 -248 360 -187 330 -248 l 157 -248 b 79 0 127 -98 101 -16 b 68 3 73 0 68 3 b 45 -68 52 3 45 -20 z',
    },
    accSagittal49SmallDiesisUp: {
      x_min: 0,
      x_max: 281,
      y_min: -359,
      y_max: 172,
      ha: 531,
      o: 'm 0 -203 l 45 -203 b 89 -23 45 -82 60 -23 l 157 -23 b 180 -4 164 -23 173 -17 l 180 -517 l 225 -517 l 225 112 l 271 112 b 360 -68 330 112 360 53 l 360 -248 l 405 -248 l 405 68 b 315 248 405 187 374 248 l 203 248 b 135 68 177 127 154 68 l 68 68 b 0 -203 23 68 0 -23 z',
    },
    accSagittal49SmallDiesisDown: {
      x_min: 0,
      x_max: 281,
      y_min: -172,
      y_max: 359,
      ha: 531,
      o: 'm 0 203 l 45 203 b 89 23 45 82 60 23 l 157 23 b 180 4 164 23 173 17 l 180 517 l 225 517 l 225 -112 l 271 -112 b 360 68 330 -112 360 -53 l 360 248 l 405 248 l 405 -68 b 315 -248 405 -187 374 -248 l 203 -248 b 135 -68 177 -127 154 -68 l 68 -68 b 0 203 23 -68 0 23 z',
    },
    accSagittal23SmallDiesisUp: {
      x_min: 0,
      x_max: 344,
      y_min: -359,
      y_max: 172,
      ha: 531,
      o: 'm 45 -203 b 89 -23 45 -82 60 -23 l 157 -23 b 180 -4 164 -23 173 -17 l 180 -517 l 225 -517 l 225 58 l 495 -274 l 495 -112 l 203 248 b 135 68 177 127 154 68 l 68 68 b 0 -203 23 68 0 -23 z',
    },
    accSagittal23SmallDiesisDown: {
      x_min: 0,
      x_max: 344,
      y_min: -172,
      y_max: 359,
      ha: 531,
      o: 'm 45 203 b 89 23 45 82 60 23 l 157 23 b 180 4 164 23 173 17 l 180 517 l 225 517 l 225 -58 l 495 274 l 495 112 l 203 -248 b 135 -68 177 -127 154 -68 l 68 -68 b 0 203 23 -68 0 23 z',
    },
    accSagittal5v13MediumDiesisUp: {
      x_min: 0,
      x_max: 250,
      y_min: -359,
      y_max: 172,
      ha: 531,
      o: 'm 0 -259 l 315 -89 l 315 -517 l 360 -517 l 360 248 l 337 248 b 128 180 253 203 184 180 b 45 248 73 180 45 203 l 0 248 b 52 95 0 170 17 120 l 0 68 l 0 -33 l 315 135 l 315 10 l 0 -157 z',
    },
    accSagittal5v13MediumDiesisDown: {
      x_min: 0,
      x_max: 250,
      y_min: -172,
      y_max: 359,
      ha: 531,
      o: 'm 0 259 l 315 89 l 315 517 l 360 517 l 360 -248 l 337 -248 b 128 -180 253 -203 184 -180 b 45 -248 73 -180 45 -203 l 0 -248 b 52 -95 0 -170 17 -120 l 0 -68 l 0 33 l 315 -135 l 315 -10 l 0 157 z',
    },
    accSagittal11v19MediumDiesisUp: {
      x_min: 0,
      x_max: 344,
      y_min: -359,
      y_max: 172,
      ha: 531,
      o: 'm 45 -248 l 45 -68 b 180 112 45 53 89 112 l 225 112 l 225 -517 l 271 -517 l 271 -4 b 292 -23 278 -17 285 -23 l 405 -23 b 449 -203 435 -23 449 -82 l 495 -203 b 431 68 495 -23 472 68 l 315 68 b 248 248 295 68 271 127 l 135 248 b 0 68 45 248 0 187 l 0 -248 z',
    },
    accSagittal11v19MediumDiesisDown: {
      x_min: 0,
      x_max: 344,
      y_min: -172,
      y_max: 359,
      ha: 531,
      o: 'm 45 248 l 45 68 b 180 -112 45 -53 89 -112 l 225 -112 l 225 517 l 271 517 l 271 4 b 292 23 278 17 285 23 l 405 23 b 449 203 435 23 449 82 l 495 203 b 431 -68 495 23 472 -68 l 315 -68 b 248 -248 295 -68 271 -127 l 135 -248 b 0 -68 45 -248 0 -187 l 0 248 z',
    },
    accSagittal49MediumDiesisUp: {
      x_min: 0,
      x_max: 250,
      y_min: -359,
      y_max: 172,
      ha: 531,
      o: 'm 45 -68 b 225 112 45 53 105 112 l 315 112 l 315 10 l 45 -145 z m 0 -68 l 0 -248 l 45 -248 l 315 -94 l 315 -517 l 360 -517 l 360 248 l 225 248 b 0 -68 75 248 0 143 z',
    },
    accSagittal49MediumDiesisDown: {
      x_min: 0,
      x_max: 250,
      y_min: -172,
      y_max: 359,
      ha: 531,
      o: 'm 0 68 l 0 248 l 45 248 l 315 94 l 315 517 l 360 517 l 360 -248 l 225 -248 b 0 68 75 -248 0 -143 z m 45 68 b 225 -112 45 -53 105 -112 l 315 -112 l 315 -10 l 45 145 z',
    },
    accSagittal5v49MediumDiesisUp: {
      x_min: 0,
      x_max: 344,
      y_min: -359,
      y_max: 172,
      ha: 531,
      o: 'm 0 -89 l 0 -248 l 225 53 l 225 -517 l 271 -517 l 271 53 l 495 -248 l 495 -89 l 248 248 b 89 89 170 143 118 89 b 45 157 60 89 45 112 l 0 157 b 68 3 0 68 23 16 z',
    },
    accSagittal5v49MediumDiesisDown: {
      x_min: 0,
      x_max: 344,
      y_min: -172,
      y_max: 359,
      ha: 531,
      o: 'm 0 89 l 0 248 l 225 -53 l 225 517 l 271 517 l 271 -53 l 495 248 l 495 89 l 248 -248 b 89 -89 170 -143 118 -89 b 45 -157 60 -89 45 -112 l 0 -157 b 68 -3 0 -68 23 -16 z',
    },
    accSagittal49LargeDiesisUp: {
      x_min: 0,
      x_max: 281,
      y_min: -359,
      y_max: 172,
      ha: 531,
      o: 'm 45 12 l 45 112 l 180 112 b 360 -68 300 112 360 53 l 360 -147 z m 0 -517 l 45 -517 l 45 -89 l 360 -248 l 405 -248 l 405 -68 b 180 248 405 143 330 248 l 0 248 z',
    },
    accSagittal49LargeDiesisDown: {
      x_min: 0,
      x_max: 281,
      y_min: -172,
      y_max: 359,
      ha: 531,
      o: 'm 0 517 l 45 517 l 45 89 l 360 248 l 405 248 l 405 68 b 180 -248 405 -143 330 -248 l 0 -248 z m 45 -12 l 45 -112 l 180 -112 b 360 68 300 -112 360 -53 l 360 147 z',
    },
    accSagittal11v19LargeDiesisUp: {
      x_min: 0,
      x_max: 312,
      y_min: -359,
      y_max: 172,
      ha: 531,
      o: 'm 0 -517 l 45 -517 l 45 -86 l 449 -256 l 449 -157 l 45 13 l 45 138 l 449 -30 l 449 68 l 23 248 l 0 248 z',
    },
    accSagittal11v19LargeDiesisDown: {
      x_min: 0,
      x_max: 312,
      y_min: -172,
      y_max: 359,
      ha: 531,
      o: 'm 0 517 l 45 517 l 45 86 l 449 256 l 449 157 l 45 -13 l 45 -138 l 449 30 l 449 -68 l 23 -248 l 0 -248 z',
    },
    accSagittal5v13LargeDiesisUp: {
      x_min: 0,
      x_max: 438,
      y_min: -359,
      y_max: 172,
      ha: 531,
      o: 'm 0 68 b 89 -112 0 -52 30 -112 b 180 -35 125 -112 157 -86 l 180 -517 l 225 -517 l 225 -86 l 631 -256 l 631 -157 l 225 13 l 225 138 l 631 -30 l 631 68 l 203 248 b 101 0 173 98 138 16 b 81 -3 94 0 86 -3 b 45 68 56 -3 45 20 z',
    },
    accSagittal5v13LargeDiesisDown: {
      x_min: 0,
      x_max: 438,
      y_min: -172,
      y_max: 359,
      ha: 531,
      o: 'm 0 -68 b 89 112 0 52 30 112 b 180 35 125 112 157 86 l 180 517 l 225 517 l 225 86 l 631 256 l 631 157 l 225 -13 l 225 -138 l 631 30 l 631 -68 l 203 -248 b 101 0 173 -98 138 -16 b 81 3 94 0 86 3 b 45 -68 56 3 45 -20 z',
    },
    accSagittalSharp23SDown: {
      x_min: 0,
      x_max: 250,
      y_min: -359,
      y_max: 172,
      ha: 531,
      o: 'm 0 -203 l 45 -203 b 112 -23 45 -84 68 -23 l 135 -23 l 135 -517 l 180 -517 l 180 -23 l 271 -23 b 315 6 287 -23 301 -13 l 315 -517 l 360 -517 l 360 248 l 337 248 b 248 68 312 127 282 68 l 194 68 b 89 157 125 68 89 98 l 45 157 b 60 59 45 118 50 85 b 0 -203 20 30 0 -56 z',
    },
    accSagittalFlat23SUp: {
      x_min: 0,
      x_max: 250,
      y_min: -172,
      y_max: 359,
      ha: 531,
      o: 'm 0 203 l 45 203 b 112 23 45 84 68 23 l 135 23 l 135 517 l 180 517 l 180 23 l 271 23 b 315 -6 287 23 301 13 l 315 517 l 360 517 l 360 -248 l 337 -248 b 248 -68 312 -127 282 -68 l 194 -68 b 89 -157 125 -68 89 -98 l 45 -157 b 60 -59 45 -118 50 -85 b 0 203 20 -30 0 56 z',
    },
    accSagittalSharp49SDown: {
      x_min: 0,
      x_max: 250,
      y_min: -359,
      y_max: 172,
      ha: 531,
      o: 'm 0 -292 l 45 -292 b 112 -157 45 -203 68 -157 l 135 -157 l 135 -517 l 180 -517 l 180 -157 l 271 -157 b 315 -135 285 -157 300 -150 l 315 -517 l 360 -517 l 360 248 l 337 248 b 248 157 323 187 292 157 l 89 157 b 0 -68 30 157 0 82 l 45 -68 b 112 68 45 23 68 68 l 271 68 b 315 89 284 68 300 75 l 315 -32 b 248 -68 298 -56 275 -68 l 89 -68 b 0 -292 29 -68 0 -143 z',
    },
    accSagittalFlat49SUp: {
      x_min: 0,
      x_max: 250,
      y_min: -172,
      y_max: 359,
      ha: 531,
      o: 'm 0 292 l 45 292 b 112 157 45 203 68 157 l 135 157 l 135 517 l 180 517 l 180 157 l 271 157 b 315 135 285 157 300 150 l 315 517 l 360 517 l 360 -248 l 337 -248 b 248 -157 323 -187 292 -157 l 89 -157 b 0 68 30 -157 0 -82 l 45 68 b 112 -68 45 -23 68 -68 l 271 -68 b 315 -89 284 -68 300 -75 l 315 32 b 248 68 298 56 275 68 l 89 68 b 0 292 29 68 0 143 z',
    },
    accSagittalSharp7v19CDown: {
      x_min: 0,
      x_max: 250,
      y_min: -359,
      y_max: 172,
      ha: 531,
      o: 'm 0 -112 l 0 -271 l 135 -125 l 135 -517 l 180 -517 l 180 -78 l 315 65 l 315 -517 l 360 -517 l 360 248 l 337 248 b 118 89 239 143 166 89 b 45 157 68 89 45 112 l 0 157 b 89 -20 0 53 29 -6 z',
    },
    accSagittalFlat7v19CUp: {
      x_min: 0,
      x_max: 250,
      y_min: -172,
      y_max: 359,
      ha: 531,
      o: 'm 0 112 l 0 271 l 135 125 l 135 517 l 180 517 l 180 78 l 315 -65 l 315 517 l 360 517 l 360 -248 l 337 -248 b 118 -89 239 -143 166 -89 b 45 -157 68 -89 45 -112 l 0 -157 b 89 20 0 -53 29 6 z',
    },
    accSagittalSharp19CDown: {
      x_min: 0,
      x_max: 281,
      y_min: -359,
      y_max: 172,
      ha: 531,
      o: 'm 0 -248 l 45 -248 l 45 -68 b 180 96 45 17 89 72 l 180 -517 l 225 -517 l 225 107 b 315 112 252 112 282 112 l 360 112 l 360 -517 l 405 -517 l 405 248 l 271 248 b 0 68 89 248 0 187 z',
    },
    accSagittalFlat19CUp: {
      x_min: 0,
      x_max: 281,
      y_min: -172,
      y_max: 359,
      ha: 531,
      o: 'm 0 248 l 45 248 l 45 68 b 180 -96 45 -17 89 -72 l 180 517 l 225 517 l 225 -107 b 315 -112 252 -112 282 -112 l 360 -112 l 360 517 l 405 517 l 405 -248 l 271 -248 b 0 -68 89 -248 0 -187 z',
    },
    accSagittalSharp11v49CDown: {
      x_min: 0,
      x_max: 344,
      y_min: -359,
      y_max: 172,
      ha: 531,
      o: 'm 45 -203 b 112 -23 45 -82 68 -23 l 135 -23 l 135 -517 l 180 -517 l 180 -23 b 271 112 215 -23 245 23 l 315 112 l 315 -517 l 360 -517 l 360 107 b 449 -68 420 89 449 30 l 449 -248 l 495 -248 l 495 68 b 360 248 495 189 449 248 l 248 248 b 157 68 222 128 192 68 l 89 68 b 0 -203 30 68 0 -23 z',
    },
    accSagittalFlat11v49CUp: {
      x_min: 0,
      x_max: 344,
      y_min: -172,
      y_max: 359,
      ha: 531,
      o: 'm 45 203 b 112 23 45 82 68 23 l 135 23 l 135 517 l 180 517 l 180 23 b 271 -112 215 23 245 -23 l 315 -112 l 315 517 l 360 517 l 360 -107 b 449 68 420 -89 449 -30 l 449 248 l 495 248 l 495 -68 b 360 -248 495 -189 449 -248 l 248 -248 b 157 -68 222 -128 192 -68 l 89 -68 b 0 203 30 -68 0 23 z',
    },
    accSagittalSharp143CDown: {
      x_min: 0,
      x_max: 406,
      y_min: -359,
      y_max: 172,
      ha: 531,
      o: 'm 45 -203 b 112 -23 45 -84 68 -23 l 135 -23 l 135 -517 l 180 -517 l 180 -23 b 259 76 210 -23 236 10 l 315 17 l 315 -517 l 360 -517 l 360 -30 l 585 -271 l 585 -112 l 248 248 b 157 68 222 127 192 68 l 89 68 b 0 -203 30 68 0 -23 z',
    },
    accSagittalFlat143CUp: {
      x_min: 0,
      x_max: 406,
      y_min: -172,
      y_max: 359,
      ha: 531,
      o: 'm 45 203 b 112 23 45 84 68 23 l 135 23 l 135 517 l 180 517 l 180 23 b 259 -76 210 23 236 -10 l 315 -17 l 315 517 l 360 517 l 360 30 l 585 271 l 585 112 l 248 -248 b 157 -68 222 -127 192 -68 l 89 -68 b 0 203 30 -68 0 23 z',
    },
    accSagittalSharp17kDown: {
      x_min: 0,
      x_max: 312,
      y_min: -359,
      y_max: 172,
      ha: 531,
      o: 'm 0 -157 l 0 -256 l 225 -161 l 225 -517 l 271 -517 l 271 -144 l 405 -86 l 405 -517 l 449 -517 l 449 248 l 428 248 b 145 171 305 196 210 171 b 45 248 78 171 45 196 l 0 248 b 79 101 0 170 26 121 l 0 68 l 0 -32 l 405 138 l 405 13 z',
    },
    accSagittalFlat17kUp: {
      x_min: 0,
      x_max: 312,
      y_min: -172,
      y_max: 359,
      ha: 531,
      o: 'm 0 157 l 0 256 l 225 161 l 225 517 l 271 517 l 271 144 l 405 86 l 405 517 l 449 517 l 449 -248 l 428 -248 b 145 -171 305 -196 210 -171 b 45 -248 78 -171 45 -196 l 0 -248 b 79 -101 0 -170 26 -121 l 0 -68 l 0 32 l 405 -138 l 405 -13 z',
    },
    accSagittalSharp19sDown: {
      x_min: 0,
      x_max: 406,
      y_min: -359,
      y_max: 172,
      ha: 531,
      o: 'm 0 -248 l 45 -248 l 45 -68 b 180 109 45 36 89 95 l 180 -517 l 225 -517 l 225 112 l 271 112 b 360 -23 295 23 325 -23 l 360 -517 l 405 -517 l 405 -23 l 472 -23 b 540 -203 517 -23 540 -84 l 585 -203 b 495 68 585 -23 554 68 l 383 68 b 292 248 348 68 318 127 l 180 248 b 0 68 60 248 0 187 z',
    },
    accSagittalFlat19sUp: {
      x_min: 0,
      x_max: 406,
      y_min: -172,
      y_max: 359,
      ha: 531,
      o: 'm 0 248 l 45 248 l 45 68 b 180 -109 45 -36 89 -95 l 180 517 l 225 517 l 225 -112 l 271 -112 b 360 23 295 -23 325 23 l 360 517 l 405 517 l 405 23 l 472 23 b 540 203 517 23 540 84 l 585 203 b 495 -68 585 23 554 -68 l 383 -68 b 292 -248 348 -68 318 -127 l 180 -248 b 0 -68 60 -248 0 -187 z',
    },
    accSagittalSharp19sUp: {
      x_min: 0,
      x_max: 281,
      y_min: -359,
      y_max: 172,
      ha: 531,
      o: 'm 89 -96 l 89 -517 l 135 -517 l 135 -108 b 180 -112 148 -112 163 -112 b 225 -108 196 -112 210 -112 l 225 -517 l 271 -517 l 271 -94 b 360 -12 305 -78 337 -50 l 360 -517 l 405 -517 l 405 248 l 383 248 b 190 0 353 98 288 16 b 138 -3 171 0 153 -3 b 45 68 75 -3 45 20 l 0 68 b 89 -96 0 -17 30 -72 z',
    },
    accSagittalFlat19sDown: {
      x_min: 0,
      x_max: 281,
      y_min: -172,
      y_max: 359,
      ha: 531,
      o: 'm 89 96 l 89 517 l 135 517 l 135 108 b 180 112 148 112 163 112 b 225 108 196 112 210 112 l 225 517 l 271 517 l 271 94 b 360 12 305 78 337 50 l 360 517 l 405 517 l 405 -248 l 383 -248 b 190 0 353 -98 288 -16 b 138 3 171 0 153 3 b 45 -68 75 3 45 -20 l 0 -68 b 89 96 0 17 30 72 z',
    },
    accSagittalSharp17kUp: {
      x_min: 0,
      x_max: 312,
      y_min: -359,
      y_max: 172,
      ha: 531,
      o: 'm 45 -203 b 135 -23 45 -84 75 -23 l 135 -517 l 180 -517 l 180 -23 l 271 -23 l 271 -517 l 315 -517 l 315 -23 l 337 -23 b 405 14 363 -23 386 -10 l 405 -517 l 449 -517 l 449 248 l 428 248 b 315 68 402 127 364 68 l 112 68 b 0 -203 37 68 0 -23 z',
    },
    accSagittalFlat17kDown: {
      x_min: 0,
      x_max: 312,
      y_min: -172,
      y_max: 359,
      ha: 531,
      o: 'm 45 203 b 135 23 45 84 75 23 l 135 517 l 180 517 l 180 23 l 271 23 l 271 517 l 315 517 l 315 23 l 337 23 b 405 -14 363 23 386 10 l 405 517 l 449 517 l 449 -248 l 428 -248 b 315 -68 402 -127 364 -68 l 112 -68 b 0 203 37 -68 0 23 z',
    },
    accSagittalSharp143CUp: {
      x_min: 0,
      x_max: 312,
      y_min: -359,
      y_max: 172,
      ha: 531,
      o: 'm 45 -203 b 135 -23 45 -84 75 -23 l 135 -517 l 180 -517 l 180 -23 l 271 -23 l 271 -517 l 315 -517 l 315 -23 l 337 -23 b 405 14 363 -23 386 -10 l 405 -517 l 449 -517 l 449 248 l 428 248 b 315 68 402 127 364 68 l 240 68 b 89 157 140 68 89 98 l 45 157 b 68 53 45 115 52 81 b 0 -203 23 23 0 -63 z',
    },
    accSagittalFlat143CDown: {
      x_min: 0,
      x_max: 312,
      y_min: -172,
      y_max: 359,
      ha: 531,
      o: 'm 45 203 b 135 23 45 84 75 23 l 135 517 l 180 517 l 180 23 l 271 23 l 271 517 l 315 517 l 315 23 l 337 23 b 405 -14 363 23 386 10 l 405 517 l 449 517 l 449 -248 l 428 -248 b 315 -68 402 -127 364 -68 l 240 -68 b 89 -157 140 -68 89 -98 l 45 -157 b 68 -53 45 -115 52 -81 b 0 203 23 -23 0 63 z',
    },
    accSagittalSharp11v49CUp: {
      x_min: 0,
      x_max: 312,
      y_min: -359,
      y_max: 172,
      ha: 531,
      o: 'm 45 -68 b 135 68 45 23 76 68 l 337 68 b 405 95 363 68 386 76 l 405 -27 b 315 -68 386 -55 356 -68 l 112 -68 b 0 -292 37 -68 0 -143 l 45 -292 b 135 -157 45 -203 75 -157 l 135 -517 l 180 -517 l 180 -157 l 271 -157 l 271 -517 l 315 -517 l 315 -157 l 337 -157 b 405 -130 360 -157 383 -148 l 405 -517 l 449 -517 l 449 248 l 428 248 b 315 157 413 187 376 157 l 112 157 b 0 -68 37 157 0 82 z',
    },
    accSagittalFlat11v49CDown: {
      x_min: 0,
      x_max: 312,
      y_min: -172,
      y_max: 359,
      ha: 531,
      o: 'm 45 68 b 135 -68 45 -23 76 -68 l 337 -68 b 405 -95 363 -68 386 -76 l 405 27 b 315 68 386 55 356 68 l 112 68 b 0 292 37 68 0 143 l 45 292 b 135 157 45 203 75 157 l 135 517 l 180 517 l 180 157 l 271 157 l 271 517 l 315 517 l 315 157 l 337 157 b 405 130 360 157 383 148 l 405 517 l 449 517 l 449 -248 l 428 -248 b 315 -157 413 -187 376 -157 l 112 -157 b 0 68 37 -157 0 -82 z',
    },
    accSagittalSharp19CUp: {
      x_min: 0,
      x_max: 375,
      y_min: -359,
      y_max: 172,
      ha: 531,
      o: 'm 89 -109 l 89 -517 l 135 -517 l 135 -109 b 225 -27 170 -102 200 -75 l 225 -517 l 271 -517 l 271 14 b 337 -23 289 -10 311 -23 l 360 -23 l 360 -517 l 405 -517 l 405 -23 b 495 -203 465 -23 495 -82 l 540 -203 b 428 68 540 -23 503 68 l 360 68 b 248 248 310 68 271 128 b 122 0 217 98 176 16 b 95 -3 112 0 104 -3 b 45 68 60 -3 45 20 l 0 68 b 89 -109 0 -39 30 -98 z',
    },
    accSagittalFlat19CDown: {
      x_min: 0,
      x_max: 375,
      y_min: -172,
      y_max: 359,
      ha: 531,
      o: 'm 89 109 l 89 517 l 135 517 l 135 109 b 225 27 170 102 200 75 l 225 517 l 271 517 l 271 -14 b 337 23 289 10 311 23 l 360 23 l 360 517 l 405 517 l 405 23 b 495 203 465 23 495 82 l 540 203 b 428 -68 540 23 503 -68 l 360 -68 b 248 -248 310 -68 271 -128 b 122 0 217 -98 176 -16 b 95 3 112 0 104 3 b 45 -68 60 3 45 -20 l 0 -68 b 89 109 0 39 30 98 z',
    },
    accSagittalSharp7v19CUp: {
      x_min: 0,
      x_max: 375,
      y_min: -359,
      y_max: 172,
      ha: 531,
      o: 'm 89 -109 l 89 -517 l 135 -517 l 135 -109 b 225 -27 170 -102 200 -75 l 225 -517 l 271 -517 l 271 112 l 315 112 b 360 109 331 112 346 112 l 360 -517 l 405 -517 l 405 98 b 495 -68 465 73 495 19 l 495 -248 l 540 -248 l 540 68 b 360 248 540 189 480 248 l 248 248 b 122 0 217 98 176 16 b 95 -3 112 0 104 -3 b 45 68 60 -3 45 20 l 0 68 b 89 -109 0 -39 30 -98 z',
    },
    accSagittalFlat7v19CDown: {
      x_min: 0,
      x_max: 375,
      y_min: -172,
      y_max: 359,
      ha: 531,
      o: 'm 89 109 l 89 517 l 135 517 l 135 109 b 225 27 170 102 200 75 l 225 517 l 271 517 l 271 -112 l 315 -112 b 360 -109 331 -112 346 -112 l 360 517 l 405 517 l 405 -98 b 495 68 465 -73 495 -19 l 495 248 l 540 248 l 540 -68 b 360 -248 540 -189 480 -248 l 248 -248 b 122 0 217 -98 176 -16 b 95 3 112 0 104 3 b 45 -68 60 3 45 -20 l 0 -68 b 89 109 0 39 30 98 z',
    },
    accSagittalSharp49SUp: {
      x_min: 0,
      x_max: 406,
      y_min: -359,
      y_max: 172,
      ha: 531,
      o: 'm 45 -203 b 135 -23 45 -84 75 -23 l 135 -517 l 180 -517 l 180 -23 l 203 -23 b 271 14 229 -23 251 -10 l 271 -517 l 315 -517 l 315 112 l 360 112 b 405 109 376 112 390 112 l 405 -517 l 449 -517 l 449 96 b 540 -68 510 72 540 17 l 540 -248 l 585 -248 l 585 68 b 405 248 585 187 526 248 l 292 248 b 180 68 268 127 230 68 l 112 68 b 0 -203 37 68 0 -23 z',
    },
    accSagittalFlat49SDown: {
      x_min: 0,
      x_max: 406,
      y_min: -172,
      y_max: 359,
      ha: 531,
      o: 'm 45 203 b 135 23 45 84 75 23 l 135 517 l 180 517 l 180 23 l 203 23 b 271 -14 229 23 251 10 l 271 517 l 315 517 l 315 -112 l 360 -112 b 405 -109 376 -112 390 -112 l 405 517 l 449 517 l 449 -96 b 540 68 510 -72 540 -17 l 540 248 l 585 248 l 585 -68 b 405 -248 585 -187 526 -248 l 292 -248 b 180 -68 268 -127 230 -68 l 112 -68 b 0 203 37 -68 0 23 z',
    },
    accSagittalSharp23SUp: {
      x_min: 0,
      x_max: 469,
      y_min: -359,
      y_max: 172,
      ha: 531,
      o: 'm 45 -203 b 135 -23 45 -84 75 -23 l 135 -517 l 180 -517 l 180 -23 l 203 -23 b 271 14 229 -23 251 -10 l 271 -517 l 315 -517 l 315 71 l 405 -14 l 405 -517 l 449 -517 l 449 -56 l 675 -268 l 675 -112 l 292 248 b 180 68 268 127 230 68 l 112 68 b 0 -203 37 68 0 -23 z',
    },
    accSagittalFlat23SDown: {
      x_min: 0,
      x_max: 469,
      y_min: -172,
      y_max: 359,
      ha: 531,
      o: 'm 45 203 b 135 23 45 84 75 23 l 135 517 l 180 517 l 180 23 l 203 23 b 271 -14 229 23 251 10 l 271 517 l 315 517 l 315 -71 l 405 14 l 405 517 l 449 517 l 449 56 l 675 268 l 675 112 l 292 -248 b 180 -68 268 -127 230 -68 l 112 -68 b 0 203 37 -68 0 23 z',
    },
    accSagittalSharp5v13MUp: {
      x_min: 0,
      x_max: 375,
      y_min: -359,
      y_max: 172,
      ha: 531,
      o: 'm 495 141 l 495 14 l 0 -157 l 0 -256 l 225 -180 l 225 -517 l 271 -517 l 271 -161 l 360 -130 l 360 -517 l 405 -517 l 405 -115 l 495 -84 l 495 -517 l 540 -517 l 540 248 l 517 248 b 167 168 366 194 248 168 b 45 248 85 168 45 194 l 0 248 b 95 99 0 170 30 120 l 0 68 l 0 -30 z',
    },
    accSagittalFlat5v13MDown: {
      x_min: 0,
      x_max: 375,
      y_min: -172,
      y_max: 359,
      ha: 531,
      o: 'm 495 -141 l 495 -14 l 0 157 l 0 256 l 225 180 l 225 517 l 271 517 l 271 161 l 360 130 l 360 517 l 405 517 l 405 115 l 495 84 l 495 517 l 540 517 l 540 -248 l 517 -248 b 167 -168 366 -194 248 -168 b 45 -248 85 -168 45 -194 l 0 -248 b 95 -99 0 -170 30 -120 l 0 -68 l 0 30 z',
    },
    accSagittalSharp11v19MUp: {
      x_min: 0,
      x_max: 438,
      y_min: -359,
      y_max: 172,
      ha: 531,
      o: 'm 0 68 l 0 -248 l 45 -248 l 45 -68 b 180 104 45 26 89 82 l 180 -517 l 225 -517 l 225 112 l 271 112 l 315 112 l 315 -517 l 360 -517 l 360 14 b 428 -23 379 -10 402 -23 l 449 -23 l 449 -517 l 495 -517 l 495 -23 b 585 -203 554 -23 585 -84 l 631 -203 b 517 68 631 -23 593 68 l 449 68 b 337 248 400 68 363 127 l 225 248 b 0 68 75 248 0 187 z',
    },
    accSagittalFlat11v19MDown: {
      x_min: 0,
      x_max: 438,
      y_min: -172,
      y_max: 359,
      ha: 531,
      o: 'm 0 -68 l 0 248 l 45 248 l 45 68 b 180 -104 45 -26 89 -82 l 180 517 l 225 517 l 225 -112 l 271 -112 l 315 -112 l 315 517 l 360 517 l 360 -14 b 428 23 379 10 402 23 l 449 23 l 449 517 l 495 517 l 495 23 b 585 203 554 23 585 84 l 631 203 b 517 -68 631 23 593 -68 l 449 -68 b 337 -248 400 -68 363 -127 l 225 -248 b 0 -68 75 -248 0 -187 z',
    },
    accSagittalSharp49MUp: {
      x_min: 0,
      x_max: 375,
      y_min: -359,
      y_max: 172,
      ha: 531,
      o: 'm 45 -145 l 45 -68 b 360 112 45 53 150 112 l 495 112 l 495 14 z m 0 -248 l 45 -248 l 225 -180 l 225 -517 l 271 -517 l 271 -166 l 360 -132 l 360 -517 l 405 -517 l 405 -117 l 495 -84 l 495 -517 l 540 -517 l 540 248 l 360 248 b 0 -68 120 248 0 143 z',
    },
    accSagittalFlat49MDown: {
      x_min: 0,
      x_max: 375,
      y_min: -172,
      y_max: 359,
      ha: 531,
      o: 'm 0 248 l 45 248 l 225 180 l 225 517 l 271 517 l 271 166 l 360 132 l 360 517 l 405 517 l 405 117 l 495 84 l 495 517 l 540 517 l 540 -248 l 360 -248 b 0 68 120 -248 0 -143 z m 45 145 l 45 68 b 360 -112 45 -53 150 -112 l 495 -112 l 495 -14 z',
    },
    accSagittalSharp5v49MUp: {
      x_min: 0,
      x_max: 469,
      y_min: -359,
      y_max: 172,
      ha: 531,
      o: 'm 0 -271 l 180 -79 l 180 -517 l 225 -517 l 225 -30 l 315 65 l 315 -517 l 360 -517 l 360 65 l 449 -30 l 449 -517 l 495 -517 l 495 -79 l 675 -271 l 675 -112 l 337 248 b 118 89 239 143 166 89 b 45 157 68 89 45 112 l 0 157 b 107 0 0 62 36 10 l 0 -112 z',
    },
    accSagittalFlat5v49MDown: {
      x_min: 0,
      x_max: 469,
      y_min: -172,
      y_max: 359,
      ha: 531,
      o: 'm 0 271 l 180 79 l 180 517 l 225 517 l 225 30 l 315 -65 l 315 517 l 360 517 l 360 -65 l 449 30 l 449 517 l 495 517 l 495 79 l 675 271 l 675 112 l 337 -248 b 118 -89 239 -143 166 -89 b 45 -157 68 -89 45 -112 l 0 -157 b 107 0 0 -62 36 -10 l 0 112 z',
    },
    accSagittalSharp49LUp: {
      x_min: 0,
      x_max: 406,
      y_min: -359,
      y_max: 172,
      ha: 531,
      o: 'm 45 112 l 180 112 b 540 -68 420 112 540 53 l 540 -145 l 45 16 z m 0 -517 l 45 -517 l 45 -82 l 135 -112 l 135 -517 l 180 -517 l 180 -127 l 271 -157 l 271 -517 l 315 -517 l 315 -173 l 540 -248 l 585 -248 l 585 -68 b 180 248 585 143 449 248 l 0 248 z',
    },
    accSagittalFlat49LDown: {
      x_min: 0,
      x_max: 406,
      y_min: -172,
      y_max: 359,
      ha: 531,
      o: 'm 0 517 l 45 517 l 45 82 l 135 112 l 135 517 l 180 517 l 180 127 l 271 157 l 271 517 l 315 517 l 315 173 l 540 248 l 585 248 l 585 68 b 180 -248 585 -143 449 -248 l 0 -248 z m 45 -112 l 180 -112 b 540 68 420 -112 540 -53 l 540 145 l 45 -16 z',
    },
    accSagittalSharp11v19LUp: {
      x_min: 0,
      x_max: 438,
      y_min: -359,
      y_max: 172,
      ha: 531,
      o: 'm 0 -517 l 45 -517 l 45 -81 l 135 -108 l 135 -517 l 180 -517 l 180 -121 l 271 -148 l 271 -517 l 315 -517 l 315 -161 l 631 -255 l 631 -157 l 45 16 l 45 144 l 631 -30 l 631 68 l 23 248 l 0 248 z',
    },
    accSagittalFlat11v19LDown: {
      x_min: 0,
      x_max: 438,
      y_min: -172,
      y_max: 359,
      ha: 531,
      o: 'm 0 517 l 45 517 l 45 81 l 135 108 l 135 517 l 180 517 l 180 121 l 271 148 l 271 517 l 315 517 l 315 161 l 631 255 l 631 157 l 45 -16 l 45 -144 l 631 30 l 631 -68 l 23 -248 l 0 -248 z',
    },
    accSagittalSharp5v13LUp: {
      x_min: 0,
      x_max: 500,
      y_min: -359,
      y_max: 172,
      ha: 531,
      o: 'm 89 -109 l 89 -517 l 135 -517 l 135 -109 b 225 -27 170 -102 200 -75 l 225 -517 l 271 -517 l 271 -85 l 360 -120 l 360 -517 l 405 -517 l 405 -135 l 720 -256 l 720 -157 l 271 14 l 271 141 l 720 -30 l 720 68 l 248 248 b 122 0 217 98 176 16 b 95 -3 112 0 104 -3 b 45 68 60 -3 45 20 l 0 68 b 89 -109 0 -39 30 -98 z',
    },
    accSagittalFlat5v13LDown: {
      x_min: 0,
      x_max: 500,
      y_min: -172,
      y_max: 359,
      ha: 531,
      o: 'm 89 109 l 89 517 l 135 517 l 135 109 b 225 27 170 102 200 75 l 225 517 l 271 517 l 271 85 l 360 120 l 360 517 l 405 517 l 405 135 l 720 256 l 720 157 l 271 -14 l 271 -141 l 720 30 l 720 -68 l 248 -248 b 122 0 217 -98 176 -16 b 95 3 112 0 104 3 b 45 -68 60 3 45 -20 l 0 -68 b 89 109 0 39 30 98 z',
    },
    accSagittalDoubleSharp23SDown: {
      x_min: 0,
      x_max: 375,
      y_min: -359,
      y_max: 172,
      ha: 531,
      o: 'm 0 -203 l 45 -203 b 135 -23 45 -82 76 -23 l 301 -23 l 135 -503 l 186 -517 l 337 -82 l 488 -517 l 540 -503 l 370 -14 b 449 112 423 10 449 53 l 449 248 l 428 248 b 315 68 402 127 364 68 l 240 68 b 89 157 140 68 89 98 l 45 157 b 68 53 45 115 52 81 b 0 -203 23 23 0 -63 z',
    },
    accSagittalDoubleFlat23SUp: {
      x_min: 0,
      x_max: 375,
      y_min: -172,
      y_max: 359,
      ha: 531,
      o: 'm 0 203 l 45 203 b 135 23 45 82 76 23 l 301 23 l 135 503 l 186 517 l 337 82 l 488 517 l 540 503 l 370 14 b 449 -112 423 -10 449 -53 l 449 -248 l 428 -248 b 315 -68 402 -127 364 -68 l 240 -68 b 89 -157 140 -68 89 -98 l 45 -157 b 68 -53 45 -115 52 -81 b 0 203 23 -23 0 63 z',
    },
    accSagittalDoubleSharp49SDown: {
      x_min: 0,
      x_max: 375,
      y_min: -359,
      y_max: 172,
      ha: 531,
      o: 'm 0 -292 l 45 -292 b 112 -157 45 -203 68 -157 l 256 -157 l 135 -503 l 187 -517 l 337 -82 l 490 -517 l 540 -503 l 366 0 l 396 89 b 449 157 416 102 435 125 l 449 248 l 428 248 b 315 157 413 187 376 157 l 112 157 b 0 -68 39 157 0 82 l 45 -68 b 135 68 45 23 76 68 l 287 68 l 311 0 l 288 -68 l 89 -68 b 0 -292 32 -68 0 -144 z',
    },
    accSagittalDoubleFlat49SUp: {
      x_min: 0,
      x_max: 375,
      y_min: -172,
      y_max: 359,
      ha: 531,
      o: 'm 0 292 l 45 292 b 112 157 45 203 68 157 l 256 157 l 135 503 l 187 517 l 337 82 l 490 517 l 540 503 l 366 0 l 396 -89 b 449 -157 416 -102 435 -125 l 449 -248 l 428 -248 b 315 -157 413 -187 376 -157 l 112 -157 b 0 68 39 -157 0 -82 l 45 68 b 135 -68 45 -23 76 -68 l 287 -68 l 311 0 l 288 68 l 89 68 b 0 292 32 68 0 144 z',
    },
    accSagittalDoubleSharp7v19CDown: {
      x_min: 0,
      x_max: 375,
      y_min: -359,
      y_max: 172,
      ha: 531,
      o: 'm 0 -112 l 0 -266 l 307 -7 l 135 -503 l 186 -517 l 337 -82 l 488 -517 l 540 -503 l 366 0 l 386 59 l 449 112 l 449 248 l 428 248 b 130 68 285 127 186 68 b 45 157 73 68 45 98 l 0 157 b 112 -20 0 53 37 -6 z',
    },
    accSagittalDoubleFlat7v19CUp: {
      x_min: 0,
      x_max: 375,
      y_min: -172,
      y_max: 359,
      ha: 531,
      o: 'm 0 112 l 0 266 l 307 7 l 135 503 l 186 517 l 337 82 l 488 517 l 540 503 l 366 0 l 386 -59 l 449 -112 l 449 -248 l 428 -248 b 130 -68 285 -127 186 -68 b 45 -157 73 -68 45 -98 l 0 -157 b 112 20 0 -53 37 6 z',
    },
    accSagittalDoubleSharp19CDown: {
      x_min: 0,
      x_max: 406,
      y_min: -359,
      y_max: 172,
      ha: 531,
      o: 'm 372 112 l 393 112 l 383 82 z m 0 68 l 0 -248 l 45 -248 l 45 -68 b 315 109 45 36 135 95 l 354 0 l 180 -503 l 232 -517 l 383 -82 l 534 -517 l 585 -503 l 410 0 l 449 112 l 495 112 l 495 248 l 360 248 b 0 68 120 248 0 187 z',
    },
    accSagittalDoubleFlat19CUp: {
      x_min: 0,
      x_max: 406,
      y_min: -172,
      y_max: 359,
      ha: 531,
      o: 'm 0 -68 l 0 248 l 45 248 l 45 68 b 315 -109 45 -36 135 -95 l 354 0 l 180 503 l 232 517 l 383 82 l 534 517 l 585 503 l 410 0 l 449 -112 l 495 -112 l 495 -248 l 360 -248 b 0 -68 120 -248 0 -187 z m 372 -112 l 393 -112 l 383 -82 z',
    },
    accSagittalDoubleSharp11v49CDown: {
      x_min: 0,
      x_max: 406,
      y_min: -359,
      y_max: 172,
      ha: 531,
      o: 'm 45 -203 b 135 -23 45 -84 75 -23 l 203 -23 b 262 4 225 -23 245 -13 l 265 0 l 89 -503 l 141 -517 l 292 -82 l 444 -517 l 495 -503 l 321 0 l 360 112 b 540 -68 480 112 540 53 l 540 -248 l 585 -248 l 585 68 b 405 248 585 187 526 248 l 292 248 b 180 68 268 127 230 68 l 112 68 b 0 -203 37 68 0 -23 z',
    },
    accSagittalDoubleFlat11v49CUp: {
      x_min: 0,
      x_max: 406,
      y_min: -172,
      y_max: 359,
      ha: 531,
      o: 'm 45 203 b 135 23 45 84 75 23 l 203 23 b 262 -4 225 23 245 13 l 265 0 l 89 503 l 141 517 l 292 82 l 444 517 l 495 503 l 321 0 l 360 -112 b 540 68 480 -112 540 -53 l 540 248 l 585 248 l 585 -68 b 405 -248 585 -187 526 -248 l 292 -248 b 180 -68 268 -127 230 -68 l 112 -68 b 0 203 37 -68 0 23 z',
    },
    accSagittalDoubleSharp143CDown: {
      x_min: 0,
      x_max: 469,
      y_min: -359,
      y_max: 172,
      ha: 531,
      o: 'm 45 -203 b 135 -23 45 -84 75 -23 l 203 -23 b 262 4 225 -23 245 -13 l 265 0 l 89 -503 l 141 -517 l 292 -82 l 444 -517 l 495 -503 l 321 0 l 337 49 l 675 -268 l 675 -112 l 292 248 b 180 68 268 127 230 68 l 112 68 b 0 -203 37 68 0 -23 z',
    },
    accSagittalDoubleFlat143CUp: {
      x_min: 0,
      x_max: 469,
      y_min: -172,
      y_max: 359,
      ha: 531,
      o: 'm 45 203 b 135 23 45 84 75 23 l 203 23 b 262 -4 225 23 245 13 l 265 0 l 89 503 l 141 517 l 292 82 l 444 517 l 495 503 l 321 0 l 337 -49 l 675 268 l 675 112 l 292 -248 b 180 -68 268 -127 230 -68 l 112 -68 b 0 203 37 -68 0 23 z',
    },
    accSagittalDoubleSharp17kDown: {
      x_min: 0,
      x_max: 438,
      y_min: -359,
      y_max: 172,
      ha: 531,
      o: 'm 416 115 l 442 124 l 428 82 z m 0 248 b 95 101 0 170 30 121 l 0 68 l 0 -30 l 364 96 l 399 0 l 390 -23 l 0 -157 l 0 -255 l 353 -135 l 225 -503 l 275 -517 l 428 -82 l 577 -517 l 631 -503 l 455 0 l 507 145 l 540 157 l 540 248 l 517 248 b 167 168 366 194 248 168 b 45 248 85 168 45 194 z',
    },
    accSagittalDoubleFlat17kUp: {
      x_min: 0,
      x_max: 438,
      y_min: -172,
      y_max: 359,
      ha: 531,
      o: 'm 0 -248 b 95 -101 0 -170 30 -121 l 0 -68 l 0 30 l 364 -96 l 399 0 l 390 23 l 0 157 l 0 255 l 353 135 l 225 503 l 275 517 l 428 82 l 577 517 l 631 503 l 455 0 l 507 -145 l 540 -157 l 540 -248 l 517 -248 b 167 -168 366 -194 248 -168 b 45 -248 85 -168 45 -194 z m 416 -115 l 442 -124 l 428 -82 z',
    },
    accSagittalDoubleSharp19sDown: {
      x_min: 0,
      x_max: 438,
      y_min: -359,
      y_max: 172,
      ha: 531,
      o: 'm 0 -248 l 45 -248 l 45 -68 b 271 112 45 53 120 112 l 310 0 l 135 -503 l 186 -517 l 337 -82 l 488 -517 l 540 -503 l 366 0 l 367 4 b 428 -23 386 -13 405 -23 l 495 -23 b 585 -203 554 -23 585 -84 l 631 -203 b 517 68 631 -23 593 68 l 449 68 b 337 248 400 68 363 127 l 225 248 b 0 68 75 248 0 187 z',
    },
    accSagittalDoubleFlat19sUp: {
      x_min: 0,
      x_max: 438,
      y_min: -172,
      y_max: 359,
      ha: 531,
      o: 'm 0 248 l 45 248 l 45 68 b 271 -112 45 -53 120 -112 l 310 0 l 135 503 l 186 517 l 337 82 l 488 517 l 540 503 l 366 0 l 367 -4 b 428 23 386 13 405 23 l 495 23 b 585 203 554 23 585 84 l 631 203 b 517 -68 631 23 593 -68 l 449 -68 b 337 -248 400 -68 363 -127 l 225 -248 b 0 -68 75 -248 0 -187 z',
    },
    accSagittalShaftUp: {
      x_min: 0,
      x_max: 31,
      y_min: -359,
      y_max: 172,
      ha: 531,
      o: 'm 0 112 l 0 -517 l 45 -517 l 45 112 l 23 248 z',
    },
    accSagittalShaftDown: {
      x_min: 0,
      x_max: 31,
      y_min: -172,
      y_max: 359,
      ha: 531,
      o: 'm 0 -112 l 0 517 l 45 517 l 45 -112 l 23 -248 z',
    },
    accSagittalAcute: {
      x_min: 0,
      x_max: 125,
      y_min: -62,
      y_max: 125,
      ha: 187,
      o: 'm 0 0 l 0 -89 l 180 89 l 180 180 z',
    },
    accSagittalGrave: {
      x_min: 0,
      x_max: 125,
      y_min: -125,
      y_max: 62,
      ha: 187,
      o: 'm 0 0 l 0 89 l 180 -89 l 180 -180 z',
    },
    accSagittal1MinaUp: {
      x_min: -7,
      x_max: 124,
      y_min: 16,
      y_max: 106.32667068233003,
      ha: 90.32667068233003,
      o: 'm -10 23 l 43 23 b 72 65 43 23 65 55 b 135 23 104 108 136 148 l 179 23 b 134 150 179 112 163 135 b 68 130 116 158 85 150 b -10 23 43 101 13 58 z',
    },
    accSagittal1MinaDown: {
      x_min: -7,
      x_max: 124,
      y_min: -106.32667068233003,
      y_max: -16,
      ha: 90.32667068233003,
      o: 'm -10 -23 l 43 -23 b 72 -65 43 -23 65 -55 b 135 -23 104 -108 136 -148 l 179 -23 b 134 -150 179 -112 163 -135 b 68 -130 116 -158 85 -150 b -10 -23 43 -101 13 -58 z',
    },
    accSagittal2MinasUp: {
      x_min: -7,
      x_max: 218,
      y_min: 16,
      y_max: 106.32679473178912,
      ha: 90.32679473178912,
      o: 'm -10 23 l 43 23 b 72 65 43 23 65 55 b 135 23 104 108 136 148 l 179 23 b 207 65 179 23 200 55 b 271 23 240 108 272 148 l 314 23 b 269 150 314 112 299 135 b 203 130 252 158 220 150 b 173 93 191 115 182 104 b 134 150 167 127 153 140 b 68 130 116 158 85 150 b -10 23 43 101 13 58 z',
    },
    accSagittal2MinasDown: {
      x_min: -7,
      x_max: 218,
      y_min: -106.32679473178912,
      y_max: -16,
      ha: 90.32679473178912,
      o: 'm -10 -23 l 43 -23 b 72 -65 43 -23 65 -55 b 135 -23 104 -108 136 -148 l 179 -23 b 207 -65 179 -23 200 -55 b 271 -23 240 -108 272 -148 l 314 -23 b 269 -150 314 -112 299 -135 b 203 -130 252 -158 220 -150 b 173 -93 191 -115 182 -104 b 134 -150 167 -127 153 -140 b 68 -130 116 -158 85 -150 b -10 -23 43 -101 13 -58 z',
    },
    accSagittal1TinaUp: {
      x_min: 0,
      x_max: 93,
      y_min: 16,
      y_max: 107,
      ha: 91,
      o: 'm 134 154 l 91 154 b 81 76 91 101 90 86 b 0 68 73 69 48 68 l 0 23 b 112 45 50 23 92 27 b 134 154 129 59 134 73 z',
    },
    accSagittal1TinaDown: {
      x_min: 0,
      x_max: 93,
      y_min: -107,
      y_max: -16,
      ha: 91,
      o: 'm 134 -154 l 91 -154 b 81 -76 91 -101 90 -86 b 0 -68 73 -69 48 -68 l 0 -23 b 112 -45 50 -23 92 -27 b 134 -154 129 -59 134 -73 z',
    },
    accSagittal2TinasUp: {
      x_min: 0,
      x_max: 94,
      y_min: 16,
      y_max: 107,
      ha: 91,
      o: 'm 135 68 b 99 92 116 68 103 82 b 89 154 94 105 89 121 l 46 154 b 36 92 45 131 42 106 b 0 68 32 83 23 68 l 0 23 b 53 45 23 23 48 39 b 68 63 60 52 60 52 b 82 43 75 52 77 50 b 135 23 86 37 115 23 z',
    },
    accSagittal2TinasDown: {
      x_min: 0,
      x_max: 94,
      y_min: -107,
      y_max: -16,
      ha: 91,
      o: 'm 135 -68 b 99 -92 116 -68 103 -82 b 89 -154 94 -105 89 -121 l 46 -154 b 36 -92 45 -131 42 -106 b 0 -68 32 -83 23 -68 l 0 -23 b 53 -45 23 -23 48 -39 b 68 -63 60 -52 60 -52 b 82 -43 75 -52 77 -50 b 135 -23 86 -37 115 -23 z',
    },
    accSagittal3TinasUp: {
      x_min: -7,
      x_max: 124,
      y_min: 16,
      y_max: 106.32667068233003,
      ha: 90.32667068233003,
      o: 'm -10 23 l 43 23 b 72 65 43 23 65 55 b 135 23 104 108 136 148 l 179 23 b 134 150 179 112 163 135 b 68 130 116 158 85 150 b -10 23 43 101 13 58 z',
    },
    accSagittal3TinasDown: {
      x_min: -7,
      x_max: 124,
      y_min: -106.32667068233003,
      y_max: -16,
      ha: 90.32667068233003,
      o: 'm -10 -23 l 43 -23 b 72 -65 43 -23 65 -55 b 135 -23 104 -108 136 -148 l 179 -23 b 134 -150 179 -112 163 -135 b 68 -130 116 -158 85 -150 b -10 -23 43 -101 13 -58 z',
    },
    accSagittal4TinasUp: {
      x_min: 0,
      x_max: 187,
      y_min: 16,
      y_max: 106.77773196082337,
      ha: 90.77773196082337,
      o: 'm 0 68 l 0 23 b 143 45 105 23 123 26 b 226 23 158 62 228 189 l 269 23 b 225 150 269 112 254 135 b 160 132 207 159 182 153 b 115 81 139 112 123 88 b 0 68 104 71 94 68 z',
    },
    accSagittal4TinasDown: {
      x_min: 0,
      x_max: 187,
      y_min: -106.77773196082337,
      y_max: -16,
      ha: 90.77773196082337,
      o: 'm 0 -68 l 0 -23 b 143 -45 105 -23 123 -26 b 226 -23 158 -62 228 -189 l 269 -23 b 225 -150 269 -112 254 -135 b 160 -132 207 -159 182 -153 b 115 -81 139 -112 123 -88 b 0 -68 104 -71 94 -68 z',
    },
    accSagittal5TinasUp: {
      x_min: 0,
      x_max: 218,
      y_min: 16,
      y_max: 107,
      ha: 91,
      o: 'm 135 23 b 187 45 156 23 168 26 b 271 23 204 61 272 189 l 314 23 b 269 150 314 112 299 135 b 204 132 252 159 226 153 b 160 81 183 112 168 88 b 135 68 148 71 147 68 b 99 92 116 68 103 82 b 89 154 94 105 89 121 l 46 154 b 36 92 45 131 42 106 b 0 68 32 83 23 68 l 0 23 b 53 45 23 23 48 39 b 68 63 60 52 60 52 b 82 43 75 52 77 50 b 135 23 86 37 115 23 z',
    },
    accSagittal5TinasDown: {
      x_min: 0,
      x_max: 218,
      y_min: -107,
      y_max: -16,
      ha: 91,
      o: 'm 135 -23 b 187 -45 156 -23 168 -26 b 271 -23 204 -61 272 -189 l 314 -23 b 269 -150 314 -112 299 -135 b 204 -132 252 -159 226 -153 b 160 -81 183 -112 168 -88 b 135 -68 148 -71 147 -68 b 99 -92 116 -68 103 -82 b 89 -154 94 -105 89 -121 l 46 -154 b 36 -92 45 -131 42 -106 b 0 -68 32 -83 23 -68 l 0 -23 b 53 -45 23 -23 48 -39 b 68 -63 60 -52 60 -52 b 82 -43 75 -52 77 -50 b 135 -23 86 -37 115 -23 z',
    },
    accSagittal6TinasUp: {
      x_min: -7,
      x_max: 218,
      y_min: 16,
      y_max: 106.32679473178912,
      ha: 90.32679473178912,
      o: 'm -10 23 l 43 23 b 72 65 43 23 65 55 b 135 23 104 108 136 148 l 179 23 b 207 65 179 23 200 55 b 271 23 240 108 272 148 l 314 23 b 269 150 314 112 299 135 b 203 130 252 158 220 150 b 173 93 191 115 182 104 b 134 150 167 127 153 140 b 68 130 116 158 85 150 b -10 23 43 101 13 58 z',
    },
    accSagittal6TinasDown: {
      x_min: -7,
      x_max: 218,
      y_min: -106.32679473178912,
      y_max: -16,
      ha: 90.32679473178912,
      o: 'm -10 -23 l 43 -23 b 72 -65 43 -23 65 -55 b 135 -23 104 -108 136 -148 l 179 -23 b 207 -65 179 -23 200 -55 b 271 -23 240 -108 272 -148 l 314 -23 b 269 -150 314 -112 299 -135 b 203 -130 252 -158 220 -150 b 173 -93 191 -115 182 -104 b 134 -150 167 -127 153 -140 b 68 -130 116 -158 85 -150 b -10 -23 43 -101 13 -58 z',
    },
    accSagittal7TinasUp: {
      x_min: 0,
      x_max: 281,
      y_min: 16,
      y_max: 106.77773196082337,
      ha: 90.77773196082337,
      o: 'm 269 23 z m 0 68 l 0 23 b 143 45 105 23 123 26 b 226 23 158 62 228 189 l 269 23 b 298 65 269 23 291 55 b 361 23 330 108 362 148 l 405 23 b 360 150 405 112 389 135 b 294 130 342 158 311 150 b 264 93 281 115 273 104 b 225 150 257 127 244 140 b 160 132 207 159 182 153 b 115 81 139 112 123 88 b 0 68 104 71 94 68 z',
    },
    accSagittal7TinasDown: {
      x_min: 0,
      x_max: 281,
      y_min: -106.77773196082337,
      y_max: -16,
      ha: 90.77773196082337,
      o: 'm 0 -68 l 0 -23 b 143 -45 105 -23 123 -26 b 226 -23 158 -62 228 -189 l 269 -23 b 298 -65 269 -23 291 -55 b 361 -23 330 -108 362 -148 l 405 -23 b 360 -150 405 -112 389 -135 b 294 -130 342 -158 311 -150 b 264 -93 281 -115 273 -104 b 225 -150 257 -127 244 -140 b 160 -132 207 -159 182 -153 b 115 -81 139 -112 123 -88 b 0 -68 104 -71 94 -68 z',
    },
    accSagittal8TinasUp: {
      x_min: 0,
      x_max: 312,
      y_min: 16,
      y_max: 107,
      ha: 91,
      o: 'm 314 23 z m 135 23 b 187 45 156 23 168 26 b 271 23 204 61 272 189 l 314 23 b 343 65 314 23 335 55 b 406 23 375 108 407 148 l 449 23 b 405 150 449 112 434 135 b 338 130 387 158 356 150 b 309 93 326 115 317 104 b 269 150 302 127 289 140 b 204 132 252 159 226 153 b 160 81 183 112 168 88 b 135 68 148 71 147 68 b 99 92 116 68 103 82 b 89 154 94 105 89 121 l 46 154 b 36 92 45 131 42 106 b 0 68 32 83 23 68 l 0 23 b 53 45 23 23 48 39 b 68 63 60 52 60 52 b 82 43 75 52 77 50 b 135 23 86 37 115 23 z',
    },
    accSagittal8TinasDown: {
      x_min: 0,
      x_max: 312,
      y_min: -107,
      y_max: -16,
      ha: 91,
      o: 'm 135 -23 b 187 -45 156 -23 168 -26 b 271 -23 204 -61 272 -189 l 314 -23 b 343 -65 314 -23 335 -55 b 406 -23 375 -108 407 -148 l 449 -23 b 405 -150 449 -112 434 -135 b 338 -130 387 -158 356 -150 b 309 -93 326 -115 317 -104 b 269 -150 302 -127 289 -140 b 204 -132 252 -159 226 -153 b 160 -81 183 -112 168 -88 b 135 -68 148 -71 147 -68 b 99 -92 116 -68 103 -82 b 89 -154 94 -105 89 -121 l 46 -154 b 36 -92 45 -131 42 -106 b 0 -68 32 -83 23 -68 l 0 -23 b 53 -45 23 -23 48 -39 b 68 -63 60 -52 60 -52 b 82 -43 75 -52 77 -50 b 135 -23 86 -37 115 -23 z',
    },
    accSagittal9TinasUp: {
      x_min: -7,
      x_max: 312,
      y_min: 16,
      y_max: 106.32679473178912,
      ha: 90.32679473178912,
      o: 'm 314 23 z m -10 23 l 43 23 b 72 65 43 23 65 55 b 135 23 104 108 136 148 l 179 23 b 207 65 179 23 200 55 b 271 23 240 108 272 148 l 314 23 b 343 65 314 23 335 55 b 406 23 375 108 407 148 l 449 23 b 405 150 449 112 434 135 b 338 130 387 158 356 150 b 309 93 326 115 317 104 b 269 150 302 127 289 140 b 203 130 252 158 220 150 b 173 93 191 115 182 104 b 134 150 167 127 153 140 b 68 130 116 158 85 150 b -10 23 43 101 13 58 z',
    },
    accSagittal9TinasDown: {
      x_min: -7,
      x_max: 312,
      y_min: -106.32679473178912,
      y_max: -16,
      ha: 90.32679473178912,
      o: 'm -10 -23 l 43 -23 b 72 -65 43 -23 65 -55 b 135 -23 104 -108 136 -148 l 179 -23 b 207 -65 179 -23 200 -55 b 271 -23 240 -108 272 -148 l 314 -23 b 343 -65 314 -23 335 -55 b 406 -23 375 -108 407 -148 l 449 -23 b 405 -150 449 -112 434 -135 b 338 -130 387 -158 356 -150 b 309 -93 326 -115 317 -104 b 269 -150 302 -127 289 -140 b 203 -130 252 -158 220 -150 b 173 -93 191 -115 182 -104 b 134 -150 167 -127 153 -140 b 68 -130 116 -158 85 -150 b -10 -23 43 -101 13 -58 z',
    },
    accSagittalFractionalTinaUp: {
      x_min: -3,
      x_max: 35,
      y_min: 73,
      y_max: 111,
      ha: 38,
      o: 'm -4 132 b 23 105 -4 118 9 105 b 50 132 37 105 50 118 b 23 160 50 147 37 160 b -4 132 9 160 -4 147 z',
    },
    accSagittalFractionalTinaDown: {
      x_min: -3,
      x_max: 35,
      y_min: -111,
      y_max: -73,
      ha: 38,
      o: 'm -4 -132 b 23 -105 -4 -118 9 -105 b 50 -132 37 -105 50 -118 b 23 -160 50 -147 37 -160 b -4 -132 9 -160 -4 -147 z',
    },
    accidentalNarrowReversedFlat: {
      x_min: 0,
      x_max: 164,
      y_min: -194,
      y_max: 422,
      ha: 616,
      o: 'm 112 -157 l 236 -279 l 236 608 l 192 608 l 192 180 b 85 243 150 222 112 243 b 0 84 23 243 0 135 b 112 -157 0 3 37 -78 z m 82 40 b 138 144 82 73 96 144 b 192 112 153 144 170 132 l 192 -163 l 135 -98 b 82 40 101 -50 82 -3 z',
    },
    accidentalNarrowReversedFlatAndFlat: {
      x_min: 0,
      x_max: 414,
      y_min: -194,
      y_max: 422,
      ha: 616,
      o: 'm 438 -157 b 596 84 547 -82 596 3 b 475 243 596 154 556 243 b 325 180 435 243 383 222 l 325 608 l 281 608 l 281 -268 z m 0 84 b 112 -157 0 3 37 -78 l 235 -279 l 235 608 l 190 608 l 190 180 b 85 243 148 222 112 243 b 12 157 52 243 27 215 b 0 84 3 135 0 108 z m 325 112 b 410 144 360 132 386 144 b 498 36 462 144 498 84 b 413 -107 498 -9 469 -58 l 325 -173 z m 89 94 b 135 144 102 127 118 144 b 192 112 153 144 170 132 l 192 -163 l 135 -98 b 81 40 99 -50 81 -3 b 89 94 81 59 84 76 z',
    },
    accidentalWilsonPlus: {
      x_min: 0,
      x_max: 281,
      y_min: -203,
      y_max: 203,
      ha: 406,
      o: 'm 180 -98 l 180 -292 l 225 -292 l 225 -56 l 405 112 l 405 268 l 225 98 l 225 292 l 180 292 l 180 56 l 0 -112 l 0 -268 z',
    },
    accidentalWilsonMinus: {
      x_min: 0,
      x_max: 281,
      y_min: -186,
      y_max: 186,
      ha: 372,
      o: 'm 0 112 l 405 -268 l 405 -112 l 0 268 z',
    },
  },
  fontFamily: 'Bravura',
  resolution: 1000,
  generatedOn: '2020-11-16T21:00:32.731Z',
};
